import React, { useState, useEffect, useCallback } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Button,
  Badge,
  Form,
  Card,
  Modal,
} from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { FaSave } from "react-icons/fa";
import { MdCancel } from "react-icons/md";
import { toast } from "react-toastify";
import moment from "moment";
import { fetchProjectDetails, updateProject } from "../Api/ViewProjects";
import {
  fetchProjectRemarks,
  addProjectRemark,
  updateProjectRemark,
} from "../Api/ViewProjects";
import "./ProjectView.css";
import {
  getTasksByProject,
  updateTask,
  getAllTaskStatus,
  getAllTaskTypes,
  getContactGuid, // Add this import
} from "../Api/TaskMaster";
import {
  startTaskWork,
  stopTaskWork,
  getTaskAssignmentsByTaskId,
  pauseTaskWork,
  createTaskWorkLog,
  getTaskLogsByTaskId,
  getTaskListByAssignedUser,
  softDeleteTask,
  restoreTask,
  toggleCurrentAssignment,
} from "../Api/TaskMaster";
import TaskEditModal from "./TaskEditModal";
import TaskViewSidebar from "./TaskViewSidebar";
import { getTeamsByOrg, getTeamById } from "../Api/TeamMaster";
import { getUsersByIds } from "../Api/Auth";
import TaskBatchCreator from "../Pages/ProjectComponents/TaskBatchCreator";
import {
  getTicketsByProjectId,
  getContactNames,
  getTicketMetaNames,
} from "../Api/TicketApiOrg";
import {
  getTicketByTicketId,
  addTicketWorkLog,
  getTicketLogsByTicketId,
} from "../Api/TicketApiOrg";
import { FaArrowCircleLeft } from "react-icons/fa";
import { fetchCusVenCpByCusVenType } from "../Api/CusVenCpMasterApi";
import {
  getAssignmentsByTicketId,
  startWork,
  stopWork,
} from "../Api/TicketApiOrg";
import { resolveNames, getTicketDropdownData } from "../Api/TicketApiOrg";
import { getAllTicketStatuses } from "../Api/TicketApiOrg";
import TaskTemplateModal from "./TaskTemplateModal";
import SprintTab from "./ProjectComponents/SprintTab";
import { getTemplatesByOrg, deleteTaskTemplate } from "../Api/TaskTemplate";
import {
  getPartnersByOrg,
  createPartner,
  updatePartner,
  getPartnersByProject,
} from "../Api/PartnerMaster";
import PartnerModal from "./PartnerModal";
import TicketEditModal from "./TicketEditModal";
import { getVendorById } from "../Api/MerchantMaster";
import CommercialModal from "./CommercialModal";
import ResourceModal from "./ResourceModal";
import {
  deleteResource,
  fetchResourcesByProject,
} from "../Api/projectResourceService";
import {
  fetchResourceById,
  fetchProjectTypes,
  fetchProjectTypeById,
  fetchCustomersByOrgId,
  fetchResourceByOrgId,
} from "../Api/InvoiceApi";
import {
  uploadMultipleProjectDocuments,
  getDocumentsByProject,
  deleteDocumentWithFile,
  downloadDocument,
  validateFile,
  handleFileDownload,
  updateProjectFavourite,
} from "../Api/ProjectMaster";
import { getAllProjectStatus } from "../Api/ProjectStatusApi";
import MilestoneModal from "./MilestoneModal";
import {
  getAllMilestones,
  getMilestonesByProjectAndOrg,
  createMilestone,
  updateMilestone,
} from "../Api/MilestoneMaster";
import StageModal from "./StageModal";
import {
  fetchStagesByProject,
  createStage,
  updateStage,
} from "../Api/StageMaster";
import {
  getTasksByProjectAndStage,
  createTasksFromExcel,
} from "../Api/TaskMaster";
import { ticketDropdownApi } from "../Api/TicketApiOrg";
import { fetchEventByCode } from "../Api/ViewEvent";

import {
  getBuildingBlocksByOrg,
  createBuildingBlock,
  getTasksByBuildingBlock,
  getBuildingBlocksByOrgAndProject,
  mapTaskToBuildingBlock,
  getBlockSummary,
  updateBuildingBlock, // 👈 ADD THIS
  getTicketsByBuildingBlock,
  mapTicketToBuildingBlock,
  removeTicketMapping,
  removeSpecificTaskMapping,
} from "../Api/BuildingBlockMaster";

import {
  getProjectTypes,
  getProjectStatus,
  getProjectSubStatus,
  getProjectMetaNames,
} from "../Api/ProjectMaster";

import {
  fetchCusVenCpById,
  fetchCusVenCpByOrgId,
} from "../Api/CusVenCpMasterApi";

import ProjectEvents from "./ProjectEvents";

import { getCommercialsByProject } from "../Api/CommercialMaster";
import { CiHeart } from "react-icons/ci";
import { FaHeart } from "react-icons/fa";
import * as XLSX from "xlsx";
import { MdAddChart } from "react-icons/md";
import { TfiViewListAlt } from "react-icons/tfi";
import { FaEdit } from "react-icons/fa";
import { Gantt, ViewMode } from "gantt-task-react";
import "gantt-task-react/dist/index.css";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { saveAs } from "file-saver";
import ProjectHeader from "./ProjectComponents/ProjectHeader";
import ProjectOverviewTab from "./ProjectComponents/ProjectOverviewTab";
import ProjectBoardTab from "./ProjectComponents/ProjectBoardTab";
import ProjectGanttTab from "./ProjectComponents/ProjectGanttTab";
import ProjectRemarksTab from "./ProjectComponents/ProjectRemarksTab";
import ProjectTasksTab from "./ProjectComponents/ProjectTasksTab";
import ProjectBuildingBlockTab from "./ProjectComponents/ProjectBuildingBlockTab";
import ProjectTeamTab from "./ProjectComponents/ProjectTeamTab";
import ProjectTicketTab from "./ProjectComponents/ProjectTicketTab";
import ProjectResourceAllocationTab from "./ProjectComponents/ProjectResourceAllocationTab";
import ProjectCommercialsTab from "./ProjectComponents/ProjectCommercialsTab";
import ProjectWorkflowTab from "./ProjectComponents/ProjectWorkflowTab";
import ProjectPartnerTab from "./ProjectComponents/ProjectPartnerTab";
import ProjectMilestoneTab from "./ProjectComponents/ProjectMilestoneTab";
import ProjectDocumentsTab from "./ProjectComponents/ProjectDocumentsTab";

const ProjectView = () => {
  // =========================================================================
  // STATE DECLARATIONS
  // =========================================================================

  // User and Project State
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userRoles = userDetails?.roles || [];
  console.log(userRoles);
  const userId = userDetails?.userId;
  const orgId = userDetails?.organisationId;
  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  // Define role constants
  const PROJECT_ADMIN_ROLE = "Project_admin";
  const PROJECT_MANAGER_ROLE = "Project_Manager";
  const PROJECT_COMMERCIAL_ROLE = "Project_Commercial";

  // Role checking functions
  const hasProjectAdminRole = () => {
    return userRoles.includes(PROJECT_ADMIN_ROLE);
  };

  const hasProjectManagerRole = () => {
    return userRoles.includes(PROJECT_MANAGER_ROLE);
  };

  const hasProjectCommercialRole = () => {
    return userRoles.includes(PROJECT_COMMERCIAL_ROLE);
  };

  const hasEditPermission = () => {
    // Project Admin and Project Manager can edit
    return hasProjectAdminRole() || hasProjectManagerRole();
  };

  const hasViewPermission = () => {
    // All three roles can view all tasks
    return (
      hasProjectAdminRole() ||
      hasProjectManagerRole() ||
      hasProjectCommercialRole()
    );
  };

  // UI State
  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [saving, setSaving] = useState(false);
  const [showTaskSidebar, setShowTaskSidebar] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedTaskId, setSelectedTaskId] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [expandedMilestones, setExpandedMilestones] = useState({});

  // Project Data State
  const [project, setProject] = useState(null);
  const [originalProject, setOriginalProject] = useState(null);
  const [projectStatuses, setProjectStatuses] = useState([]);
  const [projectStatusesLoading, setProjectStatusesLoading] = useState(false);
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectTypeLoading, setProjectTypeLoading] = useState(false);
  const [projectTypeDesc, setProjectTypeDesc] = useState("");
  const [customers, setCustomers] = useState([]);
  const [customersLoading, setCustomersLoading] = useState(false);
  const [selectedCustomerName, setSelectedCustomerName] = useState("");

  const [showBatchCreator, setShowBatchCreator] = useState(false);

  // Project Type, Status, Sub-Status State (for cascading dropdowns)
  const [projectTypesList, setProjectTypesList] = useState([]);
  const [projectStatusesList, setProjectStatusesList] = useState([]);
  const [projectSubStatusesList, setProjectSubStatusesList] = useState([]);
  const [loadingProjectTypes, setLoadingProjectTypes] = useState(false);
  const [loadingProjectStatuses, setLoadingProjectStatuses] = useState(false);
  const [loadingProjectSubStatuses, setLoadingProjectSubStatuses] =
    useState(false);

  // Meta names for displaying GUIDs as names
  const [projectMetaNames, setProjectMetaNames] = useState({
    types: {},
    statuses: {},
    subStatuses: {},
  });

  // Team and Resource State
  const [teams, setTeams] = useState([]);
  const [selectedTeamId, setSelectedTeamId] = useState("");
  const [teamData, setTeamData] = useState(null);
  const [teamMemberDetails, setTeamMemberDetails] = useState([]);
  const [loadingTeamMembers, setLoadingTeamMembers] = useState(false);
  const [resourcesByOrg, setResourcesByOrg] = useState([]);
  const [resourcesByOrgLoading, setResourcesByOrgLoading] = useState(false);
  const [projectManagerName, setProjectManagerName] = useState("");
  const [salespersonName, setSalespersonName] = useState("");
  const [loadingManager, setLoadingManager] = useState(false);
  const [loadingSalesperson, setLoadingSalesperson] = useState(false);

  // Task State
  const [tasks, setTasks] = useState([]);
  const [tasksLoading, setTasksLoading] = useState(false);
  const [taskAssignedUsers, setTaskAssignedUsers] = useState({});
  // Task Assignment Dialog State
  const [showTaskDialog, setShowTaskDialog] = useState(false);
  const [taskForDialog, setTaskForDialog] = useState(null);
  const [taskAssignments, setTaskAssignments] = useState([]);
  const [taskAssignLoading, setTaskAssignLoading] = useState(false);
  const [assignTaskUserId, setAssignTaskUserId] = useState("");
  const [taskAssignmentsByTask, setTaskAssignmentsByTask] = useState({}); // { [taskId]: [assignments] }
  // Add this with other state declarations
  const [projectAssigneeOptions, setProjectAssigneeOptions] = useState([]);
  const [loadingProjectAssignees, setLoadingProjectAssignees] = useState(false);
  // Add this with other state declarations
  const [userContactGuid, setUserContactGuid] = useState(null);
  const [loadingUserContactGuid, setLoadingUserContactGuid] = useState(false);

  // Task Type State
  const [taskTypes, setTaskTypes] = useState([]);
  const [taskTypesLoading, setTaskTypesLoading] = useState(false);
  const [taskTypeMap, setTaskTypeMap] = useState({});

  const [showTaskEditModal, setShowTaskEditModal] = useState(false);
  const [editingTaskId, setEditingTaskId] = useState(null);

  const [collapsedStages, setCollapsedStages] = useState({});

  // Add this near other state declarations
  const [taskStatusMap, setTaskStatusMap] = useState({});
  const [taskStatusesLoading, setTaskStatusesLoading] = useState(false);

  const toggleStage = (stageId) => {
    setCollapsedStages((prev) => ({
      ...prev,
      [stageId]: !prev[stageId],
    }));
  };

  // Add near other state declarations
  const [taskBuildingBlocks, setTaskBuildingBlocks] = useState({}); // { [taskId]: { buildingBlockId, buildingBlockName } }
  const [taskBuildingBlocksLoading, setTaskBuildingBlocksLoading] =
    useState(false);

  // Add these with other state declarations
  const [clientContactPersons, setClientContactPersons] = useState([]);
  const [partnerContactPersons, setPartnerContactPersons] = useState([]);
  const [loadingContacts, setLoadingContacts] = useState(false);
  const [clientId, setClientId] = useState(null);
  const [projectPartners, setProjectPartners] = useState([]);

  // Board Tab State
  const [boardGroupBy, setBoardGroupBy] = useState("status");

  // Add near other state declarations
  const [showTaskOptions, setShowTaskOptions] = useState(false);
  const [showExcelUploadModal, setShowExcelUploadModal] = useState(false);
  const [excelFile, setExcelFile] = useState(null);
  const [uploadingExcel, setUploadingExcel] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [filteredStageTasks, setFilteredStageTasks] = useState({});

  const [ganttTasks, setGanttTasks] = useState([]);
  const [viewMode, setViewMode] = useState(ViewMode.Week);

  // Gantt Controls
  const [columnWidth, setColumnWidth] = useState(65);
  const [timePeriod, setTimePeriod] = useState("Day");
  const [ganttLoading, setGanttLoading] = useState(false);

  const scrollToToday = () => {
    const today = new Date();
    const ganttElement = document.querySelector(".gantt-container");

    if (!ganttElement) return;

    // Calculate approximate scroll position
    const daysFromStart =
      (today - finalGanttTasks[0]?.start) / (1000 * 60 * 60 * 24);

    ganttElement.scrollLeft = daysFromStart * columnWidth;
  };

  // 🔍 Gantt Sorting & Filtering
  const [sortBy, setSortBy] = useState("startDate");
  const [showFilterPanel, setShowFilterPanel] = useState(false);

  const [filterStatus, setFilterStatus] = useState([]);
  const [filterPriority, setFilterPriority] = useState([]);
  const [filterAssignee, setFilterAssignee] = useState([]);
  const [filterStage, setFilterStage] = useState([]);

  const [showClosed, setShowClosed] = useState(false);

  // Manual work log states
  const [workLogUserId, setWorkLogUserId] = useState("");
  const [workValue, setWorkValue] = useState("");
  const [workUnit, setWorkUnit] = useState("HOUR");
  const [savingWorkLog, setSavingWorkLog] = useState(false);

  // ================= PROJECT REMARKS =================
  const [remarks, setRemarks] = useState([]);
  const [remarkText, setRemarkText] = useState("");
  const [remarksLoading, setRemarksLoading] = useState(false);
  const [addingRemark, setAddingRemark] = useState(false);

  // Add these state declarations with your other state variables
  const [editingRemarkId, setEditingRemarkId] = useState(null);
  const [editingRemarkText, setEditingRemarkText] = useState("");
  const [updatingRemark, setUpdatingRemark] = useState(false);

  // Task Logs (manual + updates)
  const [taskLogs, setTaskLogs] = useState([]);
  const [taskLogsLoading, setTaskLogsLoading] = useState(false);

  // Stage State
  const [stages, setStages] = useState([]);
  const [stagesLoading, setStagesLoading] = useState(false);
  // const [showStageModal, setShowStageModal] = useState(false);
  const [editingStage, setEditingStage] = useState(null);
  const [stageTasks, setStageTasks] = useState({});
  const [tasksLoadingByStage, setTasksLoadingByStage] = useState({});

  const [showStageModal, setShowStageModal] = useState(false);
  const [selectedStage, setSelectedStage] = useState(null);

  // Ticket State
  const [tickets, setTickets] = useState([]);
  const [ticketsLoading, setTicketsLoading] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [priorityFilter, setPriorityFilter] = useState("");

  // Add these near your other state declarations (around line 200-300)
  const [contactNamesCache, setContactNamesCache] = useState({});
  const [resolvedTicketNames, setResolvedTicketNames] = useState({
    types: {},
    reasons: {},
    categories: {},
  });

  // Add these near your other state declarations
  const [resolvedNames, setResolvedNames] = useState({
    types: {},
    reasons: {},
    categories: {},
  });

  const [statusMasterData, setStatusMasterData] = useState({
    statusMap: {}, // Map of StatusGuid -> StatusName
    subStatusMap: {}, // Map of SubStatusGuid -> SubStatusName
    allStatuses: [], // Full status hierarchy
  });

  const [dropdownData, setDropdownData] = useState([]);

  // Ticket quick dialog + assignments
  const [showTicketDialog, setShowTicketDialog] = useState(false);
  const [ticketForDialog, setTicketForDialog] = useState(null);
  const [assignmentsByTicket, setAssignmentsByTicket] = useState({}); // { [ticketId]: [...] }
  const [assignmentsLoading, setAssignmentsLoading] = useState(false);
  const [assignLoading, setAssignLoading] = useState(false);
  const [assignUserId, setAssignUserId] = useState(""); // selected team member userId
  const [ticketNameMap, setTicketNameMap] = useState({});

  // Ticket work log states
  const [ticketWorkUserId, setTicketWorkUserId] = useState("");
  const [ticketWorkValue, setTicketWorkValue] = useState("");
  const [ticketWorkUnit, setTicketWorkUnit] = useState("HOURS");
  const [savingTicketWorkLog, setSavingTicketWorkLog] = useState(false);

  // Ticket logs
  const [ticketLogs, setTicketLogs] = useState([]);
  const [ticketLogsLoading, setTicketLogsLoading] = useState(false);

  // Add these near your other state declarations
  const [showTicketEditModal, setShowTicketEditModal] = useState(false);
  const [selectedTicketForEdit, setSelectedTicketForEdit] = useState(null);

  // Template State
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [showTemplateModal, setShowTemplateModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [cusVenCpCache, setCusVenCpCache] = useState({});

  const [eventNameMap, setEventNameMap] = useState({});

  // Partner State
  const [partners, setPartners] = useState([]);
  const [partnersLoading, setPartnersLoading] = useState(false);
  const [showPartnerModal, setShowPartnerModal] = useState(false);
  const [editingPartner, setEditingPartner] = useState(null);
  const [vendorMap, setVendorMap] = useState({});
  // { SUP0000003: [ {contactPerName, contactPerEmail...} ] }
  const [vendorContactsMap, setVendorContactsMap] = useState({});
  const [loadingVendorContacts, setLoadingVendorContacts] = useState({});

  // Commercial State
  const [commercials, setCommercials] = useState([]);
  const [commercialsLoading, setCommercialsLoading] = useState(false);
  const [showCommercialModal, setShowCommercialModal] = useState(false);
  const [editingCommercial, setEditingCommercial] = useState(null);

  // Milestone State
  const [milestones, setMilestones] = useState([]);
  const [milestonesLoading, setMilestonesLoading] = useState(false);
  const [showMilestoneModal, setShowMilestoneModal] = useState(false);
  const [editingMilestone, setEditingMilestone] = useState(null);
  const [milestoneTasks, setMilestoneTasks] = useState({});

  // Resource Allocation State
  const [resources, setResources] = useState([]);
  const [resourcesLoading, setResourcesLoading] = useState(false);
  const [showResourceModal, setShowResourceModal] = useState(false);
  const [editingResource, setEditingResource] = useState(null);
  const [resourceDetails, setResourceDetails] = useState({});
  const [loadingResourceDetails, setLoadingResourceDetails] = useState({});

  // Document State
  const [documents, setDocuments] = useState([]);
  const [documentsLoading, setDocumentsLoading] = useState(false);
  const [uploadingDocuments, setUploadingDocuments] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [documentTitle, setDocumentTitle] = useState("");
  const [documentType, setDocumentType] = useState("");

  // Building Block State
  const [buildingBlocks, setBuildingBlocks] = useState([]);
  const [blocksLoading, setBlocksLoading] = useState(false);
  const [showBlockModal, setShowBlockModal] = useState(false);
  const [showTaskMapModal, setShowTaskMapModal] = useState(false);
  const [selectedBlock, setSelectedBlock] = useState(null);
  const [projectTasksForMapping, setProjectTasksForMapping] = useState([]);
  const [selectedTaskIds, setSelectedTaskIds] = useState([]);
  const [mappingLoading, setMappingLoading] = useState(false);
  const [blockSummaries, setBlockSummaries] = useState({});
  const [showBlockTasksModal, setShowBlockTasksModal] = useState(false);
  const [blockTasks, setBlockTasks] = useState([]);
  const [isEditingBlock, setIsEditingBlock] = useState(false);
  const [editingBlockId, setEditingBlockId] = useState(null);
  const [blockViewType, setBlockViewType] = useState("TASK");
  const [summaryLoading, setSummaryLoading] = useState(false);

  const [allBlocks, setAllBlocks] = useState([]);
  const [ticketBlocks, setTicketBlocks] = useState([]);
  const [selectedBlockId, setSelectedBlockId] = useState("");
  const [blockMappingLoading, setBlockMappingLoading] = useState(false);

  const today = new Date();

  const styledTasks = ganttTasks.map((task) => {
    if (task.type !== "project" && task.end < today && task.progress < 100) {
      return {
        ...task,
        styles: {
          progressColor: "#ff4d4f",
          progressSelectedColor: "#ff4d4f",
        },
      };
    }
    return task;
  });

  // const handleTaskChange = async (task) => {
  //   try {
  //     await updateTask(task.id, {
  //       taskStartDate: task.start,
  //       taskEndDate: task.end,
  //     });

  //     toast.success("Task updated");
  //   } catch (error) {
  //     toast.error("Failed to update task");
  //   }
  // };

  const formatDateOnly = (date) => {
    if (!date) return null;
    return new Date(date).toISOString().split("T")[0];
  };

  const handleTaskChange = async (task) => {
    try {
      await updateTask(task.id, {
        TaskStartDate: moment(task.start).format("YYYY-MM-DD"),
        TaskEndDate: moment(task.end).format("YYYY-MM-DD"),
        EditedBy: String(userDetails?.userId),
      });

      toast.success("Task updated");
    } catch (error) {
      console.error(error);
      toast.error("Failed to update task");
    }
  };

  const [blockForm, setBlockForm] = useState({
    orgId: "",
    buildingBlockName: "",
    buildingBlockStatus: "Not Started",
    buildingBlockDescription: "",
    buildingBlockProcessPoc: "",
    buildingBlockTechPoc: "",
    buildingBlockTypes: "",
    actualStartDate: "",
    actualEndDate: "",
  });

  // Available task fields configuration
  const availableFields = [
    {
      field: "taskName",
      displayName: "Task Name",
      type: "text",
      required: true,
    },
    {
      field: "taskDescription",
      displayName: "Task Description",
      type: "textarea",
      required: false,
    },
    {
      field: "assignedTo",
      displayName: "Assigned To",
      type: "select",
      required: false,
    },
    {
      field: "taskStartDate",
      displayName: "Planned Start Date",
      type: "date",
      required: false,
    },
    {
      field: "taskEndDate",
      displayName: "Planned End Date",
      type: "date",
      required: false,
    },
    {
      field: "actualStartDate",
      displayName: "Actual Start Date",
      type: "date",
      required: false,
    },
    {
      field: "actualEndDate",
      displayName: "Actual End Date",
      type: "date",
      required: false,
    },
    {
      field: "taskType",
      displayName: "Task Type",
      type: "select",
      required: false,
    },
    {
      field: "taskPriority",
      displayName: "Priority",
      type: "select",
      required: false,
    },
    {
      field: "taskStatus",
      displayName: "Status",
      type: "select",
      required: false,
    },
  ];

  // =========================================================================
  // GENERAL PROJECT DATA FUNCTIONS
  // =========================================================================

  // Load main project details
  const loadProjectDetails = async () => {
    try {
      const data = await fetchProjectDetails(projectId);
      console.log("Fetched project details:", data);
      setProject(data);
      setOriginalProject(data);
    } catch (error) {
      toast.error("Error loading project details");
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  // In the handleFieldChange function, check permissions
  const handleFieldChange = (field, value) => {
    if (!hasEditPermission()) {
      toast.error("You don't have permission to edit this project");
      return;
    }

    if (!isEditing) {
      setIsEditing(true);
    }
    setProject((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const loadTicketLogs = async (ticketId) => {
    if (!ticketId) return;

    try {
      setTicketLogsLoading(true);
      const logs = await getTicketLogsByTicketId(ticketId);

      // Sort latest first
      const sorted = [...logs].sort(
        (a, b) =>
          new Date(b.createdDate + " " + b.createdTime) -
          new Date(a.createdDate + " " + a.createdTime),
      );

      setTicketLogs(sorted);
    } catch (err) {
      console.error("Failed to load ticket logs", err);
      setTicketLogs([]);
    } finally {
      setTicketLogsLoading(false);
    }
  };

  // Save project changes
  const handleSave = async () => {
    if (!hasEditPermission()) {
      toast.error("You don't have permission to edit this project");
      return;
    }
    if (!project) return;

    setSaving(true);
    try {
      const updateData = {
        prTitle: project.prTitle,
        prDescription: project.prDescription,
        prTags: project.prTags,
        prStartDate: project.prStartDate,
        prEndDate: project.prEndDate,
        prClient: project.prClient,
        prTypes: project.prTypes,
        teamAssigned: project.teamId,
        projectStatus: project.projectStatus,
        projectSubStatus: project.projectSubStatus,
        projectCategory: project.projectCategory,
        comments: project.comments,
        salespersonCode: project.salespersonCode,
        currentProjectManager: project.currentProjectManager,
        usersId: project.usersId,
        revenue: project.revenue,
      };

      await updateProject(project.projectId, updateData);
      setOriginalProject(project);
      setIsEditing(false);
      toast.success("Project updated successfully");

      // Refresh the manager and salesperson names after update
      if (project.currentProjectManager) {
        fetchProjectManagerName(project.currentProjectManager);
      }
      if (project.salespersonCode) {
        fetchSalespersonName(project.salespersonCode);
      }
    } catch (error) {
      console.error("Error updating project:", error);
      toast.error("Failed to update project");
    } finally {
      setSaving(false);
    }
  };

  // Cancel editing
  // const handleCancel = () => {
  //   setProject(originalProject);
  //   setIsEditing(false);
  // };

  // Cancel editing
  const handleCancel = () => {
    if (!hasEditPermission()) return;

    setProject(originalProject);
    setIsEditing(false);
  };

  // Toggle favorite status
  const handleToggleFavorite = async () => {
    if (!project || !userId) return;

    const newFavoriteStatus = !project.isFavourite;

    try {
      // Optimistically update UI
      setProject((prev) => ({
        ...prev,
        isFavourite: newFavoriteStatus,
      }));

      // Call API
      await updateProjectFavourite(
        project.projectId,
        newFavoriteStatus,
        userId,
      );

      // Update original project state
      setOriginalProject((prev) => ({
        ...prev,
        isFavourite: newFavoriteStatus,
      }));

      toast.success(
        newFavoriteStatus
          ? "Project added to favorites!"
          : "Project removed from favorites!",
      );
    } catch (error) {
      // Revert on error
      setProject((prev) => ({
        ...prev,
        isFavourite: !newFavoriteStatus,
      }));

      console.error("Error updating favorite status:", error);
      toast.error("Failed to update favorite status");
    }
  };

  // =========================================================================
  // OVERVIEW TAB FUNCTIONS
  // =========================================================================

  // Load project statuses
  const loadProjectStatuses = async () => {
    setProjectStatusesLoading(true);
    try {
      const statusesData = await getAllProjectStatus();
      console.log("Loaded project statuses:", statusesData);
      setProjectStatuses(statusesData || []);
    } catch (error) {
      console.error("Error loading project statuses:", error);
      toast.error("Failed to load project statuses");
      setProjectStatuses([]);
    } finally {
      setProjectStatusesLoading(false);
    }
  };

  // Fetch project types list
  const fetchProjectTypesListNew = async () => {
    if (!orgId) return;

    setLoadingProjectTypes(true);
    try {
      const types = await getProjectTypes();
      console.log("Loaded project types:", types);
      setProjectTypesList(types || []);
    } catch (error) {
      console.error("Error fetching project types:", error);
      toast.error("Failed to load project types");
      setProjectTypesList([]);
    } finally {
      setLoadingProjectTypes(false);
    }
  };

  // Fetch project statuses based on selected project type
  const fetchProjectStatusesList = async (projectTypeGuid) => {
    if (!projectTypeGuid) {
      setProjectStatusesList([]);
      return;
    }

    setLoadingProjectStatuses(true);
    try {
      const statuses = await getProjectStatus(projectTypeGuid);
      console.log("Loaded project statuses:", statuses);
      setProjectStatusesList(statuses || []);
    } catch (error) {
      console.error("Error fetching project statuses:", error);
      toast.error("Failed to load project statuses");
      setProjectStatusesList([]);
    } finally {
      setLoadingProjectStatuses(false);
    }
  };

  // Fetch project sub-statuses based on project type and status
  const fetchProjectSubStatusesList = async (
    projectTypeGuid,
    projectStatusGuid,
  ) => {
    if (!projectTypeGuid || !projectStatusGuid) {
      setProjectSubStatusesList([]);
      return;
    }

    setLoadingProjectSubStatuses(true);
    try {
      const subStatuses = await getProjectSubStatus(
        projectTypeGuid,
        projectStatusGuid,
      );
      console.log("Loaded project sub-statuses:", subStatuses);
      setProjectSubStatusesList(subStatuses || []);
    } catch (error) {
      console.error("Error fetching project sub-statuses:", error);
      toast.error("Failed to load project sub-statuses");
      setProjectSubStatusesList([]);
    } finally {
      setLoadingProjectSubStatuses(false);
    }
  };

  // Fetch meta names for display
  // Fetch meta names for display
  const fetchProjectMetaNames = async (
    typeGuids,
    statusGuids,
    subStatusGuids,
  ) => {
    try {
      console.log("Fetching meta names for:", {
        typeGuids,
        statusGuids,
        subStatusGuids,
      });
      const metaNames = await getProjectMetaNames(
        typeGuids,
        statusGuids,
        subStatusGuids,
      );
      console.log("Loaded project meta names:", metaNames);

      const typesMap = { ...projectMetaNames.types };
      const statusesMap = { ...projectMetaNames.statuses };
      const subStatusesMap = { ...projectMetaNames.subStatuses };

      if (metaNames && Array.isArray(metaNames)) {
        metaNames.forEach((item) => {
          if (item.entity === "TYPE") {
            typesMap[item.guid] = item.name;
          } else if (item.entity === "STATUS") {
            statusesMap[item.guid] = item.name;
          } else if (item.entity === "SUBSTATUS") {
            subStatusesMap[item.guid] = item.name;
          }
        });
      }

      setProjectMetaNames({
        types: typesMap,
        statuses: statusesMap,
        subStatuses: subStatusesMap,
      });
    } catch (error) {
      console.error("Error fetching project meta names:", error);
    }
  };

  // Handle project type change with cascading reset
  const handleProjectTypeChangeForStatus = async (projectTypeGuid) => {
    handleFieldChange("prTypes", projectTypeGuid);

    // Reset status and sub-status when project type changes
    handleFieldChange("projectStatus", "");
    handleFieldChange("projectSubStatus", "");

    setProjectStatusesList([]);
    setProjectSubStatusesList([]);

    if (projectTypeGuid) {
      await fetchProjectStatusesList(projectTypeGuid);
    }
  };

  // Handle project status change with cascading reset
  const handleProjectStatusChangeForSubStatus = async (projectStatusGuid) => {
    handleFieldChange("projectStatus", projectStatusGuid);

    // Reset sub-status when status changes
    handleFieldChange("projectSubStatus", "");
    setProjectSubStatusesList([]);

    if (project.prTypes && projectStatusGuid) {
      await fetchProjectSubStatusesList(project.prTypes, projectStatusGuid);
    }
  };

  // Handle project sub-status change
  const handleProjectSubStatusChange = (projectSubStatusGuid) => {
    handleFieldChange("projectSubStatus", projectSubStatusGuid);
  };

  // Helper function to get display name for status GUID
  // const getProjectStatusDisplayName = (statusGuid) => {
  //   if (!statusGuid) return "Not set";
  //   return projectMetaNames.statuses[statusGuid] || statusGuid;
  // };

  // Helper function to get display name for sub-status GUID
  // const getProjectSubStatusDisplayName = (subStatusGuid) => {
  //   if (!subStatusGuid) return "Not set";
  //   return projectMetaNames.subStatuses[subStatusGuid] || subStatusGuid;
  // };

  // Helper function to get display name for type GUID
  const getProjectTypeDisplayName = (typeGuid) => {
    if (!typeGuid) return "Not selected";
    const name = projectMetaNames.types[typeGuid];
    if (name) return name;
    // If not found, return a truncated version or loading state
    return typeGuid.substring(0, 8) + "...";
  };

  // Helper function to get display name for status GUID
  const getProjectStatusDisplayName = (statusGuid) => {
    if (!statusGuid) return "Not set";
    const name = projectMetaNames.statuses[statusGuid];
    if (name) return name;
    // If not found, return a truncated version or loading state
    return statusGuid.substring(0, 8) + "...";
  };

  // Helper function to get display name for sub-status GUID
  const getProjectSubStatusDisplayName = (subStatusGuid) => {
    if (!subStatusGuid) return "Not set";
    const name = projectMetaNames.subStatuses[subStatusGuid];
    if (name) return name;
    // If not found, return a truncated version or loading state
    return subStatusGuid.substring(0, 8) + "...";
  };

  // Load project remarks
  const loadProjectRemarks = async () => {
    if (!projectId) return;

    try {
      setRemarksLoading(true);
      const data = await fetchProjectRemarks(projectId);
      console.log(data);
      setRemarks(Array.isArray(data) ? data : data?.data || []);
    } catch (error) {
      console.error("Error loading remarks:", error);
      toast.error("Failed to load remarks");
    } finally {
      setRemarksLoading(false);
    }
  };

  // Add new remark
  const handleAddRemark = async () => {
    if (!remarkText.trim()) {
      toast.error("Please enter a remark");
      return;
    }

    try {
      setAddingRemark(true);

      await addProjectRemark({
        projectId: projectId,
        remarks: remarkText,
        userId: String(userId),
      });

      toast.success("Remark added");

      setRemarkText("");
      loadProjectRemarks();
    } catch (error) {
      console.error(error);
      toast.error("Failed to add remark");
    } finally {
      setAddingRemark(false);
    }
  };

  // Load customers
  const loadCustomers = async () => {
    if (!orgId) return;

    setCustomersLoading(true);
    try {
      const customersData = await fetchCustomersByOrgId(orgId);
      console.log("Loaded customers:", customersData);
      setCustomers(customersData || []);
    } catch (error) {
      console.error("Error loading customers:", error);
      toast.error("Failed to load customers");
      setCustomers([]);
    } finally {
      setCustomersLoading(false);
    }
  };

  // Handle customer selection
  const handleCustomerChange = (customerCode) => {
    const selectedCustomer = customers.find(
      (cust) => cust.customerCode === customerCode,
    );
    if (selectedCustomer) {
      setSelectedCustomerName(selectedCustomer.name);
    }
    handleFieldChange("prClient", customerCode);
  };

  // Load teams
  const loadTeams = async () => {
    try {
      const teamsData = await getTeamsByOrg(orgId);
      console.log("Loaded teams:", teamsData);
      setTeams(teamsData);
    } catch (error) {
      console.error("Error loading teams:", error);
      toast.error("Failed to load teams");
    }
  };

  // Fetch project types
  const fetchProjectTypesList = async () => {
    if (!orgId) return;

    setProjectTypeLoading(true);
    try {
      const projectTypesData = await fetchProjectTypes(orgId);
      console.log("Loaded project types:", projectTypesData);
      setProjectTypes(projectTypesData || []);
    } catch (error) {
      console.error("Error loading project types:", error);
      toast.error("Failed to load project types");
      setProjectTypes([]);
    } finally {
      setProjectTypeLoading(false);
    }
  };

  // Fetch project type description
  const fetchProjectTypeDescription = async (projectTypeId) => {
    if (!projectTypeId) {
      setProjectTypeDesc("");
      return;
    }

    try {
      const response = await fetchProjectTypeById(projectTypeId);
      console.log("Project Type details:", response);
      setProjectTypeDesc(response.projectTypeDesc || projectTypeId);
    } catch (error) {
      console.error("Error fetching project type description:", error);
      setProjectTypeDesc(projectTypeId);
    }
  };

  // Fetch project manager name
  const fetchProjectManagerName = async (managerCode) => {
    if (!managerCode) {
      setProjectManagerName("Not assigned");
      return;
    }

    setLoadingManager(true);
    try {
      const response = await fetchResourceById(managerCode);
      console.log("Project Manager details:", response);
      setProjectManagerName(response.name || managerCode);
    } catch (error) {
      console.error("Error fetching project manager details:", error);
      setProjectManagerName(managerCode);
    } finally {
      setLoadingManager(false);
    }
  };

  // Fetch salesperson name
  const fetchSalespersonName = async (salespersonCode) => {
    if (!salespersonCode) {
      setSalespersonName("Not assigned");
      return;
    }

    setLoadingSalesperson(true);
    try {
      const response = await fetchResourceById(salespersonCode);
      console.log("Salesperson details:", response);
      setSalespersonName(response.name || salespersonCode);
    } catch (error) {
      console.error("Error fetching salesperson details:", error);
      setSalespersonName(salespersonCode);
    } finally {
      setLoadingSalesperson(false);
    }
  };

  // Load resources by organization
  const loadResourcesByOrg = async () => {
    if (!orgId) return;

    setResourcesByOrgLoading(true);
    try {
      const resourcesData = await fetchResourceByOrgId(orgId);
      console.log("Loaded resources by org:", resourcesData);
      setResourcesByOrg(resourcesData || []);
    } catch (error) {
      console.error("Error loading resources by org:", error);
      toast.error("Failed to load resources");
      setResourcesByOrg([]);
    } finally {
      setResourcesByOrgLoading(false);
    }
  };

  // =========================================================================
  // TASKS TAB FUNCTIONS
  // =========================================================================

  // Load project tasks

  // In the loadProjectTasksByStages function, modify it to handle tasks without stages:

  // const loadProjectTasksByStages = async () => {
  //   if (!project?.projectId) {
  //     setTasksLoading(false);
  //     return;
  //   }

  //   setTasksLoading(true);
  //   try {
  //     let allTasksData;

  //     // Check user roles to determine which tasks to load
  //     if (hasViewPermission()) {
  //       // Users with admin, manager, or commercial roles can view all tasks
  //       allTasksData = await getTasksByProject(project.projectId);
  //       console.log("All project tasks (full access):", allTasksData);
  //     } else {
  //       // Regular users only see tasks assigned to them
  //       allTasksData = await getTaskListByAssignedUser(userId);
  //       console.log(`Tasks assigned to user ${userId}:`, allTasksData);
  //     }

  //     // If no stages exist, just set tasks without stage grouping
  //     if (!stages || stages.length === 0) {
  //       setStageTasks({ "no-stage": allTasksData || [] });
  //       setFilteredStageTasks({ "no-stage": allTasksData || [] });

  //       // Fetch user details for assigned tasks
  //       if (allTasksData && allTasksData.length > 0) {
  //         await fetchTaskAssignedUsers(allTasksData);
  //         await loadAllTaskAssignments(allTasksData);
  //       }

  //       setTasksLoadingByStage({ "no-stage": false });
  //       return;
  //     }

  //     const tasksByStage = {};
  //     const loadingStates = {};

  //     // Initialize loading states for each stage + "No Stage"
  //     stages.forEach((stage) => {
  //       loadingStates[stage.stageId] = true;
  //     });
  //     loadingStates["no-stage"] = true;

  //     setTasksLoadingByStage(loadingStates);

  //     // Separate tasks by stage
  //     const tasksWithoutStage = [];

  //     (allTasksData || []).forEach((task) => {
  //       if (task.stageBelong) {
  //         const stageId = task.stageBelong;
  //         if (!tasksByStage[stageId]) {
  //           tasksByStage[stageId] = [];
  //         }
  //         tasksByStage[stageId].push(task);
  //       } else {
  //         tasksWithoutStage.push(task);
  //       }
  //     });

  //     // Add tasks without stage to the tasksByStage object
  //     if (tasksWithoutStage.length > 0) {
  //       tasksByStage["no-stage"] = tasksWithoutStage;
  //     }

  //     // Update loading states
  //     const updatedLoadingStates = { ...loadingStates };
  //     Object.keys(tasksByStage).forEach((stageId) => {
  //       updatedLoadingStates[stageId] = false;
  //     });
  //     setTasksLoadingByStage(updatedLoadingStates);

  //     // Fetch user details and assignments
  //     if (allTasksData && allTasksData.length > 0) {
  //       await fetchTaskAssignedUsers(allTasksData);
  //       await loadAllTaskAssignments(allTasksData);
  //     }

  //     setStageTasks(tasksByStage);
  //     setFilteredStageTasks(tasksByStage); // Initialize filtered tasks
  //   } catch (error) {
  //     console.error("Error loading project tasks by stages:", error);
  //     toast.error("Failed to load project tasks");
  //     setStageTasks({});
  //     setFilteredStageTasks({});
  //   } finally {
  //     setTasksLoading(false);
  //   }
  // };

  // Add this function near other load functions
  const loadTaskBuildingBlocks = async (tasks) => {
    if (!tasks || tasks.length === 0) return;

    try {
      setTaskBuildingBlocksLoading(true);
      const blocksMap = {};

      // Get all building blocks for this project
      const allBlocks = await getBuildingBlocksByOrgAndProject(
        String(orgId),
        String(project.projectId),
      );

      // For each block, get its tasks and create a mapping
      for (const block of allBlocks) {
        const blockTasks = await getTasksByBuildingBlock(block.buildingBlockId);

        // Map each task to its building block
        blockTasks.forEach((task) => {
          if (!blocksMap[task.taskId]) {
            blocksMap[task.taskId] = {
              buildingBlockId: block.buildingBlockId,
              buildingBlockName: block.buildingBlockName,
            };
          }
        });
      }

      setTaskBuildingBlocks(blocksMap);
    } catch (error) {
      console.error("Error loading task building blocks:", error);
    } finally {
      setTaskBuildingBlocksLoading(false);
    }
  };

  const loadProjectTasksByStages = async () => {
    if (!project?.projectId) {
      setTasksLoading(false);
      return;
    }

    setTasksLoading(true);
    try {
      let allTasksData;
      let additionalTasksData = [];

      // Check user roles to determine which tasks to load
      if (hasViewPermission()) {
        // Users with admin, manager, or commercial roles can view all tasks
        allTasksData = await getTasksByProject(project.projectId);
        console.log("All project tasks (full access):", allTasksData);
      } else {
        // Regular users:
        // 1. Get tasks assigned to them
        allTasksData = await getTaskListByAssignedUser(userId);
        console.log(`Tasks assigned to user ${userId}:`, allTasksData);

        // 2. Get tasks created by them (if we have the user's contact GUID)
        if (userContactGuid) {
          const allProjectTasks = await getTasksByProject(project.projectId);
          // Filter tasks where taskCreatedGuid matches user's contact GUID
          const tasksCreatedByUser = allProjectTasks.filter(
            (task) => task.taskCreatedGuid === userContactGuid,
          );
          console.log(
            `Tasks created by user ${userId} (GUID: ${userContactGuid}):`,
            tasksCreatedByUser,
          );
          additionalTasksData = tasksCreatedByUser;
        }
      }

      // Merge tasks: for regular users, combine assigned tasks + created tasks
      let finalTasksData = allTasksData || [];
      if (!hasViewPermission() && additionalTasksData.length > 0) {
        // Use a Set to avoid duplicates (in case a task is both assigned to and created by the user)
        const taskIdsSet = new Set(finalTasksData.map((t) => t.taskId));
        additionalTasksData.forEach((task) => {
          if (!taskIdsSet.has(task.taskId)) {
            finalTasksData.push(task);
            taskIdsSet.add(task.taskId);
          }
        });
        console.log("Final tasks (assigned + created):", finalTasksData);
      }

      // Load building block mappings for tasks
      if (finalTasksData && finalTasksData.length > 0) {
        await loadTaskBuildingBlocks(finalTasksData);
      }

      // If no stages exist, just set tasks without stage grouping
      if (!stages || stages.length === 0) {
        setStageTasks({ "no-stage": finalTasksData || [] });
        setFilteredStageTasks({ "no-stage": finalTasksData || [] });

        // Fetch user details for assigned tasks
        if (finalTasksData && finalTasksData.length > 0) {
          await fetchTaskAssignedUsers(finalTasksData);
          await loadAllTaskAssignments(finalTasksData);
        }

        setTasksLoadingByStage({ "no-stage": false });
        return;
      }

      const tasksByStage = {};
      const loadingStates = {};

      // Initialize loading states for each stage + "No Stage"
      stages.forEach((stage) => {
        loadingStates[stage.stageId] = true;
      });
      loadingStates["no-stage"] = true;

      setTasksLoadingByStage(loadingStates);

      // Separate tasks by stage
      const tasksWithoutStage = [];

      (finalTasksData || []).forEach((task) => {
        if (task.stageBelong) {
          const stageId = task.stageBelong;
          if (!tasksByStage[stageId]) {
            tasksByStage[stageId] = [];
          }
          tasksByStage[stageId].push(task);
        } else {
          tasksWithoutStage.push(task);
        }
      });

      // Add tasks without stage to the tasksByStage object
      if (tasksWithoutStage.length > 0) {
        tasksByStage["no-stage"] = tasksWithoutStage;
      }

      // Update loading states
      const updatedLoadingStates = { ...loadingStates };
      Object.keys(tasksByStage).forEach((stageId) => {
        updatedLoadingStates[stageId] = false;
      });
      setTasksLoadingByStage(updatedLoadingStates);

      // Fetch user details and assignments
      if (finalTasksData && finalTasksData.length > 0) {
        await fetchTaskAssignedUsers(finalTasksData);
        await loadAllTaskAssignments(finalTasksData);
      }

      setStageTasks(tasksByStage);
      setFilteredStageTasks(tasksByStage); // Initialize filtered tasks
    } catch (error) {
      console.error("Error loading project tasks by stages:", error);
      toast.error("Failed to load project tasks");
      setStageTasks({});
      setFilteredStageTasks({});
    } finally {
      setTasksLoading(false);
    }
  };

  // const loadProjectTasksByStages = async () => {
  //   if (!project?.projectId) {
  //     setTasksLoading(false);
  //     return;
  //   }

  //   setTasksLoading(true);
  //   try {
  //     let allTasksData;

  //     // Check user roles to determine which tasks to load
  //     if (hasViewPermission()) {
  //       // Users with admin, manager, or commercial roles can view all tasks
  //       allTasksData = await getTasksByProject(project.projectId);
  //       console.log("All project tasks (full access):", allTasksData);
  //     } else {
  //       // Regular users only see tasks assigned to them
  //       allTasksData = await getTaskListByAssignedUser(userId);
  //       console.log(`Tasks assigned to user ${userId}:`, allTasksData);
  //     }

  //     // Load building block mappings for tasks
  //     if (allTasksData && allTasksData.length > 0) {
  //       await loadTaskBuildingBlocks(allTasksData);
  //     }

  //     // If no stages exist, just set tasks without stage grouping
  //     if (!stages || stages.length === 0) {
  //       setStageTasks({ "no-stage": allTasksData || [] });
  //       setFilteredStageTasks({ "no-stage": allTasksData || [] });

  //       // Fetch user details for assigned tasks
  //       if (allTasksData && allTasksData.length > 0) {
  //         await fetchTaskAssignedUsers(allTasksData);
  //         await loadAllTaskAssignments(allTasksData);
  //       }

  //       setTasksLoadingByStage({ "no-stage": false });
  //       return;
  //     }

  //     const tasksByStage = {};
  //     const loadingStates = {};

  //     // Initialize loading states for each stage + "No Stage"
  //     stages.forEach((stage) => {
  //       loadingStates[stage.stageId] = true;
  //     });
  //     loadingStates["no-stage"] = true;

  //     setTasksLoadingByStage(loadingStates);

  //     // Separate tasks by stage
  //     const tasksWithoutStage = [];

  //     (allTasksData || []).forEach((task) => {
  //       if (task.stageBelong) {
  //         const stageId = task.stageBelong;
  //         if (!tasksByStage[stageId]) {
  //           tasksByStage[stageId] = [];
  //         }
  //         tasksByStage[stageId].push(task);
  //       } else {
  //         tasksWithoutStage.push(task);
  //       }
  //     });

  //     // Add tasks without stage to the tasksByStage object
  //     if (tasksWithoutStage.length > 0) {
  //       tasksByStage["no-stage"] = tasksWithoutStage;
  //     }

  //     // Update loading states
  //     const updatedLoadingStates = { ...loadingStates };
  //     Object.keys(tasksByStage).forEach((stageId) => {
  //       updatedLoadingStates[stageId] = false;
  //     });
  //     setTasksLoadingByStage(updatedLoadingStates);

  //     // Fetch user details and assignments
  //     if (allTasksData && allTasksData.length > 0) {
  //       await fetchTaskAssignedUsers(allTasksData);
  //       await loadAllTaskAssignments(allTasksData);
  //     }

  //     setStageTasks(tasksByStage);
  //     setFilteredStageTasks(tasksByStage); // Initialize filtered tasks
  //   } catch (error) {
  //     console.error("Error loading project tasks by stages:", error);
  //     toast.error("Failed to load project tasks");
  //     setStageTasks({});
  //     setFilteredStageTasks({});
  //   } finally {
  //     setTasksLoading(false);
  //   }
  // };

  // Fetch user details for assigned tasks
  const fetchTaskAssignedUsers = async (tasks) => {
    const assignedUserIds = tasks
      .map((task) => task.assignedTo)
      .filter((userId) => userId && userId !== "")
      .map((id) => parseInt(id))
      .filter((id) => !isNaN(id));

    if (assignedUserIds.length === 0) return;

    try {
      const response = await getUsersByIds(assignedUserIds);
      if (response && response.users) {
        const usersMap = {};
        response.users.forEach((user) => {
          usersMap[user.userId] = user.username;
        });
        setTaskAssignedUsers(usersMap);
      }
    } catch (error) {
      console.error("Error fetching task assigned users:", error);
    }
  };

  // const handleOpenTaskDetails = (taskId) => {
  //   navigate(`/project/${projectId}/task/${taskId}`);
  // };

  const handleOpenTaskDetails = (taskId) => {
    // Pass the current active tab as state
    navigate(`/project/${projectId}/task/${taskId}`, {
      state: { activeTab: activeTab },
    });
  };

  // Task edit modal handlers
  const handleEditTask = (taskId) => {
    setSelectedTaskId(taskId);
    setShowEditModal(true);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setSelectedTaskId(null);
    setSelectedTask(null);
  };

  const handleTaskUpdated = () => {
    loadProjectTasks();
  };

  // Handle task name clicks
  const handleTaskNameClick = (taskId) => {
    setSelectedTaskId(taskId);
    setShowTaskSidebar(true);
  };

  const loadEventName = async (eventCode) => {
    if (!eventCode) return;

    // prevent duplicate API calls
    if (eventNameMap[eventCode]) return;

    try {
      const event = await fetchEventByCode(orgId, eventCode);

      setEventNameMap((prev) => ({
        ...prev,
        [eventCode]: event?.eventName || eventCode,
      }));
    } catch (err) {
      console.error("Failed to fetch event", eventCode, err);

      setEventNameMap((prev) => ({
        ...prev,
        [eventCode]: eventCode,
      }));
    }
  };

  // Fetch contact persons for client
  const fetchClientContactPersons = async (clientId) => {
    if (!clientId) return [];
    try {
      console.log("Fetching client contacts for:", clientId);
      const contacts = await fetchCusVenCpByCusVenType(clientId);
      if (Array.isArray(contacts)) {
        console.log("Client contacts found:", contacts);
        setClientContactPersons(contacts);
        return contacts;
      } else {
        setClientContactPersons([]);
        return [];
      }
    } catch (error) {
      console.error("Error fetching client contact persons:", error);
      setClientContactPersons([]);
      return [];
    }
  };

  // Fetch contact persons for partners
  const fetchPartnerContactPersons = async (partners) => {
    if (!partners || partners.length === 0) return [];

    try {
      setLoadingContacts(true);
      const allPartnerContacts = [];
      for (const partner of partners) {
        const partnerId = partner.partnerName; // partnerName contains the vendor code
        console.log("Fetching partner contacts for:", partnerId);
        const contacts = await fetchCusVenCpByCusVenType(partnerId);
        if (Array.isArray(contacts) && contacts.length > 0) {
          console.log(
            `Found ${contacts.length} contacts for partner ${partnerId}`,
          );
          allPartnerContacts.push(...contacts);
        }
      }
      console.log("Total partner contacts found:", allPartnerContacts.length);
      setPartnerContactPersons(allPartnerContacts);
      return allPartnerContacts;
    } catch (error) {
      console.error("Error fetching partner contact persons:", error);
      setPartnerContactPersons([]);
      return [];
    } finally {
      setLoadingContacts(false);
    }
  };

  // Add this function to load project contacts
  const loadProjectContacts = async (projectId) => {
    if (!projectId) return;

    try {
      // First get project details to get the client ID
      const projectData = await fetchProjectDetails(projectId);

      // Store client ID for reference
      if (projectData && projectData.prClient) {
        setClientId(projectData.prClient);
        await fetchClientContactPersons(projectData.prClient);
      }

      // Fetch partner contact persons
      try {
        const partners = await getPartnersByProject(projectId);
        console.log("Project partners:", partners);
        if (Array.isArray(partners) && partners.length > 0) {
          setProjectPartners(partners);
          await fetchPartnerContactPersons(partners);
        } else {
          setProjectPartners([]);
          setPartnerContactPersons([]);
        }
      } catch (error) {
        console.error("Error fetching partners:", error);
        setProjectPartners([]);
        setPartnerContactPersons([]);
      }
    } catch (error) {
      console.error("Error loading project contacts:", error);
    }
  };

  // Function to get all assignee options (team members + client contacts + partner contacts)
  // Replace the existing getAllAssigneeOptions function with this:
  const getAllAssigneeOptions = () => {
    // If we have options from ticketDropdownApi, use them
    if (projectAssigneeOptions.length > 0) {
      return projectAssigneeOptions;
    }

    // Fallback to the old method if needed
    const options = [];
    const seenValues = new Set();

    // Add team members
    teamMemberDetails.forEach((user) => {
      if (!seenValues.has(user.userId)) {
        seenValues.add(user.userId);
        options.push({
          value: user.userId,
          label: `${user.username} (${user.email}) - Team Member`,
          type: "team",
        });
      }
    });

    // Add client contact persons
    clientContactPersons.forEach((contact) => {
      if (!seenValues.has(contact.cusVenId)) {
        seenValues.add(contact.cusVenId);
        options.push({
          value: contact.cusVenId,
          label: `${contact.contactPerName} (${contact.contactPerEmail || "No email"}) - Client Contact`,
          type: "client",
        });
      }
    });

    // Add partner contact persons
    partnerContactPersons.forEach((contact) => {
      if (!seenValues.has(contact.cusVenId)) {
        seenValues.add(contact.cusVenId);
        options.push({
          value: contact.cusVenId,
          label: `${contact.contactPerName} (${contact.contactPerEmail || "No email"}) - Partner Contact`,
          type: "partner",
        });
      }
    });

    // Sort options by type and then by name
    options.sort((a, b) => {
      if (a.type !== b.type) {
        const typeOrder = { team: 1, client: 2, partner: 3 };
        return typeOrder[a.type] - typeOrder[b.type];
      }
      return a.label.localeCompare(b.label);
    });

    return options;
  };

  // Add this function after your existing functions (e.g., after handleSoftDeleteTask)
  const exportTasksToExcel = () => {
    try {
      // Get all tasks from filteredStageTasks
      const allTasks = [];

      Object.keys(filteredStageTasks).forEach((stageId) => {
        const stage = stages.find((s) => s.stageId === stageId);
        // Get stage name - this gives you both Stage ID and Name together
        const stageName =
          stage?.stageName || (stageId === "no-stage" ? "No Stage" : stageId);
        const stageIdDisplay = stage?.stageId || stageId;

        (filteredStageTasks[stageId] || []).forEach((task) => {
          // Get assigned users names
          const currentAssignments = getCurrentAssignedUsersForTask(
            task.taskId,
          );
          const assignedUserNames = currentAssignments
            .map((assign) => {
              const userDetail = teamMemberDetails.find(
                (user) => String(user.userId) === String(assign.assignedUserId),
              );
              return userDetail?.username || assign.assignedUserId;
            })
            .join(", ");

          // Get building block info
          const buildingBlock = taskBuildingBlocks[task.taskId];

          allTasks.push({
            // Project Info (Title and ID together)
            "Project Name": project?.prTitle || "-",
            "Project ID": project?.projectId || "-",

            // Stage Info (ID and Name together)
            // "Stage ID": stageIdDisplay,
            "Stage Name": stageName,

            // Task Info
            "Task ID": task.taskId,
            "Task Name": task.taskName,
            Description: task.taskDescription || "-",
            "Assigned To": assignedUserNames || task.assignedTo || "Unassigned",

            // Related Items
            // "Ticket ID": task.taskTicketFor || "-",
            "Ticket Name": ticketNameMap[task.taskTicketFor] || "-",
            // "Event ID": task.taskEventFor || "-",
            "Event Name": eventNameMap[task.taskEventFor] || "-",
            "Building Block":
              buildingBlock?.buildingBlockName || "Not assigned",

            // Task Metadata
            "Task Type": getTaskTypeName(task.taskType),
            Priority: task.taskPriority || "No Priority",
            Status: getTaskStatusName(task.taskStatus),

            // Dates
            "Start Date": task.taskStartDate
              ? moment(task.taskStartDate).format("YYYY-MM-DD")
              : "-",
            "End Date": task.taskEndDate
              ? moment(task.taskEndDate).format("YYYY-MM-DD")
              : "-",
            "Actual Start Date": task.actualStartDate
              ? moment(task.actualStartDate).format("YYYY-MM-DD")
              : "-",
            "Actual End Date": task.actualEndDate
              ? moment(task.actualEndDate).format("YYYY-MM-DD")
              : "-",

            // Audit Info
            "Created By": task.createdBy || "-",
            "Created Date": task.createdDate
              ? moment(task.createdDate).format("YYYY-MM-DD")
              : "-",
            "Created Time": task.createdTime || "-",
            "Edited By": task.editedBy || "-",
          });
        });
      });

      if (allTasks.length === 0) {
        toast.warning("No tasks to export");
        return;
      }

      // Create worksheet with column widths
      const worksheet = XLSX.utils.json_to_sheet(allTasks);
      worksheet["!cols"] = [
        { wch: 25 }, // Project Name
        { wch: 15 }, // Project ID
        { wch: 15 }, // Stage ID
        { wch: 20 }, // Stage Name
        { wch: 15 }, // Task ID
        { wch: 35 }, // Task Name
        { wch: 40 }, // Description
        { wch: 25 }, // Assigned To
        { wch: 15 }, // Ticket ID
        { wch: 30 }, // Ticket Name
        { wch: 15 }, // Event ID
        { wch: 25 }, // Event Name
        { wch: 20 }, // Building Block
        { wch: 15 }, // Task Type
        { wch: 12 }, // Priority
        { wch: 15 }, // Status
        { wch: 12 }, // Start Date
        { wch: 12 }, // End Date
        { wch: 15 }, // Actual Start Date
        { wch: 15 }, // Actual End Date
        { wch: 15 }, // Created By
        { wch: 12 }, // Created Date
        { wch: 10 }, // Created Time
        { wch: 15 }, // Edited By
      ];

      // Create workbook and download
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Project Tasks");

      // Generate filename with project name and date
      const safeProjectName = (project?.prTitle || "Project").replace(
        /[^a-z0-9]/gi,
        "_",
      );
      const filename = `${safeProjectName}_${project?.projectId || "Tasks"}_${moment().format("YYYY-MM-DD")}.xlsx`;

      XLSX.writeFile(workbook, filename);
      toast.success(`Exported ${allTasks.length} tasks to Excel`);
    } catch (error) {
      console.error("Error exporting tasks:", error);
      toast.error("Failed to export tasks");
    }
  };

  // Add this function near other load functions
  const loadProjectAssigneeOptions = async (projectId) => {
    if (!orgId || !projectId) {
      setProjectAssigneeOptions([]);
      return;
    }

    setLoadingProjectAssignees(true);
    try {
      // Fetch Team, Customer, and Partner in parallel
      const [team, customers, partners] = await Promise.all([
        ticketDropdownApi.getTeamAssigned(orgId, projectId),
        ticketDropdownApi.getCustomer(orgId, projectId),
        ticketDropdownApi.getPartner(orgId, projectId),
      ]);

      const assigneeMap = new Map();

      // Add Team members
      team.forEach((item) => {
        if (!assigneeMap.has(item.contactGUID)) {
          assigneeMap.set(item.contactGUID, {
            value: item.contactGUID,
            label: `${item.contactName} (Team)`,
            type: "team",
            contactName: item.contactName,
            contactRoleGUID: item.contactRoleGUID,
          });
        }
      });

      // Add Customers
      customers.forEach((item) => {
        if (!assigneeMap.has(item.contactGUID)) {
          assigneeMap.set(item.contactGUID, {
            value: item.contactGUID,
            label: `${item.contactName} (Customer)`,
            type: "client",
            contactName: item.contactName,
            contactRoleGUID: item.contactRoleGUID,
          });
        }
      });

      // Add Partners/Vendors
      partners.forEach((item) => {
        if (!assigneeMap.has(item.contactGUID)) {
          assigneeMap.set(item.contactGUID, {
            value: item.contactGUID,
            label: `${item.contactName} (Partner)`,
            type: "partner",
            contactName: item.contactName,
            contactRoleGUID: item.contactRoleGUID,
          });
        }
      });

      // Convert map to array and sort alphabetically
      const sortedOptions = Array.from(assigneeMap.values()).sort((a, b) =>
        a.label.localeCompare(b.label),
      );

      setProjectAssigneeOptions(sortedOptions);

      console.log("Project assignee options loaded:", sortedOptions.length);
    } catch (error) {
      console.error("Error loading project assignee options:", error);
      setProjectAssigneeOptions([]);
    } finally {
      setLoadingProjectAssignees(false);
    }
  };

  // ======================= TASK ASSIGNMENT FUNCTIONS =======================

  // Load assignments for all tasks in the table
  const loadAllTaskAssignments = async (tasks) => {
    if (!tasks || tasks.length === 0) return;

    try {
      const assignmentsMap = {};

      // Fetch assignments for each task
      for (const task of tasks) {
        try {
          const assignments = await getTaskAssignmentsByTaskId(task.taskId);
          assignmentsMap[task.taskId] = assignments || [];
        } catch (error) {
          console.error(
            `Error loading assignments for task ${task.taskId}:`,
            error,
          );
          assignmentsMap[task.taskId] = [];
        }
      }

      setTaskAssignmentsByTask(assignmentsMap);
    } catch (error) {
      console.error("Error loading task assignments:", error);
    }
  };

  // Add this function near other load functions
  const loadAllTaskStatuses = async () => {
    try {
      setTaskStatusesLoading(true);
      const statuses = await getAllTaskStatus();
      console.log("Loaded statuses:", statuses); // Add this

      // Create a mapping from statusGuid to statusName
      const statusMap = {};
      statuses.forEach((status) => {
        console.log(`Mapping ${status.statusGuid} -> ${status.statusName}`); // Add this

        statusMap[status.statusGuid.toLowerCase()] = status.statusName;
      });

      setTaskStatusMap(statusMap);
    } catch (error) {
      console.error("Error loading task statuses:", error);
      toast.error("Failed to load task statuses");
    } finally {
      setTaskStatusesLoading(false);
    }
  };

  // Add this helper function
  const getTaskStatusName = (statusGuid) => {
    if (!statusGuid) return "No Status";

    // Convert to lowercase for case-insensitive comparison
    const lowerGuid = statusGuid.toLowerCase();

    // Return the mapped name or show "Loading..." if still loading
    if (taskStatusesLoading) return "Loading...";

    return taskStatusMap[lowerGuid] || statusGuid; // Fallback to GUID if not found
  };

  // Load assignments for a specific task
  const loadTaskAssignmentsForTask = async (taskId) => {
    try {
      const assignments = await getTaskAssignmentsByTaskId(taskId);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: assignments || [],
      }));
      return assignments || [];
    } catch (error) {
      console.error(`Error loading assignments for task ${taskId}:`, error);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: [],
      }));
      return [];
    }
  };

  // Update the loadProjectTasks function to also load assignments:
  const loadProjectTasks = async () => {
    if (!project?.projectId) return;

    setTasksLoading(true);
    try {
      const tasksData = await getTasksByProject(project.projectId);
      console.log("Loaded tasks:", tasksData);
      setTasks(tasksData);

      // Load assignments for all tasks
      await loadAllTaskAssignments(tasksData);

      // Fetch user details for assigned tasks (keep this for fallback)
      await fetchTaskAssignedUsers(tasksData);
    } catch (error) {
      console.error("Error loading tasks:", error);
      toast.error("Failed to load project tasks");
    } finally {
      setTasksLoading(false);
    }
  };

  // Helper function to get active assignments for a task
  const getActiveAssignmentsForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];
    return assignments.filter(
      (assign) => assign.isActive === true || assign.isActive === 1,
    );
  };

  // Helper function to get all assigned users for a task (including historical)
  const getAllAssignedUsersForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];
    return assignments.map((assign) => assign.assignedUserId);
  };

  // Helper function to get current assigned users (active or most recent)
  const getCurrentAssignedUsersForTask = (taskId) => {
    const assignments = taskAssignmentsByTask[taskId] || [];

    // First, get active assignments
    const activeAssignments = assignments.filter(
      (assign) => assign.isActive === true || assign.isActive === 1,
    );

    if (activeAssignments.length > 0) {
      return activeAssignments;
    }

    // If no active assignments, get the most recent completed assignment
    if (assignments.length > 0) {
      const sorted = [...assignments].sort(
        (a, b) =>
          new Date(b.endTime || b.startTime) -
          new Date(a.endTime || a.startTime),
      );
      return [sorted[0]];
    }

    return [];
  };

  // Add this helper function
  const getUsernameFromId = (userId) => {
    if (!userId) return "Unknown";

    // Try to find in teamMemberDetails first
    const userDetail = teamMemberDetails.find(
      (user) => String(user.userId) === String(userId),
    );

    if (userDetail) return userDetail.username;

    // Fallback to taskAssignedUsers
    const mappedUser = taskAssignedUsers[parseInt(userId)];
    if (mappedUser) return mappedUser;

    return userId; // Return ID if no name found
  };

  // Fetch user's contact GUID for task creator filtering
  const fetchUserContactGuid = async () => {
    if (!orgId || !userId) return;

    setLoadingUserContactGuid(true);
    try {
      const response = await getContactGuid(orgId, userId);
      console.log("User Contact GUID:", response);
      setUserContactGuid(response.contactGuid);
    } catch (error) {
      console.error("Error fetching user contact GUID:", error);
      // Don't show toast error as this is not critical
    } finally {
      setLoadingUserContactGuid(false);
    }
  };

  // Refresh task assignments
  // Refresh task assignments with cache busting
  const refreshTaskAssignments = async (taskId) => {
    try {
      setTaskAssignLoading(true);
      const data = await getTaskAssignmentsByTaskId(taskId);

      // Update both the dialog state and the main assignments map
      setTaskAssignments(data || []);
      setTaskAssignmentsByTask((prev) => ({
        ...prev,
        [taskId]: data || [],
      }));

      return data || [];
    } catch (err) {
      console.error("Error loading task assignments:", err);
      toast.error("Failed to load task assignments");
      return [];
    } finally {
      setTaskAssignLoading(false);
    }
  };

  const loadTaskLogs = async (taskId) => {
    try {
      setTaskLogsLoading(true);
      const logs = await getTaskLogsByTaskId(taskId);
      setTaskLogs(logs || []);
    } catch (err) {
      console.error("Failed to load task logs:", err);
      toast.error("Failed to load task logs");
      setTaskLogs([]);
    } finally {
      setTaskLogsLoading(false);
    }
  };

  const openTaskDialog = async (task) => {
    setTaskAssignments([]);
    setTaskLogs([]); // ✅ reset logs
    setTaskForDialog(task);
    setShowTaskDialog(true);
    setAssignTaskUserId("");

    // Load assignments
    const freshAssignments = await loadTaskAssignmentsForTask(task.taskId);
    setTaskAssignments(freshAssignments);

    // 🔥 Load task logs
    await loadTaskLogs(task.taskId);
  };

  // Load all task types
  const loadAllTaskTypes = async () => {
    try {
      setTaskTypesLoading(true);
      const types = await getAllTaskTypes();
      console.log("Loaded task types:", types);

      // Create a mapping from typeGuid to typeName
      const typeMap = {};
      types.forEach((type) => {
        console.log(`Mapping ${type.typeGuid} -> ${type.typeName}`);
        typeMap[type.typeGuid.toLowerCase()] = type.typeName;
      });

      setTaskTypeMap(typeMap);
      setTaskTypes(types);
    } catch (error) {
      console.error("Error loading task types:", error);
      toast.error("Failed to load task types");
    } finally {
      setTaskTypesLoading(false);
    }
  };

  // Helper function to get task type name from GUID
  const getTaskTypeName = (typeGuid) => {
    if (!typeGuid) return "No Type";

    // Convert to lowercase for case-insensitive comparison
    const lowerGuid = typeGuid.toLowerCase();

    // Return the mapped name or show "Loading..." if still loading
    if (taskTypesLoading) return "Loading...";

    return taskTypeMap[lowerGuid] || typeGuid; // Fallback to GUID if not found
  };

  // Also update the closeTaskDialog to reset assignments
  const closeTaskDialog = () => {
    setShowTaskDialog(false);
    setTaskForDialog(null);
    setTaskAssignments([]); // Clear assignments when closing
    setAssignTaskUserId("");
  };

  // Get active assignment for user on this task
  const getActiveAssignmentForTaskUser = (taskId, userId) => {
    const list = taskAssignments || [];
    return list.find(
      (x) =>
        String(x.assignedUserId) === String(userId) &&
        (x.isActive === true || x.isActive === 1),
    );
  };

  const isNotStarted = (a) => !a.startTime && !a.endTime;
  const isActive = (a) => a.isActive === true && !!a.startTime;
  const isPaused = (a) => a.isPaused === true;

  // Handle assign/start
  const handleAssignAndStartTask = async () => {
    if (!taskForDialog?.taskId) {
      toast.error("No task selected");
      return;
    }
    if (!assignTaskUserId) {
      toast.error("Please select a team member");
      return;
    }

    const active = getActiveAssignmentForTaskUser(
      taskForDialog.taskId,
      assignTaskUserId,
    );
    if (active) {
      toast.info("This user already has an active session on this task");
      return;
    }

    try {
      setTaskAssignLoading(true);
      await startTaskWork(taskForDialog.taskId, assignTaskUserId, orgId);
      toast.success("Task work session started");
      await refreshTaskAssignments(taskForDialog.taskId);
      setAssignTaskUserId("");
    } catch (err) {
      console.error("Start work failed:", err);
      toast.error(
        err?.response?.data || err?.message || "Failed to start work",
      );
    } finally {
      setTaskAssignLoading(false);
    }
  };

  // const handleAssignUserOnly = async () => {
  //   if (!taskForDialog?.taskId || !assignTaskUserId) {
  //     toast.error("Please select a team member");
  //     return;
  //   }

  //   try {
  //     setTaskAssignLoading(true);

  //     await updateTask(taskForDialog.taskId, {
  //       assignedTo: assignTaskUserId,
  //       CreatedBy: String(userId),
  //       EditedBy: String(userId),
  //     });

  //     toast.success("User assigned to task");

  //     // 🔄 Assignment already created by backend
  //     await refreshTaskAssignments(taskForDialog.taskId);

  //     setAssignTaskUserId("");
  //   } catch {
  //     toast.error("Failed to assign user");
  //   } finally {
  //     setTaskAssignLoading(false);
  //   }
  // };

  const handleAssignUserOnly = async () => {
    if (!taskForDialog?.taskId || !assignTaskUserId) {
      toast.error("Please select a team member");
      return;
    }

    // Optional: Add validation to ensure only valid assignee types can be assigned
    const selectedOption = getAllAssigneeOptions().find(
      (opt) => String(opt.value) === String(assignTaskUserId),
    );

    if (!selectedOption) {
      toast.error("Invalid assignee selected");
      return;
    }

    // You can add logic here to handle different assignee types differently
    // For example, maybe client contacts and partner contacts have different assignment logic

    try {
      setTaskAssignLoading(true);

      await updateTask(taskForDialog.taskId, {
        assignedTo: assignTaskUserId,
        CreatedBy: String(userId),
        EditedBy: String(userId),
      });

      toast.success(`User assigned to task (${selectedOption.type})`);

      // 🔄 Assignment already created by backend
      await refreshTaskAssignments(taskForDialog.taskId);

      setAssignTaskUserId("");
    } catch {
      toast.error("Failed to assign user");
    } finally {
      setTaskAssignLoading(false);
    }
  };

  const hasAnyAssignment = (taskId, userId) => {
    return (taskAssignmentsByTask[taskId] || []).some(
      (a) => String(a.assignedUserId) === String(userId),
    );
  };

  // Stop work
  const handleStopTaskWork = async (assignmentId) => {
    if (!assignmentId) return;
    try {
      await stopTaskWork(assignmentId);
      toast.success("Stopped task work session");
      await refreshTaskAssignments(taskForDialog?.taskId);
    } catch (err) {
      console.error("Stop work failed:", err);
      toast.error(err?.response?.data || err?.message || "Failed to stop work");
    }
  };

  // 🔎 Search by Stage Name + Task Name
  useEffect(() => {
    if (!searchQuery.trim()) {
      setFilteredStageTasks(stageTasks);
      return;
    }

    const lowerQuery = searchQuery.toLowerCase();
    const filtered = {};

    Object.keys(stageTasks).forEach((stageId) => {
      const stage = stages.find((s) => s.stageId === stageId);
      const stageNameMatch = stage?.stageName
        ?.toLowerCase()
        .includes(lowerQuery);

      // Filter tasks by task name
      const matchingTasks = stageTasks[stageId].filter((task) =>
        task.taskName?.toLowerCase().includes(lowerQuery),
      );

      // If stage name matches → show ALL tasks of that stage
      if (stageNameMatch) {
        filtered[stageId] = stageTasks[stageId];
      }
      // If only some tasks match → show only matching tasks
      else if (matchingTasks.length > 0) {
        filtered[stageId] = matchingTasks;
      }
    });

    setFilteredStageTasks(filtered);
  }, [searchQuery, stageTasks, stages]);

  const handleSaveWorkLog = async () => {
    if (!taskForDialog?.taskId) {
      toast.error("No task selected");
      return;
    }

    if (!workLogUserId || !workValue) {
      toast.error("Please select user and work value");
      return;
    }

    // Get selected user info for logging purposes
    const selectedUser = getAllAssigneeOptions().find(
      (opt) => String(opt.value) === String(workLogUserId),
    );

    if (!selectedUser) {
      toast.error("Selected user not found");
      return;
    }

    try {
      setSavingWorkLog(true);

      const payload = {
        taskId: taskForDialog.taskId,
        projectId: project.projectId,
        orgId: String(orgId),
        assignedUserId: workLogUserId,
        workValue: parseFloat(workValue),
        workUnit,
        logType: "WORK_LOG",
        logDescription: `Manual work log: ${workValue} ${workUnit} - ${selectedUser.type}`, // Include user type in description
        createdBy: String(userId),
      };

      console.log("Creating work log with payload:", payload);

      await createTaskWorkLog(payload);

      toast.success(`Work log added for ${selectedUser.type}`);

      // refresh logs immediately
      await loadTaskLogs(taskForDialog.taskId);

      // reset
      setWorkLogUserId("");
      setWorkValue("");
      setWorkUnit("HOUR");

      // OPTIONAL: refresh task logs / history later
    } catch (err) {
      console.error(err);
      toast.error("Failed to add work log");
    } finally {
      setSavingWorkLog(false);
    }
  };

  const handleSelect = (task, isSelected) => {
    if (!task || task.type !== "project") return;

    // Only toggle when row is actively clicked (not deselected)
    if (!isSelected) return;

    const stageId = task.id.replace("stage-", "");

    setCollapsedStages((prev) => ({
      ...prev,
      [stageId]: !prev[stageId],
    }));
  };

  const handleTimePeriodChange = (value) => {
    setTimePeriod(value);

    switch (value) {
      case "Day":
        setViewMode(ViewMode.Day);
        setColumnWidth(65);
        break;

      case "Week":
        setViewMode(ViewMode.Week);
        setColumnWidth(85);
        break;

      case "Month":
        setViewMode(ViewMode.Month);
        setColumnWidth(300);
        break;

      case "Quarter":
        setViewMode(ViewMode.Month);
        setColumnWidth(500); // Larger month width
        break;

      case "Year":
        setViewMode(ViewMode.Year);
        setColumnWidth(350);
        break;

      case "Flexible":
        setViewMode(ViewMode.Month);
        setColumnWidth(200);
        break;

      default:
        break;
    }
  };

  const handleAutoFit = () => {
    if (!finalGanttTasks.length) return;

    const taskOnly = finalGanttTasks.filter((t) => t.type !== "project");

    const minDate = new Date(
      Math.min(...taskOnly.map((t) => new Date(t.start))),
    );

    const maxDate = new Date(Math.max(...taskOnly.map((t) => new Date(t.end))));

    const totalDays = (maxDate - minDate) / (1000 * 60 * 60 * 24);

    if (totalDays <= 14) {
      setViewMode(ViewMode.Day);
      setColumnWidth(65);
      setTimePeriod("Day");
    } else if (totalDays <= 90) {
      setViewMode(ViewMode.Week);
      setColumnWidth(85);
      setTimePeriod("Week");
    } else if (totalDays <= 365) {
      setViewMode(ViewMode.Month);
      setColumnWidth(300);
      setTimePeriod("Month");
    } else {
      setViewMode(ViewMode.Year);
      setColumnWidth(350);
      setTimePeriod("Year");
    }
  };

  const exportPNG = async () => {
    const element = document.getElementById("gantt-container");
    const canvas = await html2canvas(element);
    const link = document.createElement("a");
    link.download = "gantt.png";
    link.href = canvas.toDataURL();
    link.click();
  };

  const exportPDF = async () => {
    const element = document.getElementById("gantt-container");
    const canvas = await html2canvas(element);

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("landscape");
    pdf.addImage(imgData, "PNG", 10, 10, 280, 150);
    pdf.save("gantt.pdf");
  };

  const exportExcel = () => {
    const taskOnly = finalGanttTasks.filter((t) => t.type !== "project");

    const data = taskOnly.map((t) => ({
      Task: t.name,
      Start: moment(t.start).format("YYYY-MM-DD"),
      End: moment(t.end).format("YYYY-MM-DD"),
      Progress: t.progress,
    }));

    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Gantt");

    XLSX.writeFile(workbook, "gantt.xlsx");
  };

  const sortTasks = (tasks) => {
    const sorted = [...tasks];

    switch (sortBy) {
      case "startDate":
        return sorted.sort((a, b) => new Date(a.start) - new Date(b.start));

      case "endDate":
        return sorted.sort((a, b) => new Date(a.end) - new Date(b.end));

      case "status":
        return sorted.sort((a, b) =>
          (a.taskStatus || "").localeCompare(b.taskStatus || ""),
        );

      case "priority":
        return sorted.sort((a, b) =>
          (a.taskPriority || "").localeCompare(b.taskPriority || ""),
        );

      case "assignee":
        return sorted.sort((a, b) =>
          (a.assignedTo || "").localeCompare(b.assignedTo || ""),
        );

      case "duration":
        return sorted.sort(
          (a, b) =>
            new Date(a.end) -
            new Date(a.start) -
            (new Date(b.end) - new Date(b.start)),
        );

      default:
        return sorted;
    }
  };

  // 1️⃣ Separate stages and tasks
  const stageRows = ganttTasks.filter((t) => t.type === "project");
  const taskRows = ganttTasks.filter((t) => t.type !== "project");

  // 2️⃣ Apply filters
  let filteredTasks = taskRows.filter((task) => {
    if (!showClosed && task.progress === 100) return false;

    if (filterStatus.length && !filterStatus.includes(task.taskStatus))
      return false;

    if (filterPriority.length && !filterPriority.includes(task.taskPriority))
      return false;

    if (
      filterAssignee.length &&
      !filterAssignee.includes(String(task.assignedTo))
    )
      return false;

    return true;
  });

  // 3️⃣ Apply sorting
  filteredTasks = sortTasks(filteredTasks);

  // 4️⃣ Group by stage
  const tasksGroupedByStage = {};

  filteredTasks.forEach((task) => {
    const stageId = task.project;

    if (!tasksGroupedByStage[stageId]) {
      tasksGroupedByStage[stageId] = [];
    }

    tasksGroupedByStage[stageId].push(task);
  });

  const getGanttTaskStyleByStatus = (status) => {
    switch (status) {
      case "Not Started":
        return {
          backgroundColor: "#94a3b8", // Gray
          backgroundSelectedColor: "#64748b",
          progressColor: "#64748b",
          progressSelectedColor: "#64748b",
        };

      case "In Progress":
        return {
          backgroundColor: "#3b82f6", // Blue
          backgroundSelectedColor: "#2563eb",
          progressColor: "#1d4ed8",
          progressSelectedColor: "#1d4ed8",
        };

      case "On Hold":
        return {
          backgroundColor: "#f59e0b", // Orange
          backgroundSelectedColor: "#d97706",
          progressColor: "#b45309",
          progressSelectedColor: "#b45309",
        };

      case "Completed":
        return {
          backgroundColor: "#10b981", // Green
          backgroundSelectedColor: "#059669",
          progressColor: "#047857",
          progressSelectedColor: "#047857",
        };

      case "Cancelled":
        return {
          backgroundColor: "#ef4444", // Red
          backgroundSelectedColor: "#dc2626",
          progressColor: "#b91c1c",
          progressSelectedColor: "#b91c1c",
        };

      default:
        return {
          backgroundColor: "#6b7280", // Default gray
          backgroundSelectedColor: "#4b5563",
          progressColor: "#4b5563",
          progressSelectedColor: "#4b5563",
        };
    }
  };

  // 1️⃣ Build final tasks directly from filteredStageTasks
  let finalGanttTasks = [];

  // 1️⃣ Convert stages to array with tasks
  let stageArray = Object.keys(filteredStageTasks).map((stageId) => {
    const stage = stages.find((s) => s.stageId === stageId);

    const tasks = (filteredStageTasks[stageId] || []).filter((task) => {
      if (!showClosed && task.taskStatus === "Completed") return false;

      if (filterStatus.length && !filterStatus.includes(task.taskStatus))
        return false;

      if (filterPriority.length && !filterPriority.includes(task.taskPriority))
        return false;

      if (
        filterAssignee.length &&
        !filterAssignee.includes(String(task.assignedTo))
      )
        return false;

      return true;
    });

    return {
      stageId,
      stage,
      tasks,
    };
  });

  // 2️⃣ Stage Level Sorting
  if (sortBy === "stageStart") {
    stageArray.sort(
      (a, b) =>
        new Date(a.stage?.stageStartDateTime) -
        new Date(b.stage?.stageStartDateTime),
    );
  }

  if (sortBy === "stageEnd") {
    stageArray.sort(
      (a, b) =>
        new Date(a.stage?.stageEndDateTime) -
        new Date(b.stage?.stageEndDateTime),
    );
  }

  // 3️⃣ Task Level Sorting
  if (sortBy === "taskStart") {
    stageArray.forEach((stageObj) => {
      stageObj.tasks.sort(
        (a, b) => new Date(a.taskStartDate) - new Date(b.taskStartDate),
      );
    });

    // Move stage based on earliest task
    stageArray.sort(
      (a, b) =>
        new Date(a.tasks[0]?.taskStartDate) -
        new Date(b.tasks[0]?.taskStartDate),
    );
  }

  if (sortBy === "taskEnd") {
    stageArray.forEach((stageObj) => {
      stageObj.tasks.sort(
        (a, b) => new Date(a.taskEndDate) - new Date(b.taskEndDate),
      );
    });

    // Move stage based on latest task
    stageArray.sort(
      (a, b) =>
        new Date(a.tasks[a.tasks.length - 1]?.taskEndDate) -
        new Date(b.tasks[b.tasks.length - 1]?.taskEndDate),
    );
  }

  // 4️⃣ Build final gantt structure
  stageArray.forEach(({ stageId, stage, tasks }) => {
    if (!stage || tasks.length === 0) return;

    finalGanttTasks.push({
      id: `stage-${stageId}`,
      name: stage.stageName,
      type: "project",
      start: new Date(stage.stageStartDateTime),
      end: new Date(stage.stageEndDateTime),
      progress: 0,
      hideChildren: collapsedStages[stageId] || false,
    });

    if (!collapsedStages[stageId]) {
      tasks.forEach((task) => {
        finalGanttTasks.push({
          id: task.taskId,
          name: task.taskName,
          start: new Date(task.taskStartDate),
          end: new Date(task.taskEndDate),
          progress: task.taskStatus === "Completed" ? 100 : 50,
          project: `stage-${stageId}`,
          taskStatus: task.taskStatus,
          taskPriority: task.taskPriority,
          assignedTo: String(task.assignedTo),
          styles: getGanttTaskStyleByStatus(task.taskStatus),
        });
      });
    }
  });

  const handleResetFilters = () => {
    setFilterStatus([]);
    setFilterPriority([]);
    setFilterAssignee([]);
    setFilterStage([]);
    setShowClosed(false);
    setSortBy("startDate");

    toast.info("Filters reset");
  };

  // Add this function near other handler functions

  const refreshTasks = async () => {
    setTasksLoading(true);
    try {
      // Clear existing data
      setStageTasks({});
      setFilteredStageTasks({});

      // Reload stages and tasks
      await loadProjectStages();
      await loadProjectTasksByStages();
    } catch (error) {
      console.error("Error refreshing tasks:", error);
      toast.error("Failed to refresh tasks");
    } finally {
      setTasksLoading(false);
    }
  };

  const handleSoftDeleteTask = async (taskId) => {
    if (!hasEditPermission()) {
      toast.error("You don't have permission to delete tasks");
      return;
    }

    const reason = window.prompt(
      "Please provide a reason for deleting this task (optional):",
      "",
    );

    if (reason === null) {
      return;
    }

    try {
      const result = await softDeleteTask(taskId, String(userId), reason || "");

      console.log("Delete result:", result); // Add this for debugging

      // Check for both 'message' (lowercase) and 'Message' (uppercase)
      if (result.message || result.Message) {
        const successMessage = result.message || result.Message;
        toast.success(successMessage);

        // Use the dedicated refresh function
        await refreshTasks();
      } else {
        toast.error("Failed to delete task");
      }
    } catch (error) {
      console.error("Error deleting task:", error);
      toast.error(error.message || "Failed to delete task");
    }
  };

  // const handleSoftDeleteTask = async (taskId) => {
  //   if (!hasEditPermission()) {
  //     toast.error("You don't have permission to delete tasks");
  //     return;
  //   }

  //   const reason = window.prompt(
  //     "Please provide a reason for deleting this task (optional):",
  //     "",
  //   );

  //   if (reason === null) {
  //     return;
  //   }

  //   try {
  //     const result = await softDeleteTask(taskId, String(userId), reason || "");

  //     if (result.Message) {
  //       toast.success(result.Message);

  //       // Use the dedicated refresh function
  //       await refreshTasks();
  //     } else {
  //       toast.error("Failed to delete task");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting task:", error);
  //     toast.error(error.message || "Failed to delete task");
  //   }
  // };

  // const handleSoftDeleteTask = async (taskId) => {
  //   // Check if user has permission to delete
  //   if (!hasEditPermission()) {
  //     toast.error("You don't have permission to delete tasks");
  //     return;
  //   }

  //   // Show confirmation dialog with reason input
  //   const reason = window.prompt(
  //     "Please provide a reason for deleting this task (optional):",
  //     "",
  //   );

  //   // User cancelled the prompt
  //   if (reason === null) {
  //     return;
  //   }

  //   try {
  //     const result = await softDeleteTask(
  //       taskId,
  //       String(userId), // Pass the current user ID
  //       reason || "", // Pass the reason (empty string if not provided)
  //     );

  //     if (result.Message) {
  //       toast.success(result.Message);

  //       // Refresh tasks after deletion
  //       await loadProjectTasksByStages();

  //       // Also refresh Gantt view if active
  //       if (activeTab === "gantt") {
  //         // The Gantt view will update when loadProjectTasksByStages is called
  //       }
  //     } else {
  //       toast.error("Failed to delete task");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting task:", error);
  //     toast.error(error.message || "Failed to delete task");
  //   }
  // };

  // Optional: Add restore functionality if you want to allow restoration
  const handleRestoreTask = async (taskId) => {
    if (!hasEditPermission()) {
      toast.error("You don't have permission to restore tasks");
      return;
    }

    const reason = window.prompt(
      "Please provide a reason for restoring this task (optional):",
      "",
    );

    if (reason === null) return;

    try {
      const result = await restoreTask(taskId, String(userId), reason || "");

      if (result.Message) {
        toast.success(result.Message);
        await loadProjectTasksByStages();
      } else {
        toast.error("Failed to restore task");
      }
    } catch (error) {
      console.error("Error restoring task:", error);
      toast.error(error.message || "Failed to restore task");
    }
  };

  // Add this function near handleAddRemark
  const handleUpdateRemark = async (logGuid, newRemark) => {
    if (!newRemark.trim()) {
      toast.error("Please enter a remark");
      return;
    }

    try {
      setUpdatingRemark(true);

      const updateData = {
        logGuid: logGuid,
        newRemark: newRemark,
        changedByUserId: String(userId),
      };

      await updateProjectRemark(projectId, updateData);

      toast.success("Remark updated successfully");

      // Reset editing state
      setEditingRemarkId(null);
      setEditingRemarkText("");

      // Refresh remarks list
      loadProjectRemarks();
    } catch (error) {
      console.error("Error updating remark:", error);
      toast.error(error.message || "Failed to update remark");
    } finally {
      setUpdatingRemark(false);
    }
  };

  // Start editing a remark
  const startEditRemark = (remark) => {
    setEditingRemarkId(remark.guid);
    setEditingRemarkText(remark.remarks);
  };

  // Cancel editing
  const cancelEditRemark = () => {
    setEditingRemarkId(null);
    setEditingRemarkText("");
  };

  // =========================================================================
  // BORAD FUNCTIONS
  // =========================================================================

  const getBoardColumns = () => {
    const allTasks = Object.values(filteredStageTasks).flat();
    const columns = {};

    // =========================
    // GROUP BY STATUS
    // =========================
    if (boardGroupBy === "status") {
      const statusList = [
        "Not Started",
        "In Progress",
        "On Hold",
        "Completed",
        "Cancelled",
        "No Status",
      ];

      statusList.forEach((status) => {
        columns[status] = [];
      });

      allTasks.forEach((task) => {
        const key = task.taskStatus || "No Status";
        if (columns[key]) {
          columns[key].push(task);
        }
      });
    }

    // =========================
    // GROUP BY PRIORITY
    // =========================
    if (boardGroupBy === "priority") {
      const priorityList = ["High", "Medium", "Low", "No Priority"];

      priorityList.forEach((priority) => {
        columns[priority] = [];
      });

      allTasks.forEach((task) => {
        const key = task.taskPriority || "No Priority";
        if (columns[key]) {
          columns[key].push(task);
        }
      });
    }

    // =========================
    // GROUP BY ASSIGNEE
    // =========================
    if (boardGroupBy === "assignee") {
      const assigneeList = [
        "Unassigned",
        ...teamMemberDetails.map((user) => user.username),
      ];

      assigneeList.forEach((name) => {
        columns[name] = [];
      });

      allTasks.forEach((task) => {
        const key = task.assignedTo
          ? getUsernameFromId(task.assignedTo)
          : "Unassigned";

        if (columns[key]) {
          columns[key].push(task);
        }
      });
    }

    // =========================
    // GROUP BY STAGE
    // =========================
    if (boardGroupBy === "stage") {
      stages.forEach((stage) => {
        columns[stage.stageName] = filteredStageTasks[stage.stageId] || [];
      });

      // Always show No Stage column
      columns["No Stage"] = filteredStageTasks["no-stage"] || [];
    }

    return columns;
  };

  // =========================================================================
  // Building Block FUNCTIONS
  // =========================================================================

  const handleBlockChange = (field, value) => {
    setBlockForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const loadBuildingBlocks = async () => {
    try {
      setSummaryLoading(true); // 🔥 START LOADER

      const data = await getBuildingBlocksByOrgAndProject(
        String(orgId),
        String(project.projectId),
      );

      setBuildingBlocks(data);

      const summaryMap = {};

      for (const block of data) {
        const summary = await getBlockSummary(
          block.buildingBlockId,
          blockViewType,
        );
        summaryMap[block.buildingBlockId] = summary;
      }

      setBlockSummaries(summaryMap);
    } catch (error) {
      toast.error("Failed to load building blocks");
    } finally {
      setSummaryLoading(false); // 🔥 STOP LOADER
    }
  };

  useEffect(() => {
    if (activeTab === "BuildingBlock" && orgId) {
      loadBuildingBlocks();
    }
  }, [activeTab, orgId]);

  useEffect(() => {
    if (activeTab === "BuildingBlock") {
      loadBuildingBlocks();
    }
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "BuildingBlock") {
      loadBuildingBlocks();
    }
  }, [blockViewType]);

  const handleSaveBlock = async () => {
    if (!blockForm.buildingBlockName.trim()) {
      toast.error("Please enter building block name");
      return;
    }

    try {
      const payload = {
        buildingBlockId: editingBlockId,
        buildingBlockName: blockForm.buildingBlockName,
        buildingBlockStatus: blockForm.buildingBlockStatus,
        buildingBlockDescription: blockForm.buildingBlockDescription,
        buildingBlockProject: String(project.projectId),
        buildingBlockProcessPoc: blockForm.buildingBlockProcessPoc,
        buildingBlockTechPoc: blockForm.buildingBlockTechPoc,
        buildingBlockTypes: blockForm.buildingBlockTypes,
        actualStartDate: blockForm.actualStartDate
          ? new Date(blockForm.actualStartDate).toISOString()
          : null,
        actualEndDate: blockForm.actualEndDate
          ? new Date(blockForm.actualEndDate).toISOString()
          : null,
        editedBy: String(userId),
      };

      if (isEditingBlock) {
        // 🔥 UPDATE
        await updateBuildingBlock(editingBlockId, payload);
        toast.success("Building Block updated successfully");
      } else {
        // CREATE
        await createBuildingBlock({
          ...payload,
          orgId: String(orgId),
          createdBy: String(userId),
        });
        toast.success("Building Block created successfully");
      }

      setShowBlockModal(false);
      setIsEditingBlock(false);
      setEditingBlockId(null);

      setBlockForm({
        buildingBlockName: "",
        buildingBlockStatus: "Not Started",
        buildingBlockDescription: "",
        buildingBlockProcessPoc: "",
        buildingBlockTechPoc: "",
        buildingBlockTypes: "",
        actualStartDate: "",
        actualEndDate: "",
      });

      loadBuildingBlocks();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save building block");
    }
  };

  const resetBlockForm = () => {
    setBlockForm({
      buildingBlockName: "",
      buildingBlockStatus: "Not Started",
      buildingBlockDescription: "",
      buildingBlockProcessPoc: "",
      buildingBlockTechPoc: "",
      buildingBlockTypes: "",
      actualStartDate: "",
      actualEndDate: "",
    });

    setIsEditingBlock(false);
    setEditingBlockId(null);
  };

  const openMapModal = async (block) => {
    setSelectedBlock(block);
    setSelectedTaskIds([]);
    setShowTaskMapModal(true);

    try {
      if (blockViewType === "TASK") {
        const allTasks = await getTasksByProject(project.projectId);
        const mappedTasks = await getTasksByBuildingBlock(
          block.buildingBlockId,
        );

        const mappedIds = (mappedTasks || []).map((t) => t.taskId);

        const filtered = (allTasks || []).filter(
          (t) => !mappedIds.includes(t.taskId),
        );

        setProjectTasksForMapping(filtered);
      } else {
        const allTickets = await getTicketsByProjectId(project.projectId);
        const mappedTickets = await getTicketsByBuildingBlock(
          block.buildingBlockId,
        );

        const mappedIds = (mappedTickets || []).map((t) => t.ticketId);

        const filtered = (allTickets || []).filter(
          (t) => !mappedIds.includes(t.ticketId),
        );

        setProjectTasksForMapping(filtered);
      }
    } catch {
      toast.error("Failed to load data");
    }
  };

  const handleEditBlock = (block) => {
    setIsEditingBlock(true);
    setEditingBlockId(block.buildingBlockId);

    setBlockForm({
      buildingBlockName: block.buildingBlockName || "",
      buildingBlockStatus: block.buildingBlockStatus || "Not Started",
      buildingBlockDescription: block.buildingBlockDescription || "",
      buildingBlockProcessPoc: block.buildingBlockProcessPoc || "",
      buildingBlockTechPoc: block.buildingBlockTechPoc || "",
      buildingBlockTypes: block.buildingBlockTypes || "",
      actualStartDate: block.actualStartDate
        ? moment(block.actualStartDate).format("YYYY-MM-DD")
        : "",
      actualEndDate: block.actualEndDate
        ? moment(block.actualEndDate).format("YYYY-MM-DD")
        : "",
    });

    setShowBlockModal(true);
  };

  const handleTaskSelection = (taskId) => {
    setSelectedTaskIds((prev) =>
      prev.includes(taskId)
        ? prev.filter((id) => id !== taskId)
        : [...prev, taskId],
    );
  };

  const loadBlocksForTicket = async (ticketId) => {
    try {
      // 1️⃣ Get all blocks for this project
      const blocks = await getBuildingBlocksByOrgAndProject(
        String(orgId),
        String(project.projectId),
      );

      setAllBlocks(blocks || []);

      // 2️⃣ Get blocks already mapped to this ticket
      const mappedTickets = [];

      for (const block of blocks) {
        const tickets = await getTicketsByBuildingBlock(block.buildingBlockId);

        if ((tickets || []).some((t) => t.ticketId === ticketId)) {
          mappedTickets.push(block);
        }
      }

      setTicketBlocks(mappedTickets);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load building blocks");
    }
  };

  const BUILDING_BLOCK_STATUS_OPTIONS = [
    "Not Started",
    "In Progress",
    "On Hold",
    "Completed",
    "Cancelled",
  ];

  const handleRemoveItemFromBlock = async (itemId) => {
    if (!selectedBlock?.buildingBlockId) return;

    if (!window.confirm("Are you sure you want to remove this mapping?")) {
      return;
    }

    try {
      setMappingLoading(true);

      if (blockViewType === "TASK") {
        await removeSpecificTaskMapping(itemId, selectedBlock.buildingBlockId);
      } else {
        await removeTicketMapping(itemId, selectedBlock.buildingBlockId);
      }

      toast.success("Mapping removed successfully");

      // 🔄 Refresh block items modal
      await openBlockItemsModal(selectedBlock);

      // 🔄 Refresh summary table
      await loadBuildingBlocks();
    } catch (error) {
      console.error(error);
      toast.error("Failed to remove mapping");
    } finally {
      setMappingLoading(false);
    }
  };

  const availableBlocksForMapping = allBlocks.filter(
    (block) =>
      !ticketBlocks.some(
        (mapped) => mapped.buildingBlockId === block.buildingBlockId,
      ),
  );

  const handleRemoveBlockMapping = async (blockId) => {
    if (!ticketForDialog?.ticketId) return;

    try {
      setBlockMappingLoading(true);

      await removeTicketMapping(ticketForDialog.ticketId, blockId);

      toast.success("Building Block removed successfully");

      // Refresh ticket blocks
      await loadBlocksForTicket(ticketForDialog.ticketId);
    } catch (err) {
      console.error(err);
      toast.error("Failed to remove mapping");
    } finally {
      setBlockMappingLoading(false);
    }
  };

  const handleMapTasks = async () => {
    if (!selectedBlock || selectedTaskIds.length === 0) {
      toast.error("Please select at least one item");
      return;
    }

    try {
      setMappingLoading(true);

      for (const id of selectedTaskIds) {
        if (blockViewType === "TASK") {
          await mapTaskToBuildingBlock({
            buildingBlockId: selectedBlock.buildingBlockId,
            taskId: id,
            orgId: String(orgId),
            createdBy: String(userId),
          });
        } else {
          await mapTicketToBuildingBlock({
            buildingBlockId: selectedBlock.buildingBlockId,
            ticketId: id,
            orgId: String(orgId),
            createdBy: String(userId),
          });
        }
      }

      toast.success(`${blockViewType} mapped successfully`);
      setShowTaskMapModal(false);
      await loadBuildingBlocks();
    } catch {
      toast.error("Mapping failed");
    } finally {
      setMappingLoading(false);
    }
  };

  const openBlockItemsModal = async (block) => {
    try {
      if (blockViewType === "TASK") {
        const tasks = await getTasksByBuildingBlock(block.buildingBlockId);
        setBlockTasks(tasks);
      } else {
        const tickets = await getTicketsByBuildingBlock(block.buildingBlockId);
        setBlockTasks(tickets);
      }

      setSelectedBlock(block);
      setShowBlockTasksModal(true);
    } catch {
      toast.error("Failed to load data");
    }
  };

  // =========================================================================
  // EXCEL UPLOAD FUNCTIONS
  // =========================================================================

  // Handle task creation method selection
  const handleAddTaskClick = () => {
    setShowTaskOptions(true);
  };

  // Handle Excel upload method
  const handleExcelUploadClick = () => {
    setShowTaskOptions(false);
    setShowExcelUploadModal(true);
  };

  // Handle manual task creation
  const handleManualTaskClick = () => {
    setShowTaskOptions(false);
    navigate(`/addTask?projectId=${project.projectId}`);
  };

  // Add new handler for batch creator
  const handleBatchCreateClick = () => {
    setShowTaskOptions(false);
    setShowBatchCreator(true);
  };

  // Handle Excel file selection
  // Update the handleExcelFileSelect function
  const handleExcelFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Check file size (max 10MB)
    const maxSize = 10 * 1024 * 1024; // 10MB
    if (file.size > maxSize) {
      toast.error("File size must be less than 10MB");
      event.target.value = "";
      return;
    }

    // Get file extension
    const fileName = file.name.toLowerCase();
    const isExcel = fileName.endsWith(".xlsx") || fileName.endsWith(".xls");
    const isCSV = fileName.endsWith(".csv");

    if (!isExcel && !isCSV) {
      toast.error("Please select an Excel (.xlsx, .xls) or CSV file");
      event.target.value = "";
      return;
    }

    // If it's a CSV file, convert it to Excel format
    if (isCSV) {
      const reader = new FileReader();
      reader.onload = async (e) => {
        try {
          const csvContent = e.target.result;

          // Parse CSV
          const workbook = XLSX.read(csvContent, { type: "string" });

          // Convert to XLSX format
          const excelData = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
          });

          // Create new Excel file
          const excelBlob = new Blob([excelData], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          const excelFileName = file.name.replace(".csv", ".xlsx");
          const excelFile = new File([excelBlob], excelFileName, {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          setExcelFile(excelFile);
          toast.info("CSV file converted to Excel format.");
        } catch (error) {
          console.error("Error converting CSV to Excel:", error);
          toast.error(
            "Failed to convert CSV file. Please upload an Excel file instead.",
          );
          event.target.value = "";
        }
      };
      reader.readAsText(file);
    } else {
      // It's already an Excel file
      setExcelFile(file);
    }
  };
  // In handleExcelUpload function
  const handleExcelUpload = async () => {
    if (!excelFile) {
      toast.error("Please select an Excel file to upload");
      return;
    }

    if (!orgId || !project?.projectId) {
      toast.error("Organization ID or Project ID is missing");
      return;
    }

    setUploadingExcel(true);

    try {
      const formData = new FormData();
      formData.append("excelFile", excelFile);
      formData.append("orgId", orgId);
      formData.append("projectBelong", project.projectId);

      // Add createdBy if needed
      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      if (userDetails?.userId) {
        formData.append("createdBy", userDetails.userId);
      }

      // Optional: Add other parameters if needed
      formData.append("taskStatus", "Pending"); // Default status
      formData.append("taskPriority", "Medium"); // Default priority

      console.log("=== FRONTEND DEBUG ===");
      console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0] + ": ", pair[1]);
      }
      console.log("File details:", {
        name: excelFile.name,
        size: excelFile.size,
        type: excelFile.type,
        lastModified: excelFile.lastModified,
      });

      // Call the Excel upload API
      console.log("Calling API...");
      const response = await createTasksFromExcel(formData);

      console.log("API Response received:", response);

      // Check for success flag
      if (response.success || response.message) {
        const successMessage =
          response.message ||
          `${
            response.createdCount || "Tasks"
          } created successfully from Excel!`;
        toast.success(successMessage);
        setShowExcelUploadModal(false);
        setExcelFile(null);

        // Refresh tasks list
        loadProjectTasks();
      } else {
        toast.error(response.message || "Failed to create tasks from Excel");
      }
    } catch (error) {
      console.error("=== FRONTEND ERROR ===");
      console.error("Full error:", error);
      console.error("Error name:", error.name);
      console.error("Error message:", error.message);
      console.error("Error stack:", error.stack);

      // Show more specific error
      if (error.message.includes("File contains corrupted data")) {
        toast.error(
          "The Excel file format is invalid. Please download and use the template.",
        );
      } else if (error.message.includes("instance of entity type")) {
        toast.error("Database error. Please try again or contact support.");
      } else if (error.message.includes("No response from server")) {
        toast.error(
          "Cannot connect to server. Please check your network connection.",
        );
      } else if (error.message.includes("timeout")) {
        toast.error(
          "Request timed out. The file might be too large or server is busy.",
        );
      } else {
        // Show the actual error message from backend
        toast.error(`Upload failed: ${error.message}`);
      }
    } finally {
      setUploadingExcel(false);
    }
  };

  // Close Excel upload modal
  const handleCloseExcelUploadModal = () => {
    setShowExcelUploadModal(false);
    setExcelFile(null);
  };

  // Download Excel template
  const handleDownloadTemplate = () => {
    // Create sample Excel data
    const templateData = [
      [
        "taskName",
        "taskDescription",
        "assignedTo",
        "taskStartDate",
        "taskEndDate",
        "taskPriority",
        "taskStatus",
      ],
      [
        "Task 1",
        "Description for task 1",
        "user123",
        "2024-01-15",
        "2024-01-20",
        "High",
        "Pending",
      ],
      [
        "Task 2",
        "Description for task 2",
        "user456",
        "2024-01-16",
        "2024-01-22",
        "Medium",
        "In Progress",
      ],
      [
        "Task 3",
        "Description for task 3",
        "",
        "2024-01-17",
        "2024-01-25",
        "Low",
        "Not Started",
      ],
    ];

    // Convert to CSV
    const csvContent = templateData.map((row) => row.join(",")).join("\n");

    // Create download link
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "task_upload_template.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);

    toast.info("Excel template downloaded. Fill in your tasks and upload.");
  };

  // =========================================================================
  // STAGES TAB FUNCTIONS
  // =========================================================================

  // Load project stages
  const loadProjectStages = async () => {
    if (!projectId) return;

    setStagesLoading(true);
    try {
      const stagesData = await fetchStagesByProject(projectId);
      console.log("Loaded project stages:", stagesData);
      setStages(stagesData || []);
    } catch (error) {
      console.error("Error loading project stages:", error);
      toast.error("Failed to load project stages");
      setStages([]);
    } finally {
      setStagesLoading(false);
    }
  };

  // Stage modal handlers
  const handleCreateStage = () => {
    setEditingStage(null);
    setShowStageModal(true);
  };

  const handleEditStage = (stage) => {
    setEditingStage(stage);
    setShowStageModal(true);
  };

  const handleCloseStageModal = () => {
    setShowStageModal(false);
    setEditingStage(null);
  };

  const handleStageSaved = () => {
    loadProjectStages();
    handleCloseStageModal();
  };

  // Handle stage updates
  const handleUpdateStage = async (stageId, updatedData) => {
    try {
      await updateStage(stageId, updatedData);
      toast.success("Stage updated successfully");
      loadProjectStages();
    } catch (error) {
      console.error("Error updating stage:", error);
      toast.error("Failed to update stage");
    }
  };

  // =========================================================================
  // TEAM TAB FUNCTIONS
  // =========================================================================

  // Fetch user details for team members
  const fetchTeamMemberDetails = async (userIds) => {
    if (!userIds || userIds.length === 0) {
      setTeamMemberDetails([]);
      return;
    }

    try {
      setLoadingTeamMembers(true);
      console.log("Fetching user details for team member IDs:", userIds);

      // Convert string IDs to numbers for the API
      const numericUserIds = userIds
        .map((id) => parseInt(id))
        .filter((id) => !isNaN(id));

      if (numericUserIds.length === 0) {
        console.warn("No valid user IDs to fetch for team members");
        setTeamMemberDetails([]);
        return;
      }

      const response = await getUsersByIds(numericUserIds);
      console.log("Fetched Team Member Details:", response);

      if (response && response.users) {
        setTeamMemberDetails(response.users);
      } else {
        setTeamMemberDetails([]);
        console.warn("No user details found for team members");
      }
    } catch (error) {
      console.error("Error fetching team member details:", error);
      toast.error("Error loading team member details");
      setTeamMemberDetails([]);
    } finally {
      setLoadingTeamMembers(false);
    }
  };

  // =========================================================================
  // TICKET TAB FUNCTIONS
  // =========================================================================

  // Load tickets for the project
  // Load tickets for the project
  // Replace your existing loadProjectTickets function
  const loadProjectTickets = async () => {
    if (!project?.projectId) return;

    setTicketsLoading(true);
    try {
      const ticketsData = await getTicketsByProjectId(project.projectId);
      console.log("Loaded tickets:", ticketsData);
      setTickets(ticketsData);

      // Collect all contact GUIDs from tickets
      const contactGuids = new Set();
      ticketsData.forEach((ticket) => {
        // Check submittedBy (if it's a GUID)
        if (
          ticket.submittedBy &&
          ticket.submittedBy.match(
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
          )
        ) {
          contactGuids.add(ticket.submittedBy);
        }
        // Check assignedTo (split if multiple)
        if (ticket.assignedTo) {
          const assignedToIds = ticket.assignedTo.split(",");
          assignedToIds.forEach((id) => {
            const trimmedId = id.trim();
            if (
              trimmedId &&
              trimmedId.match(
                /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
              )
            ) {
              contactGuids.add(trimmedId);
            }
          });
        }
      });

      // Fetch contact names for all collected GUIDs
      if (contactGuids.size > 0) {
        await fetchContactNames(Array.from(contactGuids));
      }

      // Resolve names after fetching tickets
      if (ticketsData && ticketsData.length > 0) {
        await resolveAllTicketNames(ticketsData);
      }
    } catch (error) {
      console.error("Error loading tickets:", error);
      toast.error("Failed to load project tickets");
    } finally {
      setTicketsLoading(false);
    }
  };

  // Add this function near loadProjectTickets
  const resolveAllTicketNames = useCallback(async (ticketsList) => {
    if (!ticketsList || ticketsList.length === 0) return;

    const isValidGuid = (guid) => {
      if (!guid || typeof guid !== "string") return false;
      return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        guid,
      );
    };

    const typeSet = new Set();
    const logSet = new Set();
    const categorySet = new Set();

    ticketsList.forEach((t) => {
      if (t.ticketType && isValidGuid(t.ticketType)) {
        typeSet.add(t.ticketType);
      }
      if (t.ticketReason && isValidGuid(t.ticketReason)) {
        logSet.add(t.ticketReason);
      }
      if (t.category && isValidGuid(t.category)) {
        categorySet.add(t.category);
      }
    });

    if (typeSet.size === 0 && logSet.size === 0 && categorySet.size === 0) {
      return;
    }

    try {
      const typeGuidsStr =
        typeSet.size > 0 ? Array.from(typeSet).join(",") : null;
      const logGuidsStr = logSet.size > 0 ? Array.from(logSet).join(",") : null;
      const categoryGuidsStr =
        categorySet.size > 0 ? Array.from(categorySet).join(",") : null;

      const data = await getTicketMetaNames(
        typeGuidsStr,
        logGuidsStr,
        categoryGuidsStr,
      );

      const typeMap = {};
      const logMap = {};
      const categoryMap = {};

      data.forEach((item) => {
        const key = item.guid.toLowerCase();
        if (item.entity === "TYPE") {
          typeMap[key] = item.name;
        }
        if (item.entity === "LOG") {
          logMap[key] = item.name;
        }
        if (item.entity === "CATEGORY") {
          categoryMap[key] = item.name;
        }
      });

      setResolvedTicketNames({
        types: typeMap,
        reasons: logMap,
        categories: categoryMap,
      });
    } catch (err) {
      console.error("Failed to resolve meta names", err);
    }
  }, []);

  // Handle converting ticket to task
  const handleConvertToTask = (ticket) => {
    navigate(`/addTask?projectId=${projectId}&ticketId=${ticket.ticketId}`);
  };

  // Load assignments for a ticket
  const refreshAssignments = async (ticketId) => {
    try {
      setAssignmentsLoading(true);
      const data = await getAssignmentsByTicketId(ticketId);
      console.log(data);
      setAssignmentsByTicket((prev) => ({ ...prev, [ticketId]: data || [] }));
    } catch (err) {
      console.error("Error loading assignments:", err);
      // toast.error("Failed to load assignments");
    } finally {
      setAssignmentsLoading(false);
    }
  };

  // Open the small ticket dialog
  /**
   * The function `openTicketDialog` sets up a ticket dialog, assigns a ticket to a user, and refreshes
   * the assignments.
   */
  // const openTicketDialog = async (ticket) => {
  //   setTicketForDialog(ticket);
  //   setShowTicketDialog(true);
  //   setAssignUserId("");
  //   await refreshAssignments(ticket.ticketId);
  // };

  const openTicketDialog = async (ticket) => {
    setTicketForDialog(ticket);
    setShowTicketDialog(true);
    setAssignUserId("");

    await refreshAssignments(ticket.ticketId);
    await loadTicketLogs(ticket.ticketId);

    // 🔥 ADD THIS
    await loadBlocksForTicket(ticket.ticketId);
  };

  const handleMapTicketToBlock = async () => {
    if (!selectedBlockId) {
      toast.error("Please select a Building Block");
      return;
    }

    // 🔥 Check if already mapped
    const alreadyMapped = ticketBlocks.some(
      (b) => b.buildingBlockId === selectedBlockId,
    );

    if (alreadyMapped) {
      toast.warning(
        "This ticket is already assigned to the selected Building Block.",
      );
      return;
    }

    try {
      setBlockMappingLoading(true);

      await mapTicketToBuildingBlock({
        buildingBlockId: selectedBlockId,
        ticketId: ticketForDialog.ticketId,
        orgId: String(orgId),
        createdBy: String(userId),
      });

      toast.success("Ticket mapped successfully");

      setSelectedBlockId("");

      await loadBlocksForTicket(ticketForDialog.ticketId);
    } catch (err) {
      console.error(err);
      toast.error("Failed to map ticket");
    } finally {
      setBlockMappingLoading(false);
    }
  };

  const filteredTickets = tickets.filter((ticket) => {
    const matchesSearch =
      ticket.ticketName?.toLowerCase().includes(searchText.toLowerCase()) ||
      ticket.description?.toLowerCase().includes(searchText.toLowerCase());

    const matchesStatus = statusFilter ? ticket.status === statusFilter : true;

    const matchesPriority = priorityFilter
      ? ticket.priority === priorityFilter
      : true;

    return matchesSearch && matchesStatus && matchesPriority;
  });

  const handleSaveTicketWorkLog = async () => {
    if (!ticketForDialog?.ticketId) {
      toast.error("No ticket selected");
      return;
    }

    if (!ticketWorkUserId || !ticketWorkValue) {
      toast.error("Please select user and enter hours");
      return;
    }

    try {
      setSavingTicketWorkLog(true);

      const payload = {
        ticketId: ticketForDialog.ticketId,
        orgId: orgId,
        effortValue: parseFloat(ticketWorkValue),
        effortUnit: ticketWorkUnit,

        // 🔥 IMPORTANT
        changedBy: ticketWorkUserId, // resource who worked
        createdBy: String(userId), // logged-in user
      };

      await addTicketWorkLog(payload);

      toast.success("Work log added");

      await loadTicketLogs(ticketForDialog.ticketId);

      // reset
      setTicketWorkUserId("");
      setTicketWorkValue("");
      setTicketWorkUnit("HOURS");
    } catch (err) {
      console.error(err);
      toast.error("Failed to add work log");
    } finally {
      setSavingTicketWorkLog(false);
    }
  };

  // Close dialog
  const closeTicketDialog = () => {
    setShowTicketDialog(false);
    setTicketForDialog(null);
    setAssignUserId("");
  };

  // Get the active assignment (if any) for a user on this ticket
  const getActiveAssignmentForUser = (ticketId, userId) => {
    const list = assignmentsByTicket[ticketId] || [];
    return list.find(
      (x) =>
        String(x.assignedUserId) === String(userId) &&
        (x.isActive === true || x.isActive === 1),
    );
  };

  // Assign & start work for the selected team member
  const handleAssignAndStart = async () => {
    if (!ticketForDialog?.ticketId) {
      toast.error("No ticket selected");
      return;
    }
    if (!assignUserId) {
      toast.error("Please select a team member");
      return;
    }

    // Prevent duplicate active sessions
    const active = getActiveAssignmentForUser(
      ticketForDialog.ticketId,
      assignUserId,
    );
    if (active) {
      toast.info("This user already has an active session on this ticket");
      return;
    }
    console.log(orgId);
    try {
      setAssignLoading(true);
      await startWork(ticketForDialog.ticketId, assignUserId, orgId);
      toast.success("Assignment started");
      await refreshAssignments(ticketForDialog.ticketId);
      setAssignUserId("");
    } catch (err) {
      console.error("Start work failed:", err);
      toast.error(
        err?.response?.data || err?.message || "Failed to start assignment",
      );
    } finally {
      setAssignLoading(false);
    }
  };

  const loadTicketName = async (ticketId) => {
    if (!ticketId) return;

    // prevent duplicate API calls
    if (ticketNameMap[ticketId]) return;

    try {
      const ticket = await getTicketByTicketId(ticketId);

      setTicketNameMap((prev) => ({
        ...prev,
        [ticketId]: ticket?.ticketName || ticketId,
      }));
    } catch (err) {
      console.error("Failed to fetch ticket", ticketId, err);

      setTicketNameMap((prev) => ({
        ...prev,
        [ticketId]: ticketId,
      }));
    }
  };

  // Stop an active assignment
  const handleStop = async (assignmentId) => {
    if (!assignmentId) return;

    try {
      await stopWork(assignmentId);
      toast.success("Stopped");
      if (ticketForDialog?.ticketId) {
        await refreshAssignments(ticketForDialog.ticketId);
      }
    } catch (err) {
      console.error("Stop work failed:", err);
      toast.error(err?.response?.data || err?.message || "Failed to stop");
    }
  };

  useEffect(() => {
    if (tickets.length > 0) {
      tickets.forEach((ticket) => refreshAssignments(ticket.ticketId));
    }
  }, [tickets]);

  // Format a duration in hours with 2 decimals
  const fmtHours = (h) => (h == null ? "-" : Number(h).toFixed(2));

  // Helper function to check if a string is a valid GUID
  const isValidGuid = (guid) => {
    if (!guid || typeof guid !== "string") return false;
    const guidRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
    return guidRegex.test(guid);
  };

  // Resolve status GUID to name
  const resolveStatusName = (statusGuid) => {
    if (!statusGuid) return "N/A";

    // If it's already a status name (for backward compatibility)
    if (!statusGuid.includes("-")) {
      return statusGuid;
    }

    return statusMasterData.statusMap[statusGuid] || statusGuid.substring(0, 8);
  };

  // Resolve sub-status GUID to name
  const resolveSubStatusName = (subStatusGuid) => {
    if (!subStatusGuid) return "N/A";

    // If it's already a status name (for backward compatibility)
    if (!subStatusGuid.includes("-")) {
      return subStatusGuid;
    }

    return (
      statusMasterData.subStatusMap[subStatusGuid] ||
      subStatusGuid.substring(0, 8)
    );
  };

  // Resolve ticket type
  const resolveTicketType = (typeGuid) => {
    if (!typeGuid) return "N/A";

    if (isValidGuid(typeGuid)) {
      const resolvedName = resolvedNames.types[typeGuid];
      if (resolvedName) {
        return resolvedName;
      }
      return typeGuid.substring(0, 8);
    }
    // If not a GUID, return as is (legacy string value)
    return typeGuid;
  };

  // Resolve ticket reason
  const resolveTicketReason = (code) => {
    if (!code) return "N/A";
    const resolvedName = resolvedNames.reasons[code];
    if (resolvedName) {
      return resolvedName;
    }
    return code;
  };

  // Resolve category name
  const resolveCategoryName = (categoryGuid) => {
    if (!categoryGuid) return "N/A";

    if (isValidGuid(categoryGuid)) {
      const resolvedName = resolvedNames.categories[categoryGuid];
      if (resolvedName) {
        return resolvedName;
      }
      return categoryGuid.substring(0, 8);
    }
    return categoryGuid;
  };

  // Get status badge with proper name
  const getStatusBadgeWithName = (statusGuid) => {
    const statusName = resolveStatusName(statusGuid);
    const variants = {
      Open: "success",
      "In Progress": "warning",
      Resolved: "info",
      Closed: "secondary",
    };

    const variant = variants[statusName] || "secondary";
    return <Badge bg={variant}>{statusName}</Badge>;
  };

  // Load dropdown data for ticket types, reasons, categories
  const loadTicketDropdownData = async () => {
    try {
      if (!orgId) return;
      const data = await getTicketDropdownData(orgId);
      setDropdownData(data);
    } catch (error) {
      console.error("Failed to load dropdown data:", error);
    }
  };

  // Load status master data
  const loadTicketStatusMasterData = async () => {
    try {
      const statuses = await getAllTicketStatuses();

      const statusMap = {};
      const subStatusMap = {};

      statuses.forEach((mainStatus) => {
        // Map main status
        statusMap[mainStatus.statusGuid] = mainStatus.statusName;

        // Map sub-statuses
        if (mainStatus.subStatuses && mainStatus.subStatuses.length > 0) {
          mainStatus.subStatuses.forEach((subStatus) => {
            subStatusMap[subStatus.statusGuid] = subStatus.statusName;
          });
        }
      });

      setStatusMasterData({
        statusMap,
        subStatusMap,
        allStatuses: statuses,
      });
    } catch (error) {
      console.error("Failed to load status master data:", error);
    }
  };

  // Function to resolve all names for tickets
  // const resolveAllTicketNames = useCallback(async (ticketsList) => {
  //   if (!ticketsList || ticketsList.length === 0) return;

  //   // Collect unique IDs
  //   const uniqueTypeGuids = new Set();
  //   const uniqueReasonCodes = new Set();
  //   const uniqueCategoryGuids = new Set();

  //   ticketsList.forEach((ticket) => {
  //     if (ticket.ticketType && isValidGuid(ticket.ticketType)) {
  //       uniqueTypeGuids.add(ticket.ticketType);
  //     }
  //     if (ticket.ticketReason) {
  //       uniqueReasonCodes.add(ticket.ticketReason);
  //     }
  //     if (ticket.category && isValidGuid(ticket.category)) {
  //       uniqueCategoryGuids.add(ticket.category);
  //     }
  //   });

  //   if (
  //     uniqueTypeGuids.size === 0 &&
  //     uniqueReasonCodes.size === 0 &&
  //     uniqueCategoryGuids.size === 0
  //   ) {
  //     return;
  //   }

  //   try {
  //     const resolved = await resolveNames(
  //       Array.from(uniqueTypeGuids),
  //       Array.from(uniqueReasonCodes),
  //       Array.from(uniqueCategoryGuids),
  //     );

  //     setResolvedNames({
  //       types: resolved.typeNames || {},
  //       reasons: resolved.reasonNames || {},
  //       categories: resolved.categoryNames || {},
  //     });
  //   } catch (error) {
  //     console.error("Failed to resolve names:", error);
  //   }
  // }, []);

  const fetchCusVenCpIfNeeded = async (cpId) => {
    if (!cpId || !cpId.startsWith("CVCP")) return null;
    if (cusVenCpCache[cpId]) {
      return cusVenCpCache[cpId];
    }
    try {
      const cp = await fetchCusVenCpById(cpId);
      if (cp?.contactPerName) {
        setCusVenCpCache((prev) => ({
          ...prev,
          [cpId]: cp.contactPerName,
        }));
        return cp.contactPerName;
      }
    } catch (err) {
      console.error("Failed to fetch CP:", cpId, err);
    }
    return cpId;
  };

  // Add this function near your other helper functions
  const fetchContactNames = useCallback(
    async (contactGuids) => {
      if (!contactGuids || contactGuids.length === 0) return {};

      // Filter out GUIDs we already have in cache
      const guidsToFetch = contactGuids.filter(
        (guid) =>
          guid &&
          !contactNamesCache[guid] &&
          guid.match(
            /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
          ),
      );

      if (guidsToFetch.length === 0) return contactNamesCache;

      try {
        const contactGuidsString = guidsToFetch.join(",");
        const contacts = await getContactNames(guidsToFetch);

        const newCache = { ...contactNamesCache };
        contacts.forEach((contact) => {
          if (contact.contactGuid && contact.contactName) {
            newCache[contact.contactGuid.toLowerCase()] = contact.contactName;
          }
        });

        setContactNamesCache(newCache);
        return newCache;
      } catch (error) {
        console.error("Failed to fetch contact names:", error);
        return contactNamesCache;
      }
    },
    [contactNamesCache],
  );

  // Add this helper function
  const resolveContactName = (guid) => {
    if (!guid) return "N/A";

    // Check if it's a GUID format
    const isGuid = guid.match(
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i,
    );

    if (isGuid) {
      const contactName = contactNamesCache[guid.toLowerCase()];
      if (contactName) {
        return contactName;
      }
      // If not found in cache, return truncated GUID
      return guid.substring(0, 8);
    }

    // If it starts with CVCP, check the cusVenCpCache
    if (guid.startsWith("CVCP")) {
      return cusVenCpCache[guid] || guid;
    }

    // If not a GUID, return as is (might be a resource ID or other identifier)
    return guid;
  };

  // Replace the existing resolveAssigneeName function with this improved version
  const resolveAssigneeName = (ids) => {
    if (!ids) return "N/A";

    const idArray =
      typeof ids === "string" ? ids.split(",").map((i) => i.trim()) : ids;

    return idArray
      .map((id) => {
        // Handle client/partner contacts (CVCP prefix)
        if (id.startsWith("CVCP")) {
          return cusVenCpCache[id] || id;
        }
        // Handle team members - lookup in teamMemberDetails
        const match = teamMemberDetails.find(
          (user) => String(user.userId) === String(id),
        );
        if (match) {
          return match.username;
        }
        // Also try to find in resourcesByOrg as fallback
        const resourceMatch = resourcesByOrg.find(
          (res) => String(res.resourceId) === String(id),
        );
        if (resourceMatch) {
          return resourceMatch.name;
        }
        return id;
      })
      .join(", ");
  };

  // Add this function near other helper functions
  const getTicketAssigneeName = (assignment) => {
    if (!assignment) return "Unassigned";

    // Try to find in team members first
    const userDetail = teamMemberDetails.find(
      (user) => String(user.userId) === String(assignment.assignedUserId),
    );

    if (userDetail) return userDetail.username;

    // Try resources by org
    const resourceMatch = resourcesByOrg.find(
      (res) => String(res.resourceId) === String(assignment.assignedUserId),
    );

    if (resourceMatch) return resourceMatch.name;

    return assignment.assignedUserId;
  };

  // Handle edit ticket - opens the TicketEditModal
  const handleEditTicket = (ticket) => {
    setSelectedTicketForEdit(ticket);
    setShowTicketEditModal(true);
  };

  // Handle close ticket edit modal
  const handleCloseTicketEditModal = () => {
    setShowTicketEditModal(false);
    setSelectedTicketForEdit(null);
  };

  // Refresh tickets after update
  const refreshTickets = () => {
    loadProjectTickets();
  };

  const currentProjectOption = project
    ? {
        value: project.projectId,
        label: `${project.prTitle} (${project.projectId})`,
      }
    : null;

  // =========================================================================
  // WORKFLOW TAB FUNCTIONS
  // =========================================================================

  // Load task templates
  const loadTemplates = async () => {
    if (!orgId) return;

    setTemplatesLoading(true);
    try {
      const templatesData = await getTemplatesByOrg(orgId);
      console.log("Loaded templates:", templatesData);
      setTemplates(templatesData || []);
    } catch (error) {
      console.error("Error loading templates:", error);
      toast.error("Failed to load task templates");
      setTemplates([]);
    } finally {
      setTemplatesLoading(false);
    }
  };

  // Task Template Handlers
  const handleCreateTemplate = () => {
    setSelectedTemplate(null);
    setShowTemplateModal(true);
  };

  const handleEditTemplate = (template) => {
    setSelectedTemplate(template);
    setShowTemplateModal(true);
  };

  const handleDeleteTemplate = async (templateId) => {
    if (window.confirm("Are you sure you want to delete this template?")) {
      try {
        await deleteTaskTemplate(templateId);
        toast.success("Template deleted successfully");
        loadTemplates();
      } catch (error) {
        console.error("Error deleting template:", error);
        toast.error("Failed to delete template");
      }
    }
  };

  const handleTemplateSaved = () => {
    loadTemplates();
  };

  // =========================================================================
  // PARTNER TAB FUNCTIONS
  // =========================================================================

  // Load partners for the project
  const loadProjectPartners = async () => {
    if (!projectId) return;

    setPartnersLoading(true);
    try {
      const partnersData = await getPartnersByProject(projectId);
      console.log("Loaded project partners:", partnersData);
      setPartners(partnersData || []);
    } catch (error) {
      console.error("Error loading project partners:", error);
      toast.error("Failed to load project partners");
      setPartners([]);
    } finally {
      setPartnersLoading(false);
    }
  };

  // Partner modal handlers
  const handleCreatePartner = () => {
    setEditingPartner(null);
    setShowPartnerModal(true);
  };

  const handleEditPartner = (partner) => {
    setEditingPartner(partner);
    setShowPartnerModal(true);
  };

  const handleClosePartnerModal = () => {
    setShowPartnerModal(false);
    setEditingPartner(null);
  };

  const handlePartnerSaved = () => {
    loadProjectPartners();
    handleClosePartnerModal();
  };

  const fetchVendorIfNeeded = async (vendorCode) => {
    if (!vendorCode) return;

    // Already fetched → skip API
    if (vendorMap[vendorCode]) return;

    try {
      const vendor = await getVendorById(vendorCode);

      setVendorMap((prev) => ({
        ...prev,
        [vendorCode]: vendor,
      }));
    } catch (error) {
      console.error(`Failed to fetch vendor ${vendorCode}`, error);

      // fallback so UI does not break
      setVendorMap((prev) => ({
        ...prev,
        [vendorCode]: {
          name: vendorCode,
          vendorCode,
        },
      }));
    }
  };

  useEffect(() => {
    if (partners && partners.length > 0) {
      partners.forEach((partner) => {
        // partner.partnerName actually contains vendorCode
        fetchVendorIfNeeded(partner.partnerName);
      });
    }
  }, [partners]);

  const fetchVendorContactsIfNeeded = async (vendorCode) => {
    if (!vendorCode) return;

    // already fetched → skip
    if (vendorContactsMap[vendorCode]) return;

    try {
      setLoadingVendorContacts((prev) => ({
        ...prev,
        [vendorCode]: true,
      }));

      const contacts = await fetchCusVenCpByCusVenType(vendorCode);

      setVendorContactsMap((prev) => ({
        ...prev,
        [vendorCode]: Array.isArray(contacts) ? contacts : [],
      }));
    } catch (error) {
      console.error("Error fetching vendor contacts:", error);

      setVendorContactsMap((prev) => ({
        ...prev,
        [vendorCode]: [],
      }));
    } finally {
      setLoadingVendorContacts((prev) => ({
        ...prev,
        [vendorCode]: false,
      }));
    }
  };

  useEffect(() => {
    if (partners && partners.length > 0) {
      partners.forEach((partner) => {
        // partner.partnerName = vendorCode
        fetchVendorContactsIfNeeded(partner.partnerName);
      });
    }
  }, [partners]);

  // =========================================================================
  // COMMERCIALS TAB FUNCTIONS
  // =========================================================================

  // Load commercials for the project
  const loadProjectCommercials = async () => {
    if (!projectId) return;

    setCommercialsLoading(true);
    try {
      const commercialsData = await getCommercialsByProject(projectId);
      console.log("Loaded project commercials:", commercialsData);
      setCommercials(commercialsData || []);
    } catch (error) {
      console.error("Error loading project commercials:", error);
      toast.error("Failed to load project commercials");
      setCommercials([]);
    } finally {
      setCommercialsLoading(false);
    }
  };

  // Commercial modal handlers
  const handleCreateCommercial = () => {
    setEditingCommercial(null);
    setShowCommercialModal(true);
  };

  const handleEditCommercial = (commercial) => {
    setEditingCommercial(commercial);
    setShowCommercialModal(true);
  };

  const handleCloseCommercialModal = () => {
    setShowCommercialModal(false);
    setEditingCommercial(null);
  };

  const handleCommercialSaved = () => {
    loadProjectCommercials();
    handleCloseCommercialModal();
  };

  // =========================================================================
  // MILESTONE TAB FUNCTIONS
  // =========================================================================

  // Function to fetch task details by IDs
  const fetchTaskDetailsByIds = async (taskIds) => {
    if (!taskIds || taskIds.length === 0) return [];

    try {
      const tasksData = await getTasksByProject(projectId);
      console.log("All project tasks:", tasksData);

      // Filter tasks to only include those in the taskIds array
      const filteredTasks = tasksData.filter((task) =>
        taskIds.includes(task.taskId),
      );
      console.log("Filtered tasks for milestone:", filteredTasks);

      return filteredTasks;
    } catch (error) {
      console.error("Error fetching task details:", error);
      return [];
    }
  };

  // Load milestones for the project
  const loadProjectMilestones = async () => {
    if (!projectId || !orgId) return;

    setMilestonesLoading(true);
    try {
      const milestonesData = await getMilestonesByProjectAndOrg(
        projectId,
        orgId,
      );
      console.log("Loaded project milestones:", milestonesData);

      // Load tasks for each milestone and calculate percentages
      if (milestonesData && milestonesData.length > 0) {
        const tasksMap = {};
        const updatedMilestones = [];

        // Fetch tasks for each milestone and calculate percentage
        for (const milestone of milestonesData) {
          let taskDetails = [];

          if (
            milestone.taskAssignedList &&
            milestone.taskAssignedList.length > 0
          ) {
            taskDetails = await fetchTaskDetailsByIds(
              milestone.taskAssignedList,
            );

            // Calculate percentage based on task status
            const totalTasks = taskDetails.length;
            const completedTasks = taskDetails.filter(
              (task) => task.taskStatus?.toLowerCase() === "completed",
            ).length;

            // Calculate percentage: (completed tasks / total tasks) * 100
            const calculatedPercentage =
              totalTasks > 0
                ? Math.round((completedTasks / totalTasks) * 100)
                : 0;

            // Update milestone with calculated percentage
            const updatedMilestone = {
              ...milestone,
              calculatedPercentage: calculatedPercentage,
              totalTasks: totalTasks,
              completedTasks: completedTasks,
            };

            updatedMilestones.push(updatedMilestone);
          } else {
            // No tasks assigned - percentage is 0
            const updatedMilestone = {
              ...milestone,
              calculatedPercentage: 0,
              totalTasks: 0,
              completedTasks: 0,
            };
            updatedMilestones.push(updatedMilestone);
          }

          tasksMap[milestone.milestoneMavroId] = taskDetails;
        }

        setMilestones(updatedMilestones);
        setMilestoneTasks(tasksMap);
      } else {
        setMilestones(milestonesData || []);
      }
    } catch (error) {
      console.error("Error loading project milestones:", error);
      toast.error("Failed to load project milestones");
      setMilestones([]);
    } finally {
      setMilestonesLoading(false);
    }
  };

  // Milestone modal handlers
  const handleCreateMilestone = () => {
    setEditingMilestone(null);
    setShowMilestoneModal(true);
  };

  const handleEditMilestone = (milestone) => {
    setEditingMilestone(milestone);
    setShowMilestoneModal(true);
  };

  const handleCloseMilestoneModal = () => {
    setShowMilestoneModal(false);
    setEditingMilestone(null);
  };

  const handleMilestoneSaved = () => {
    loadProjectMilestones();
    handleCloseMilestoneModal();
  };

  // Toggle milestone expansion
  const toggleMilestoneExpand = (milestoneId) => {
    setExpandedMilestones((prev) => ({
      ...prev,
      [milestoneId]: !prev[milestoneId],
    }));
  };

  // =========================================================================
  // RESOURCE ALLOCATION TAB FUNCTIONS
  // =========================================================================

  // Load resources for the project
  const loadProjectResources = async () => {
    if (!projectId) return;

    setResourcesLoading(true);
    try {
      const resourcesData = await fetchResourcesByProject(projectId);
      console.log("Loaded project resources:", resourcesData);
      setResources(resourcesData || []);
    } catch (error) {
      console.error("Error loading project resources:", error);
      toast.error("Failed to load project resources");
      setResources([]);
    } finally {
      setResourcesLoading(false);
    }
  };

  // Resource modal handlers
  const handleCreateResource = () => {
    setEditingResource(null);
    setShowResourceModal(true);
  };

  const handleEditResource = (resource) => {
    setEditingResource(resource);
    setShowResourceModal(true);
  };

  const handleCloseResourceModal = () => {
    setShowResourceModal(false);
    setEditingResource(null);
  };

  const handleResourceSaved = () => {
    loadProjectResources();
    handleCloseResourceModal();
    setActiveTab("resourceAllocation");
  };

  // Handle resource deletion
  const handleDeleteResource = async (resourceId) => {
    if (window.confirm("Are you sure you want to delete this resource?")) {
      try {
        await deleteResource(resourceId);
        toast.success("Resource deleted successfully");
        loadProjectResources();
      } catch (error) {
        console.error("Error deleting resource:", error);
        toast.error("Failed to delete resource");
      }
    }
  };

  // Fetch resource details by ID
  const fetchResourceDetails = async (resourceId) => {
    if (!resourceId || resourceDetails[resourceId]) return;

    try {
      setLoadingResourceDetails((prev) => ({
        ...prev,
        [resourceId]: true,
      }));

      const response = await fetchResourceById(resourceId);
      console.log(`Fetched resource details for ${resourceId}:`, response);

      if (response) {
        setResourceDetails((prev) => ({
          ...prev,
          [resourceId]: response,
        }));
      }
    } catch (error) {
      console.error(
        `Error fetching resource details for ${resourceId}:`,
        error,
      );
      // Set a fallback object if fetch fails
      setResourceDetails((prev) => ({
        ...prev,
        [resourceId]: { name: resourceId, role: "Unknown" },
      }));
    } finally {
      setLoadingResourceDetails((prev) => ({
        ...prev,
        [resourceId]: false,
      }));
    }
  };

  // =========================================================================
  // DOCUMENTS TAB FUNCTIONS
  // =========================================================================

  // Load documents for the project
  const loadProjectDocuments = async () => {
    if (!projectId) return;

    setDocumentsLoading(true);
    try {
      const documentsData = await getDocumentsByProject(projectId);
      console.log("Loaded project documents:", documentsData);
      setDocuments(documentsData || []);
    } catch (error) {
      console.error("Error loading project documents:", error);
      toast.error("Failed to load project documents");
      setDocuments([]);
    } finally {
      setDocumentsLoading(false);
    }
  };

  const handleUploadDocuments = async () => {
    if (selectedFiles.length === 0) {
      toast.error("Please select at least one file to upload");
      return;
    }

    if (!documentTitle.trim()) {
      toast.error("Please enter a document title");
      return;
    }

    if (!documentType) {
      toast.error("Please select a document type");
      return;
    }

    setUploadingDocuments(true);
    try {
      // Validate files
      for (const file of selectedFiles) {
        const validation = validateFile(file, 25);
        if (!validation.isValid) {
          toast.error(`Invalid file: ${file.name} - ${validation.error}`);
          return;
        }
      }

      const userDetails = JSON.parse(localStorage.getItem("userDetails"));
      const createdBy = userDetails?.userId || "unknown";

      // Updated API call with title and type
      await uploadMultipleProjectDocuments(
        orgId,
        projectId,
        createdBy,
        selectedFiles,
        documentTitle,
        documentType,
      );

      toast.success(
        `${selectedFiles.length} document(s) uploaded successfully`,
      );
      setSelectedFiles([]);
      setDocumentTitle("");
      setDocumentType("");
      setShowUploadModal(false);
      loadProjectDocuments();
    } catch (error) {
      console.error("Error uploading documents:", error);
      toast.error("Failed to upload documents");
    } finally {
      setUploadingDocuments(false);
    }
  };

  const getFileNameFromHeaders = (headers, fallback = "download") => {
    const cd = headers["content-disposition"] || headers["Content-Disposition"];
    if (!cd) return fallback;

    // Example: attachment; filename="file.xlsx"; filename*=UTF-8''file.xlsx
    const filenameStarMatch = cd.match(/filename\*\=([^;]+)/i);
    if (filenameStarMatch) {
      try {
        const value = filenameStarMatch[1].trim(); // UTF-8''name
        const idx = value.indexOf("''");
        if (idx !== -1) {
          return decodeURIComponent(value.substring(idx + 2));
        }
        return decodeURIComponent(value.replace(/^UTF-8''/i, ""));
      } catch (_) {
        /* ignore decode errors */
      }
    }

    const filenameMatch = cd.match(/filename\=\"?([^\";]+)\"?/i);
    if (filenameMatch) return filenameMatch[1];

    return fallback;
  };

  // Handle document download
  // Handle document download
  const handleDownloadDocument = async (doc) => {
    try {
      toast.info("Downloading document...");

      // If you have a utility that already does this correctly, keep it.
      // Otherwise, do the robust approach below:
      const response = await downloadDocument(doc.documentId);

      // 1) Extract filename from headers, fallback to title, keep extension if any
      const serverFileName = getFileNameFromHeaders(
        response.headers,
        doc.documentTitle || "document",
      );
      // 2) Use the server content-type to create a proper Blob
      const contentType =
        response.headers["content-type"] ||
        response.headers["Content-Type"] ||
        "application/octet-stream";

      const blob = new Blob([response.data], { type: contentType });

      // 3) Create link and trigger download
      const url = window.URL.createObjectURL(blob);
      const a = window.document.createElement("a"); // IMPORTANT: window.document (not the param)
      a.href = url;
      a.download = serverFileName;
      window.document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);

      toast.success("Document downloaded successfully");
    } catch (error) {
      console.error("Error downloading document:", error);
      toast.error("Failed to download document. Please try again.");
    }
  };

  // Handle document deletion
  const handleDeleteDocument = async (documentId, documentTitle) => {
    if (window.confirm(`Are you sure you want to delete "${documentTitle}"?`)) {
      try {
        await deleteDocumentWithFile(documentId);
        toast.success("Document deleted successfully");
        loadProjectDocuments(); // Refresh the documents list
      } catch (error) {
        console.error("Error deleting document:", error);
        toast.error("Failed to delete document");
      }
    }
  };

  // Handle file selection
  const handleFileSelect = (event) => {
    const files = Array.from(event.target.files);
    setSelectedFiles(files);
  };

  // =========================================================================
  // HELPER FUNCTIONS
  // =========================================================================

  // Helper function to get status description by ID
  const getStatusDescription = (statusId) => {
    if (!statusId) return "Not set";
    const status = projectStatuses.find((s) => s.projectStatusId === statusId);
    return status ? status.projectStatusDesc : statusId;
  };

  // Helper function to get resource name by ID
  const getResourceNameById = (resourceId) => {
    if (!resourceId) return "Not assigned";
    const resource = resourcesByOrg.find(
      (res) => res.resourceId === resourceId,
    );
    return resource ? resource.name : resourceId;
  };

  // Helper function to get user display info
  const getUserDisplayInfo = (userId) => {
    const userDetail = teamMemberDetails.find(
      (user) => user.userId === parseInt(userId),
    );
    if (userDetail) {
      console.log("User Detail Found:", userDetail);
      return {
        name: userDetail.username,
        email: userDetail.email,
      };
    }
    return {
      name: "Unknown User",
      email: "No email",
      role: "Team Member",
    };
  };

  // Helper function to parse partner roles from JSON
  const parsePartnerRoles = (partnerRole) => {
    try {
      if (typeof partnerRole === "string") {
        return JSON.parse(partnerRole);
      }
      return partnerRole || [];
    } catch (error) {
      console.error("Error parsing partner roles:", error);
      return [];
    }
  };

  // Helper function to format roles for display
  const formatRoles = (roles) => {
    if (Array.isArray(roles)) {
      return roles.join(", ");
    }
    return roles || "No roles assigned";
  };

  // Helper function to get field display name
  const getFieldDisplayName = (fieldName) => {
    const fieldConfig = availableFields.find((f) => f.field === fieldName);
    return fieldConfig?.displayName || fieldName;
  };

  // Format currency for display
  const formatCurrencyDisplay = (amount, currency) => {
    if (!amount) return "-";

    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount)) return amount;

    const formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
      minimumFractionDigits: 2,
    });

    return formatter.format(numericAmount);
  };

  // Format date for display
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("MMM DD, YYYY");
  };

  // Format datetime for display
  const formatDateTime = (dateString) => {
    if (!dateString) return "-";
    return moment(dateString).format("MMM DD, YYYY HH:mm");
  };

  // Status badge helpers - update to handle GUIDs
  const getStatusBadge = (statusId) => {
    // If it's a GUID (looks like UUID format), get the status name first
    let statusDesc = statusId;

    // Check if it's a UUID (GUID) format
    const isGuid =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
        statusId,
      );

    if (isGuid) {
      // It's a GUID, get the status name from the map
      statusDesc = getTaskStatusName(statusId);
    } else {
      // It's a status description, get it from project statuses
      const status = projectStatuses.find(
        (s) => s.projectStatusId === statusId,
      );
      statusDesc = status ? status.projectStatusDesc : statusId;
    }

    const statusMap = {
      // Status descriptions
      Idea: "project-view-status-pending",
      Discussion: "project-view-status-pending",
      Proposal: "project-view-status-pending",
      Dev: "project-view-status-active",
      SIT: "project-view-status-active",
      UAT: "project-view-status-active",
      "Go-Live": "project-view-status-active",
      Hypercare: "project-view-status-active",
      Closed: "project-view-status-completed",
      Cancelled: "project-view-status-pending",

      // Status names from task statuses
      New: "project-view-status-pending",
      "Not Started": "project-view-status-pending",
      "In Progress": "project-view-status-active",
      "Dev in Progress": "project-view-status-active",
      "UAT In Progress": "project-view-status-active",
      "Ready for PRD": "project-view-status-active",
      "Moved to PRD": "project-view-status-completed",
      Completed: "project-view-status-completed",
      "On Hold": "project-view-status-pending",
      Cancelled: "project-view-status-pending",

      // Legacy status mappings (keep for backward compatibility)
      Active: "project-view-status-active",
      Completed: "project-view-status-completed",
      Pending: "project-view-status-pending",
      "In Progress": "project-view-status-active",
      open: "project-view-status-active",
      closed: "project-view-status-completed",
      resolved: "project-view-status-completed",
      "in progress": "project-view-status-active",
    };

    return statusMap[statusDesc] || "project-view-status-pending";
  };

  const getPriorityBadge = (priority) => {
    const priorityMap = {
      High: "priority-high",
      Medium: "project-view-priority-medium",
      Low: "project-view-priority-low",
      high: "priority-high",
      medium: "project-view-priority-medium",
      low: "project-view-priority-low",
    };
    return priorityMap[priority] || "project-view-priority-medium";
  };

  // Helper function for resource status badges
  const getResourceStatusBadge = (status) => {
    const statusMap = {
      Active: "bg-success",
      "In Progress": "bg-primary",
      Completed: "bg-secondary",
      "On Hold": "bg-warning",
      Inactive: "bg-danger",
    };
    return statusMap[status] || "bg-secondary";
  };

  // Update the tab click handlers in ProjectView.jsx
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    // Update URL without reloading the page
    const searchParams = new URLSearchParams(location.search);
    searchParams.set("tab", tab);
    navigate(`${location.pathname}?${searchParams.toString()}`, {
      replace: true,
    });
  };

  // =========================================================================
  // USE EFFECT HOOKS
  // =========================================================================

  // In ProjectView.jsx, add this useEffect to read tab from URL
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tabFromUrl = searchParams.get("tab");
    if (
      tabFromUrl &&
      [
        "overview",
        "remarks",
        "tasks",
        "board",
        "gantt",
        "BuildingBlock",
        "team",
        "ticket",
        "resourceAllocation",
        "commercials",
        "workflow",
        "partner",
        "milestone",
        "documents",
        "budget",
        "settings",
        "events",
        "sprint",
      ].includes(tabFromUrl)
    ) {
      setActiveTab(tabFromUrl);
    }
  }, [location.search]);

  // Load project types and meta names on mount
  useEffect(() => {
    if (orgId) {
      fetchProjectTypesListNew();
      // Fetch meta names for all possible values
    }
  }, [orgId]);

  // Fetch user's contact GUID when component mounts
  useEffect(() => {
    if (orgId && userId) {
      fetchUserContactGuid();
    }
  }, [orgId, userId]);

  // Fetch meta names for the project's specific GUIDs when project loads
  useEffect(() => {
    if (project && orgId) {
      const typeGuid = project.prTypes;
      const statusGuid = project.projectStatus;
      const subStatusGuid = project.projectSubStatus;

      // Collect non-null GUIDs
      const typeGuids = typeGuid ? [typeGuid] : [];
      const statusGuids = statusGuid ? [statusGuid] : [];
      const subStatusGuids = subStatusGuid ? [subStatusGuid] : [];

      if (
        typeGuids.length > 0 ||
        statusGuids.length > 0 ||
        subStatusGuids.length > 0
      ) {
        const typeGuidsStr = typeGuids.length > 0 ? typeGuids.join(",") : null;
        const statusGuidsStr =
          statusGuids.length > 0 ? statusGuids.join(",") : null;
        const subStatusGuidsStr =
          subStatusGuids.length > 0 ? subStatusGuids.join(",") : null;

        fetchProjectMetaNames(typeGuidsStr, statusGuidsStr, subStatusGuidsStr);
      }
    }
  }, [
    project?.prTypes,
    project?.projectStatus,
    project?.projectSubStatus,
    orgId,
  ]);

  // Load statuses when project type changes (for editing existing project)
  useEffect(() => {
    if (project?.prTypes) {
      fetchProjectStatusesList(project.prTypes);

      // If project has a status, load sub-statuses
      if (project?.projectStatus) {
        fetchProjectSubStatusesList(project.prTypes, project.projectStatus);
      }
    }
  }, [project?.prTypes]);

  // Load sub-statuses when status changes (for editing)
  useEffect(() => {
    if (project?.prTypes && project?.projectStatus) {
      fetchProjectSubStatusesList(project.prTypes, project.projectStatus);
    }
  }, [project?.projectStatus]);

  // INITIAL LOAD EFFECTS
  useEffect(() => {
    loadProjectDetails();
  }, [projectId]);

  useEffect(() => {
    loadProjectStatuses();
  }, []);

  useEffect(() => {
    if (orgId) {
      loadCustomers();
      loadTeams();
      fetchProjectTypesList();
      loadResourcesByOrg();
    }
  }, [orgId]);

  // OVERVIEW TAB EFFECTS
  useEffect(() => {
    if (project?.prTypes) {
      fetchProjectTypeDescription(project.prTypes);
    }
  }, [project?.prTypes]);

  useEffect(() => {
    if (project?.prClient && customers.length > 0) {
      const customer = customers.find(
        (cust) => cust.customerCode === project.prClient,
      );
      if (customer) {
        setSelectedCustomerName(customer.name);
      } else {
        setSelectedCustomerName(project.prClient);
      }
    } else if (project?.prClient) {
      setSelectedCustomerName(project.prClient);
    } else {
      setSelectedCustomerName("");
    }
  }, [project?.prClient, customers]);

  useEffect(() => {
    if (project) {
      // Fetch project manager name
      if (project.currentProjectManager) {
        fetchProjectManagerName(project.currentProjectManager);
      } else {
        setProjectManagerName("Not assigned");
      }

      // Fetch salesperson name
      if (project.salespersonCode) {
        fetchSalespersonName(project.salespersonCode);
      } else {
        setSalespersonName("Not assigned");
      }
    }
  }, [project]);

  useEffect(() => {
    const fetchTeamData = async () => {
      console.log("inside fetch team data useEffect");
      console.log("project.teamAssigned:", project?.teamAssigned);

      if (project?.teamAssigned) {
        try {
          const teamData = await getTeamById(project.teamAssigned);
          console.log("Fetched team data:", teamData);
          setTeamData(teamData);

          // Fetch user details for team members
          if (teamData.teamMembers && teamData.teamMembers.length > 0) {
            await fetchTeamMemberDetails(teamData.teamMembers);
          } else {
            setTeamMemberDetails([]);
          }
        } catch (error) {
          console.error("Error fetching team data:", error);
          setTeamData(null);
          setTeamMemberDetails([]);
        }
      } else {
        console.log("No teamAssigned found in project data");
        setTeamData(null);
        setTeamMemberDetails([]);
      }
    };

    fetchTeamData();
  }, [project?.teamAssigned]);

  // TASKS TAB EFFECTS
  // TASKS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "tasks" && project?.projectId) {
      loadProjectStages(); // Always load stages when on tasks tab
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "tasks" && project?.projectId) {
      if (stages.length > 0) {
        loadProjectTasksByStages();
      } else {
        // If no stages exist, load tasks directly
        loadProjectTasks();
      }
    }
  }, [activeTab, stages, project?.projectId]);

  // useEffect(() => {
  //   if (!tasks || tasks.length === 0) return;

  //   tasks.forEach((task) => {
  //     if (task.taskTicketFor) {
  //       loadTicketName(task.taskTicketFor);
  //     }
  //   });
  // }, [tasks]);

  useEffect(() => {
    if (activeTab === "gantt" && project?.projectId) {
      loadProjectStages();
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "gantt" && stages.length > 0) {
      loadProjectTasksByStages();
    }
  }, [activeTab, stages]);

  // const filteredGanttTasks = ganttTasks.filter((task) => {
  //   if (task.type === "project") return true;

  //   const stageId = task.project?.replace("stage-", "");
  //   return !collapsedStages[stageId];
  // });

  useEffect(() => {
    if (!stages || stages.length === 0) return;

    setCollapsedStages((prev) => {
      if (Object.keys(prev).length > 0) return prev;

      const initial = {};
      stages.forEach((stage) => {
        initial[stage.stageId] = false;
      });

      return initial;
    });
  }, [stages]);

  useEffect(() => {
    if (!filteredStageTasks || Object.keys(filteredStageTasks).length === 0) {
      setGanttTasks([]);
      return;
    }

    const transformed = [];

    Object.keys(filteredStageTasks).forEach((stageId) => {
      const stage = stages.find((s) => s.stageId === stageId);

      // Skip if stage not found (except "no-stage")
      if (!stage && stageId !== "no-stage") return;

      let stageStart = null;
      let stageEnd = null;

      if (stage) {
        stageStart = new Date(stage.stageStartDateTime);
        stageEnd = new Date(stage.stageEndDateTime);

        if (!isNaN(stageStart) && !isNaN(stageEnd)) {
          transformed.push({
            id: `stage-${stageId}`,
            name: stage.stageName || "Stage",
            type: "project",
            start: stageStart,
            end: stageEnd,
            progress: 0,
            hideChildren: collapsedStages[stageId] || false,
          });
        }
      }

      (filteredStageTasks[stageId] || []).forEach((task) => {
        if (!task.taskStartDate || !task.taskEndDate) return;

        const taskStart = new Date(task.taskStartDate);
        const taskEnd = new Date(task.taskEndDate);

        if (isNaN(taskStart) || isNaN(taskEnd)) return;

        transformed.push({
          id: task.taskId,
          name: task.taskName,
          start: taskStart,
          end: taskEnd,
          progress: task.taskStatus === "Completed" ? 100 : 50,
          dependencies: task.dependsOn ? task.dependsOn.split(",") : [],
          project: stage ? `stage-${stageId}` : undefined,

          // 🔥 ADD THESE
          taskStatus: task.taskStatus,
          taskPriority: task.taskPriority,
          assignedTo: String(task.assignedTo),

          styles: getGanttTaskStyleByStatus(task.taskStatus),
        });

        // transformed.push({
        //   id: task.taskId,
        //   name: task.taskName,
        //   start: taskStart,
        //   end: taskEnd,
        //   progress: task.taskStatus === "Completed" ? 100 : 50,
        //   dependencies: task.dependsOn ? task.dependsOn.split(",") : [],
        //   project: stage ? `stage-${stageId}` : undefined,
        //   styles: getGanttTaskStyleByStatus(task.taskStatus),
        // });
      });
    });

    setGanttTasks(transformed);
  }, [filteredStageTasks, stages, collapsedStages]);

  // TICKET TAB EFFECTS
  useEffect(() => {
    if (activeTab === "ticket" && project?.projectId) {
      loadProjectTickets();
    }
  }, [activeTab, project?.projectId]);

  // Load ticket dropdown data and status master data when orgId changes
  useEffect(() => {
    if (orgId) {
      loadTicketDropdownData();
      loadTicketStatusMasterData();
    }
  }, [orgId]);

  useEffect(() => {
    if (activeTab === "remarks" && projectId) {
      loadProjectRemarks();
    }
  }, [activeTab, projectId]);

  useEffect(() => {
    if (!tasks || tasks.length === 0) return;

    tasks.forEach((task) => {
      if (task.taskTicketFor) {
        loadTicketName(task.taskTicketFor);
      }

      if (task.taskEventFor) {
        loadEventName(task.taskEventFor);
      }
    });
  }, [tasks]);

  useEffect(() => {
    if (!tickets || tickets.length === 0) return;

    const map = {};

    tickets.forEach((ticket) => {
      map[ticket.ticketId] = ticket.ticketName;
    });

    setTicketNameMap(map);
  }, [tickets]);

  // Add this useEffect
  useEffect(() => {
    if (orgId) {
      loadAllTaskStatuses();
    }
  }, [orgId]);

  // WORKFLOW TAB EFFECTS
  useEffect(() => {
    if (activeTab === "workflow" && orgId) {
      loadTemplates();
    }
  }, [activeTab, orgId]);

  // Add this useEffect near other project loading effects
  useEffect(() => {
    if (project?.projectId) {
      loadProjectContacts(project.projectId);
      loadProjectAssigneeOptions(project.projectId); // Add this line
    }
  }, [project?.projectId]);

  useEffect(() => {
    if (activeTab === "board" && project?.projectId) {
      loadProjectStages();
    }
  }, [activeTab, project?.projectId]);

  useEffect(() => {
    if (activeTab === "board" && stages.length > 0) {
      loadProjectTasksByStages();
    }
  }, [activeTab, stages]);

  // PARTNER TAB EFFECTS
  useEffect(() => {
    if (activeTab === "partner" && orgId && projectId) {
      loadProjectPartners();
    }
  }, [activeTab, orgId, projectId]);

  // COMMERCIALS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "commercials" && projectId) {
      loadProjectCommercials();
    }
  }, [activeTab, projectId]);

  // MILESTONE TAB EFFECTS
  useEffect(() => {
    if (activeTab === "milestone" && projectId && orgId) {
      loadProjectMilestones();
    }
  }, [activeTab, projectId, orgId]);

  // RESOURCE ALLOCATION TAB EFFECTS
  useEffect(() => {
    if (activeTab === "resourceAllocation" && projectId) {
      loadProjectResources();
    }
  }, [activeTab, projectId]);

  // DOCUMENTS TAB EFFECTS
  useEffect(() => {
    if (activeTab === "documents" && projectId) {
      loadProjectDocuments();
    }
  }, [activeTab, projectId]);

  // Load task types when component mounts
  useEffect(() => {
    if (orgId) {
      loadAllTaskTypes();
    }
  }, [orgId]);

  // =========================================================================
  // RENDER COMPONENTS
  // =========================================================================

  // Milestone Tasks Component
  const MilestoneTasks = ({ tasks, milestoneId }) => {
    if (!tasks || tasks.length === 0) {
      return (
        <div className="text-center py-3 text-muted">
          <small>No tasks assigned to this milestone</small>
        </div>
      );
    }

    return (
      <div className="project-view-milestone-tasks-container">
        <div className="milestone-tasks-list">
          {tasks.map((task) => (
            <div key={task.taskId} className="project-view-milestone-task-item">
              <div className="milestone-task-main">
                <div className="milestone-task-name">
                  <strong>{task.taskName}</strong>
                </div>
                <div className="milestone-task-meta">
                  <span
                    className={`project-view-task-status-badge ${getStatusBadge(
                      task.taskStatus,
                    )}`}
                  >
                    {task.taskStatus}
                  </span>
                  <span
                    className={`project-view-task-priority-badge ${getPriorityBadge(
                      task.taskPriority,
                    )}`}
                  >
                    {task.taskPriority}
                  </span>
                </div>
              </div>
              <div className="milestone-task-details">
                <small className="text-muted">
                  {task.taskDescription
                    ? task.taskDescription.length > 100
                      ? `${task.taskDescription.substring(0, 100)}...`
                      : task.taskDescription
                    : "No description"}
                </small>
              </div>
              <div className="milestone-task-dates">
                <small>
                  Start: {formatDate(task.taskStartDate)} | End:{" "}
                  {formatDate(task.taskEndDate)}
                </small>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  // Loading and Error States
  if (loading) {
    return (
      <div className="project-view-container">
        <Container>
          <div className="text-center text-white">
            <h3>Loading Project Details...</h3>
          </div>
        </Container>
      </div>
    );
  }

  if (!project) {
    return (
      <div className="project-view-container">
        <Container>
          <div className="text-center text-white">
            <h3>Project Not Found</h3>
            <Button variant="light" onClick={() => navigate(-1)}>
              Go Back
            </Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="project-view-container">
      <Container fluid>
        {/* Project Header */}
        <div className="project-view-card project-view-fade-in">
          <ProjectHeader
            project={project}
            originalProject={originalProject}
            isEditing={isEditing}
            saving={saving}
            hasEditPermission={hasEditPermission}
            handleFieldChange={handleFieldChange}
            handleSave={handleSave}
            handleCancel={handleCancel}
            handleToggleFavorite={handleToggleFavorite}
            setIsEditing={setIsEditing}
            navigate={navigate}
          />

          {/* Tabs Navigation */}
          <div className="project-view-tabs">
            <ul className="project-tab-nav">
              <li
                className={`project-tab-item ${
                  activeTab === "overview" ? "active" : ""
                }`}
                onClick={() => setActiveTab("overview")}
              >
                <i className="fas fa-chart-pie me-2"></i>
                Overview
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "remarks" ? "active" : ""
                }`}
                onClick={() => setActiveTab("remarks")}
              >
                Comments
              </li>
              <li
                className={`project-tab-item ${activeTab === "tasks" ? "active" : ""}`}
                onClick={() => handleTabChange("tasks")}
              >
                Task List
              </li>
              <li
                className={`project-tab-item ${activeTab === "events" ? "active" : ""}`}
                onClick={() => setActiveTab("events")}
              >
                Events
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "board" ? "active" : ""
                }`}
                onClick={() => setActiveTab("board")}
              >
                Board
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "sprint" ? "active" : ""
                }`}
                onClick={() => setActiveTab("sprint")}
              >
                Sprint
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "gantt" ? "active" : ""
                }`}
                onClick={() => setActiveTab("gantt")}
              >
                {/* <MdAddChart className="me-2" /> */}
                Gantt
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "BuildingBlock" ? "active" : ""
                }`}
                onClick={() => setActiveTab("BuildingBlock")}
              >
                Building Block
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "team" ? "active" : ""
                }`}
                onClick={() => setActiveTab("team")}
              >
                Team
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "ticket" ? "active" : ""
                }`}
                onClick={() => setActiveTab("ticket")}
              >
                Ticket
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "resourceAllocation" ? "active" : ""
                }`}
                onClick={() => setActiveTab("resourceAllocation")}
              >
                Resource Allocation
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "commercials" ? "active" : ""
                }`}
                onClick={() => setActiveTab("commercials")}
              >
                Commercials
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "workflow" ? "active" : ""
                }`}
                onClick={() => setActiveTab("workflow")}
              >
                Workflow
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "partner" ? "active" : ""
                }`}
                onClick={() => setActiveTab("partner")}
              >
                Partner
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "milestone" ? "active" : ""
                }`}
                onClick={() => setActiveTab("milestone")}
              >
                Milestone
              </li>

              <li
                className={`project-tab-item ${
                  activeTab === "documents" ? "active" : ""
                }`}
                onClick={() => setActiveTab("documents")}
              >
                Documents
              </li>
              <li
                className={`project-tab-item ${
                  activeTab === "budget" ? "active" : ""
                }`}
                onClick={() => setActiveTab("budget")}
              >
                Budget
              </li>
              {hasProjectAdminRole() && (
                <li
                  className={`project-tab-item ${
                    activeTab === "settings" ? "active" : ""
                  }`}
                  onClick={() => setActiveTab("settings")}
                >
                  Settings
                </li>
              )}
            </ul>
          </div>

          {/* Tab Content */}
          <div className="project-tab-content">
            {/* In the Overview tab section, replace the Status field with this updated version */}

            {activeTab === "overview" && (
              <ProjectOverviewTab
                project={project}
                isEditing={isEditing}
                saving={saving}
                hasEditPermission={hasEditPermission}
                handleFieldChange={handleFieldChange}
                handleSave={handleSave}
                handleCancel={handleCancel}
                setIsEditing={setIsEditing}
                customers={customers}
                customersLoading={customersLoading}
                selectedCustomerName={selectedCustomerName}
                handleCustomerChange={handleCustomerChange}
                projectTypesList={projectTypesList}
                loadingProjectTypes={loadingProjectTypes}
                handleProjectTypeChangeForStatus={
                  handleProjectTypeChangeForStatus
                }
                getProjectTypeDisplayName={getProjectTypeDisplayName}
                projectStatusesList={projectStatusesList}
                loadingProjectStatuses={loadingProjectStatuses}
                handleProjectStatusChangeForSubStatus={
                  handleProjectStatusChangeForSubStatus
                }
                getProjectStatusDisplayName={getProjectStatusDisplayName}
                projectSubStatusesList={projectSubStatusesList}
                loadingProjectSubStatuses={loadingProjectSubStatuses}
                handleProjectSubStatusChange={handleProjectSubStatusChange}
                getProjectSubStatusDisplayName={getProjectSubStatusDisplayName}
                resourcesByOrg={resourcesByOrg}
                resourcesByOrgLoading={resourcesByOrgLoading}
                getResourceNameById={getResourceNameById}
                teams={teams}
                teamData={teamData}
                loadingManager={loadingManager}
                loadingSalesperson={loadingSalesperson}
                getStatusBadge={getStatusBadge}
              />
            )}

            {activeTab === "board" && (
              <ProjectBoardTab
                boardGroupBy={boardGroupBy}
                setBoardGroupBy={setBoardGroupBy}
                getBoardColumns={getBoardColumns}
                getPriorityBadge={getPriorityBadge}
                getStatusBadge={getStatusBadge}
                handleEditTask={handleEditTask}
              />
            )}

            {activeTab === "gantt" && (
              <ProjectGanttTab
                finalGanttTasks={finalGanttTasks}
                stages={stages}
                viewMode={viewMode}
                columnWidth={columnWidth}
                showClosed={showClosed}
                setShowClosed={setShowClosed}
                sortBy={sortBy}
                setSortBy={setSortBy}
                showFilterPanel={showFilterPanel}
                setShowFilterPanel={setShowFilterPanel}
                filterStatus={filterStatus}
                setFilterStatus={setFilterStatus}
                filterPriority={filterPriority}
                setFilterPriority={setFilterPriority}
                filterAssignee={filterAssignee}
                setFilterAssignee={setFilterAssignee}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
                timePeriod={timePeriod}
                handleTimePeriodChange={handleTimePeriodChange}
                teamMemberDetails={teamMemberDetails}
                handleResetFilters={handleResetFilters}
                scrollToToday={scrollToToday}
                handleAutoFit={handleAutoFit}
                exportPNG={exportPNG}
                exportPDF={exportPDF}
                exportExcel={exportExcel}
                handleTaskChange={handleTaskChange}
                showStageModal={showStageModal}
                setShowStageModal={setShowStageModal}
                editingStage={editingStage}
                setEditingStage={setEditingStage}
                projectId={projectId}
                loadProjectStages={loadProjectStages}
                showTaskEditModal={showTaskEditModal}
                setShowTaskEditModal={setShowTaskEditModal}
                editingTaskId={editingTaskId}
                setEditingTaskId={setEditingTaskId}
                loadProjectTasksByStages={loadProjectTasksByStages}
                collapsedStages={collapsedStages}
                setCollapsedStages={setCollapsedStages}
              />
            )}

            {activeTab === "sprint" && (
              <SprintTab
                orgId={orgId}
                projectId={project.projectId}
                userId={userId}
              />
            )}

            {activeTab === "remarks" && (
              <ProjectRemarksTab
                remarks={remarks}
                remarksLoading={remarksLoading}
                editingRemarkId={editingRemarkId}
                editingRemarkText={editingRemarkText}
                updatingRemark={updatingRemark}
                remarkText={remarkText}
                addingRemark={addingRemark}
                hasEditPermission={hasEditPermission}
                setRemarkText={setRemarkText}
                handleAddRemark={handleAddRemark}
                startEditRemark={startEditRemark}
                cancelEditRemark={cancelEditRemark}
                setEditingRemarkText={setEditingRemarkText}
                handleUpdateRemark={handleUpdateRemark}
              />
            )}

            {activeTab === "events" && (
              <ProjectEvents orgId={orgId} projectId={projectId} />
            )}

            {activeTab === "tasks" && (
              <ProjectTasksTab
                stages={stages}
                filteredStageTasks={filteredStageTasks}
                tasksLoading={tasksLoading}
                tasksLoadingByStage={tasksLoadingByStage}
                taskAssignmentsByTask={taskAssignmentsByTask}
                teamMemberDetails={teamMemberDetails}
                resourcesByOrg={resourcesByOrg} // ✅ Add this
                clientContactPersons={clientContactPersons} // ✅ Add this
                partnerContactPersons={partnerContactPersons} // ✅ Add this
                contactNamesCache={contactNamesCache} // ✅ Add this
                setContactNamesCache={setContactNamesCache} // Add this line
                ticketNameMap={ticketNameMap}
                eventNameMap={eventNameMap}
                taskBuildingBlocks={taskBuildingBlocks}
                taskTypesLoading={taskTypesLoading}
                taskStatusesLoading={taskStatusesLoading}
                hasEditPermission={hasEditPermission}
                handleOpenTaskDetails={handleOpenTaskDetails}
                handleEditTask={handleEditTask}
                handleSoftDeleteTask={handleSoftDeleteTask}
                openTaskDialog={openTaskDialog}
                getCurrentAssignedUsersForTask={getCurrentAssignedUsersForTask}
                getTaskTypeName={getTaskTypeName}
                getTaskStatusName={getTaskStatusName}
                getPriorityBadge={getPriorityBadge}
                getStatusBadge={getStatusBadge}
                handleEditStage={handleEditStage}
                handleCreateStage={handleCreateStage}
                setShowTaskOptions={setShowTaskOptions}
                showTaskOptions={showTaskOptions}
                handleBatchCreateClick={handleBatchCreateClick}
                handleExcelUploadClick={handleExcelUploadClick}
                handleManualTaskClick={handleManualTaskClick}
                exportTasksToExcel={exportTasksToExcel}
                searchQuery={searchQuery}
                setSearchQuery={setSearchQuery}
              />
            )}

            {activeTab === "team" && (
              <ProjectTeamTab
                teamData={teamData}
                teamMemberDetails={teamMemberDetails}
                loadingTeamMembers={loadingTeamMembers}
                getUserDisplayInfo={getUserDisplayInfo}
              />
            )}

            {activeTab === "ticket" && (
              <ProjectTicketTab
                filteredTickets={filteredTickets}
                ticketsLoading={ticketsLoading}
                assignmentsByTicket={assignmentsByTicket}
                teamMemberDetails={teamMemberDetails}
                resourcesByOrg={resourcesByOrg}
                cusVenCpCache={cusVenCpCache}
                resolvedTicketNames={resolvedTicketNames}
                statusMasterData={statusMasterData}
                openTicketDialog={openTicketDialog}
                handleEditTicket={handleEditTicket}
                handleConvertToTask={handleConvertToTask}
                getStatusBadgeWithName={getStatusBadgeWithName}
                resolveSubStatusName={resolveSubStatusName}
                getPriorityBadge={getPriorityBadge}
                resolveContactName={resolveContactName}
                formatDateTime={formatDateTime}
                formatDate={formatDate}
                searchText={searchText}
                setSearchText={setSearchText}
                statusFilter={statusFilter}
                setStatusFilter={setStatusFilter}
                priorityFilter={priorityFilter}
                setPriorityFilter={setPriorityFilter}
                navigate={navigate}
                projectId={projectId}
              />
            )}

            {activeTab === "workflow" && (
              <ProjectWorkflowTab
                templates={templates}
                templatesLoading={templatesLoading}
                handleCreateTemplate={handleCreateTemplate}
                handleEditTemplate={handleEditTemplate}
                handleDeleteTemplate={handleDeleteTemplate}
                getFieldDisplayName={getFieldDisplayName}
              />
            )}

            {activeTab === "commercials" && (
              <ProjectCommercialsTab
                commercials={commercials}
                commercialsLoading={commercialsLoading}
                hasProjectAdminRole={hasProjectAdminRole}
                hasProjectManagerRole={hasProjectManagerRole}
                handleCreateCommercial={handleCreateCommercial}
                handleEditCommercial={handleEditCommercial}
                formatCurrencyDisplay={formatCurrencyDisplay}
              />
            )}

            {activeTab === "resourceAllocation" && (
              <ProjectResourceAllocationTab
                resources={resources}
                resourcesLoading={resourcesLoading}
                teamMemberDetails={teamMemberDetails}
                hasProjectAdminRole={hasProjectAdminRole}
                hasProjectManagerRole={hasProjectManagerRole}
                handleCreateResource={handleCreateResource}
                handleEditResource={handleEditResource}
                handleDeleteResource={handleDeleteResource}
                formatDate={formatDate}
                getResourceStatusBadge={getResourceStatusBadge}
              />
            )}

            {activeTab === "BuildingBlock" && (
              <ProjectBuildingBlockTab
                buildingBlocks={buildingBlocks}
                blocksLoading={blocksLoading}
                summaryLoading={summaryLoading}
                blockViewType={blockViewType}
                blockSummaries={blockSummaries}
                hasProjectAdminRole={hasProjectAdminRole}
                hasProjectManagerRole={hasProjectManagerRole}
                setBlockViewType={setBlockViewType}
                setShowBlockModal={setShowBlockModal}
                openMapModal={openMapModal}
                openBlockItemsModal={openBlockItemsModal}
                handleEditBlock={handleEditBlock}
                getUsernameFromId={getUsernameFromId}
              />
            )}

            {activeTab === "partner" && (
              <ProjectPartnerTab
                partners={partners}
                partnersLoading={partnersLoading}
                vendorMap={vendorMap}
                vendorContactsMap={vendorContactsMap}
                loadingVendorContacts={loadingVendorContacts}
                hasProjectAdminRole={hasProjectAdminRole}
                hasProjectManagerRole={hasProjectManagerRole}
                handleCreatePartner={handleCreatePartner}
                handleEditPartner={handleEditPartner}
              />
            )}

            {activeTab === "milestone" && (
              <ProjectMilestoneTab
                milestones={milestones}
                milestonesLoading={milestonesLoading}
                milestoneTasks={milestoneTasks}
                expandedMilestones={expandedMilestones}
                taskAssignedUsers={taskAssignedUsers}
                hasProjectAdminRole={hasProjectAdminRole}
                hasProjectManagerRole={hasProjectManagerRole}
                hasEditPermission={hasEditPermission}
                handleCreateMilestone={handleCreateMilestone}
                handleEditMilestone={handleEditMilestone}
                toggleMilestoneExpand={toggleMilestoneExpand}
                handleTaskNameClick={handleTaskNameClick}
                handleEditTask={handleEditTask}
                formatDate={formatDate}
                getStatusBadge={getStatusBadge}
                getPriorityBadge={getPriorityBadge}
              />
            )}

            {activeTab === "documents" && (
              <ProjectDocumentsTab
                documents={documents}
                documentsLoading={documentsLoading}
                showUploadModal={showUploadModal}
                setShowUploadModal={setShowUploadModal}
                documentTitle={documentTitle}
                setDocumentTitle={setDocumentTitle}
                documentType={documentType}
                setDocumentType={setDocumentType}
                selectedFiles={selectedFiles}
                uploadingDocuments={uploadingDocuments}
                handleFileSelect={handleFileSelect}
                handleUploadDocuments={handleUploadDocuments}
                handleDownloadDocument={handleDownloadDocument}
                handleDeleteDocument={handleDeleteDocument}
              />
            )}

            {activeTab === "budget" && (
              <div className="project-view-fade-in text-center py-5">
                <h4>Project Budget</h4>
                <p className="text-muted">
                  Budget management features coming soon...
                </p>
              </div>
            )}

            {activeTab === "settings" && (
              <div className="project-view-fade-in p-4">
                <h4>Project Settings</h4>

                <Form.Check
                  type="switch"
                  id="revenue-allowed"
                  label="Revenue Allowed for this Project"
                  checked={project?.revenue === true}
                  onChange={(e) =>
                    handleFieldChange("revenue", e.target.checked)
                  }
                />

                <small className="text-muted d-block mt-2">
                  Enable this if this project is allowed for revenue & invoicing
                </small>
              </div>
            )}
          </div>
        </div>
      </Container>

      {/* Task Edit Modal */}
      <TaskEditModal
        show={showEditModal}
        onHide={handleCloseEditModal}
        taskId={selectedTaskId}
        onTaskUpdated={handleTaskUpdated}
      />

      {/* Task View Sidebar */}
      <TaskViewSidebar
        show={showTaskSidebar}
        onHide={() => setShowTaskSidebar(false)}
        taskId={selectedTaskId}
        onTaskUpdated={() => {
          loadProjectTasks();
        }}
      />

      {/* Task Template Modal */}
      <TaskTemplateModal
        show={showTemplateModal}
        onHide={() => setShowTemplateModal(false)}
        template={selectedTemplate}
        orgId={orgId}
        onTemplateSaved={handleTemplateSaved}
      />

      {/* Partner Modal */}
      <PartnerModal
        show={showPartnerModal}
        onHide={handleClosePartnerModal}
        partner={editingPartner}
        orgId={orgId}
        projectId={projectId}
        onPartnerSaved={handlePartnerSaved}
      />

      {/* Stage Modal */}
      <StageModal
        show={showStageModal}
        onHide={handleCloseStageModal}
        stage={editingStage}
        orgId={orgId}
        projectId={projectId}
        onStageSaved={handleStageSaved}
      />

      {/* Commercial Modal */}
      <CommercialModal
        show={showCommercialModal}
        onHide={handleCloseCommercialModal}
        commercial={editingCommercial}
        projectId={projectId}
        onCommercialSaved={handleCommercialSaved}
      />

      {/* Milestone Modal */}
      <MilestoneModal
        show={showMilestoneModal}
        onHide={handleCloseMilestoneModal}
        milestone={editingMilestone}
        projectId={projectId}
        onMilestoneSaved={handleMilestoneSaved}
      />

      {/* Task Batch Creator Modal */}
      <TaskBatchCreator
        show={showBatchCreator}
        onHide={() => setShowBatchCreator(false)}
        projectId={project?.projectId}
        orgId={orgId}
        userId={userId}
        teamMembers={teamMemberDetails}
        onSuccess={(createdTasks) => {
          // Refresh tasks after successful creation
          loadProjectTasksByStages();
          toast.success(`Successfully created ${createdTasks.length} tasks`);
        }}
      />

      {/* Resource Modal */}
      <ResourceModal
        show={showResourceModal}
        onHide={handleCloseResourceModal}
        resource={editingResource}
        projectId={projectId}
        teamAssigned={project?.teamAssigned}
        onResourceSaved={handleResourceSaved}
      />

      {/* Ticket Edit Modal */}
      <TicketEditModal
        show={showTicketEditModal}
        onClose={handleCloseTicketEditModal}
        ticket={selectedTicketForEdit}
        orgId={orgId}
        userDetails={userDetails}
        projectOptions={[currentProjectOption]} // Pass only the current project
        ticketAssignees={teamMemberDetails.map((member) => ({
          value: member.userId,
          label: member.username,
        }))}
        assigneeOptionsByProject={{}}
        fetchProjectAndPartners={async (projectId) => {
          console.log("Fetch project and partners for:", projectId);
        }}
        refreshTickets={refreshTickets}
        currentProject={project} // Pass the current project object
        isProjectReadOnly={true} // Set to true when coming from Project View
      />

      {/* ======================= Ticket close modal ======================= */}

      {/* ======================= Ticket Dialog Modal ======================= */}
      <Modal
        show={showTicketDialog}
        onHide={closeTicketDialog}
        centered
        size="xl" // Changed from "md" to "xl" for wider modal
        dialogClassName="ticket-dialog-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Ticket: {ticketForDialog?.ticketId} •{" "}
            <span style={{ fontWeight: 400 }}>
              {ticketForDialog?.ticketName}
            </span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="ticket-dialog-body">
          <Row>
            {/* LEFT COLUMN - Ticket Details and Actions */}
            <Col md={7} className="ticket-dialog-left-col">
              {/* Important details */}
              <Card className="mb-3">
                <Card.Body>
                  <Row className="mb-2">
                    <Col xs={6}>
                      <small className="text-muted">Status</small>
                      <div>
                        <span
                          className={`ticket-status-badge ${getStatusBadge(
                            ticketForDialog?.status,
                          )}`}
                        >
                          {ticketForDialog?.status || "-"}
                        </span>
                      </div>
                    </Col>
                    <Col xs={6}>
                      <small className="text-muted">Priority</small>
                      <div
                        className={`project-view-ticket-priority-badge ${getPriorityBadge(
                          ticketForDialog?.priority,
                        )}`}
                      >
                        {ticketForDialog?.priority || "-"}
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <small className="text-muted">Created</small>
                      <div>{formatDateTime(ticketForDialog?.ticketTime)}</div>
                    </Col>
                    <Col xs={6}>
                      <small className="text-muted">Due</small>
                      <div>{formatDate(ticketForDialog?.dueDate)}</div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              {/* Building Blocks Section */}
              <Card className="mb-3">
                <Card.Header className="py-2">
                  <strong>Building Blocks</strong>
                </Card.Header>

                <Card.Body className="py-3">
                  {/* Already Assigned Blocks */}
                  {ticketBlocks.length === 0 ? (
                    <div className="text-muted mb-3">
                      Not assigned to any Building Block
                    </div>
                  ) : (
                    <div className="mb-3">
                      {ticketBlocks.map((block) => (
                        <Badge
                          key={block.buildingBlockId}
                          bg="info"
                          className="me-2 mb-2"
                        >
                          {block.buildingBlockName}
                        </Badge>
                      ))}
                    </div>
                  )}

                  {/* Add New Block */}
                  <Row className="g-2 align-items-end">
                    <Col xs={8}>
                      <Form.Select
                        value={selectedBlockId}
                        onChange={(e) => setSelectedBlockId(e.target.value)}
                        disabled={blockMappingLoading}
                      >
                        <option value="">Select Building Block...</option>

                        {availableBlocksForMapping.length === 0 ? (
                          <option disabled>No available blocks</option>
                        ) : (
                          availableBlocksForMapping.map((block) => (
                            <option
                              key={block.buildingBlockId}
                              value={block.buildingBlockId}
                            >
                              {block.buildingBlockName}
                            </option>
                          ))
                        )}
                      </Form.Select>
                    </Col>

                    <Col xs={4}>
                      <Button
                        variant="primary"
                        className="w-100"
                        onClick={handleMapTicketToBlock}
                        disabled={blockMappingLoading}
                      >
                        {blockMappingLoading ? "Adding..." : "Add"}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card className="mb-3">
                <Card.Header className="py-2">
                  <strong>Assigned Building Blocks</strong>
                </Card.Header>

                <Card.Body className="py-2">
                  {ticketBlocks.length === 0 ? (
                    <div className="text-muted">
                      No building blocks assigned
                    </div>
                  ) : (
                    <ul className="list-group">
                      {ticketBlocks.map((block) => (
                        <li
                          key={block.buildingBlockId}
                          className="list-group-item d-flex justify-content-between align-items-center"
                        >
                          <span>{block.buildingBlockName}</span>

                          <Button
                            variant="outline-danger"
                            size="sm"
                            onClick={() =>
                              handleRemoveBlockMapping(block.buildingBlockId)
                            }
                          >
                            Remove
                          </Button>
                        </li>
                      ))}
                    </ul>
                  )}
                </Card.Body>
              </Card>

              {/* Add Work Log Section */}
              <Card className="mb-3">
                <Card.Header className="py-2">
                  <strong>Add Work Log</strong>
                </Card.Header>

                <Card.Body className="py-3">
                  <Row className="g-2 align-items-end">
                    <Col xs={5}>
                      <Form.Select
                        value={ticketWorkUserId}
                        onChange={(e) => setTicketWorkUserId(e.target.value)}
                      >
                        <option value="">Select member</option>
                        {teamMemberDetails.map((u) => (
                          <option key={u.userId} value={u.userId}>
                            {u.username}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>

                    <Col xs={4}>
                      <Form.Control
                        type="number"
                        step="0.25"
                        min="0"
                        placeholder="Hours"
                        value={ticketWorkValue}
                        onChange={(e) => setTicketWorkValue(e.target.value)}
                      />
                    </Col>

                    <Col xs={3}>
                      <Button
                        variant="primary"
                        className="w-100"
                        disabled={savingTicketWorkLog}
                        onClick={handleSaveTicketWorkLog}
                      >
                        {savingTicketWorkLog ? "Saving..." : "Add"}
                      </Button>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>
            </Col>

            {/* RIGHT COLUMN - Work & Activity Logs */}
            <Col md={5} className="ticket-dialog-right-col">
              <Card className="h-100">
                <Card.Header className="py-2">
                  <strong>Work & Activity Logs</strong>
                  {ticketLogsLoading && (
                    <span className="text-muted ms-2" style={{ fontSize: 12 }}>
                      loading...
                    </span>
                  )}
                </Card.Header>

                <Card.Body className="py-2 ticket-logs-container">
                  {ticketLogsLoading ? (
                    <div className="text-center py-4 text-muted">
                      Loading logs...
                    </div>
                  ) : ticketLogs.length === 0 ? (
                    <div className="text-center py-4 text-muted">
                      No logs yet
                    </div>
                  ) : (
                    <div className="table-responsive">
                      <table className="table table-sm table-hover mb-0 ticket-logs-table">
                        <thead className="table-light">
                          <tr>
                            <th>Type</th>
                            <th>User</th>
                            <th>Hours</th>
                            <th>Date</th>
                            <th>Remarks</th>
                          </tr>
                        </thead>
                        <tbody>
                          {ticketLogs.map((log) => (
                            <tr key={log.ticketLogGuid}>
                              <td>
                                <Badge
                                  bg={
                                    log.actionType === "WORK_LOG"
                                      ? "info"
                                      : "secondary"
                                  }
                                  className="log-type-badge"
                                >
                                  {log.actionType?.replace(/_/g, " ") || "N/A"}
                                </Badge>
                              </td>
                              <td className="log-user-cell">
                                <small>
                                  {resolveContactName(log.changedBy) ||
                                    log.changedBy ||
                                    "-"}
                                </small>
                              </td>
                              <td className="log-hours-cell">
                                <small>
                                  {log.effortValue
                                    ? `${log.effortValue} ${log.effortUnit}`
                                    : "-"}
                                </small>
                              </td>
                              <td className="log-date-cell">
                                <small>
                                  {log.createdDate
                                    ? moment(log.createdDate).format(
                                        "MMM DD, HH:mm",
                                      )
                                    : "-"}
                                </small>
                              </td>
                              <td className="log-remarks-cell">
                                <small className="text-muted">
                                  {log.closureRemarks || "-"}
                                </small>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeTicketDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= TASK ASSIGNMENT DIALOG ======================= */}
      {/* ======================= TASK ASSIGNMENT DIALOG ======================= */}
      <Modal
        show={showTaskDialog}
        onHide={closeTaskDialog}
        centered
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>Manage Task Assignment</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {taskForDialog ? (
            <>
              <h5>{taskForDialog.taskName}</h5>
              <p className="text-muted">
                {taskForDialog.taskDescription || "No description"}
              </p>

              <div className="mb-3">
                <strong>Planned:</strong>{" "}
                {formatDate(taskForDialog.taskStartDate)} →{" "}
                {formatDate(taskForDialog.taskEndDate)}
              </div>

              {/* Assign Team Member Section - Only Admins/Managers can assign to anyone */}
              {/* Assign Team Member Section - Only Admins/Managers can assign to anyone */}
              <Form.Group className="mb-3">
                <Form.Label>Assign To</Form.Label>
                {loadingProjectAssignees || loadingContacts ? (
                  <div className="text-center py-2">
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    >
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <span className="ms-2">Loading assignees...</span>
                  </div>
                ) : (
                  <Form.Select
                    value={assignTaskUserId}
                    onChange={(e) => setAssignTaskUserId(e.target.value)}
                    disabled={
                      taskAssignLoading || projectAssigneeOptions.length === 0
                    }
                  >
                    <option value="">
                      {projectAssigneeOptions.length === 0
                        ? "No assignees available for this project"
                        : "Select Assignee"}
                    </option>
                    {getAllAssigneeOptions().map((option) => (
                      <option key={option.value} value={option.value}>
                        {option.label}
                      </option>
                    ))}
                  </Form.Select>
                )}
                <Form.Text className="text-muted" style={{ fontSize: "11px" }}>
                  {!loadingProjectAssignees && projectAssigneeOptions.length > 0
                    ? `Available assignees: ${projectAssigneeOptions.length} total (${projectAssigneeOptions.filter((o) => o.type === "team").length} team members, ${projectAssigneeOptions.filter((o) => o.type === "client").length} client contacts, ${projectAssigneeOptions.filter((o) => o.type === "partner").length} partner contacts)`
                    : !loadingProjectAssignees &&
                        projectAssigneeOptions.length === 0
                      ? "No assignees available. Please ensure the project has team members, customers, or partners."
                      : "Loading assignees..."}
                </Form.Text>
              </Form.Group>

              <div className="d-flex gap-2 justify-content-end">
                <Button
                  variant="secondary"
                  size="sm"
                  onClick={handleAssignUserOnly}
                  disabled={taskAssignLoading || !assignTaskUserId}
                >
                  Assign
                </Button>
              </div>

              <hr />

              <h6>Assignment History</h6>
              {taskAssignLoading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary" />
                </div>
              ) : taskAssignments.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Start Time</th>
                        <th>End Time</th>
                        <th>Total Hours</th>
                        <th>Status</th>
                        <th>Current</th>{" "}
                        {/* New column for current assignment */}
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskAssignments.map((assign) => {
                        const userName = getUsernameFromId(
                          assign.assignedUserId,
                        );
                        const isCurrentUser =
                          String(assign.assignedUserId) === String(userId);

                        return (
                          <tr key={assign.assignmentId}>
                            <td>{userName}</td>
                            <td>{formatDateTime(assign.startTime)}</td>
                            <td>
                              {formatDateTime(assign.endTime) || "Ongoing"}
                            </td>
                            <td>{fmtHours(assign.totalHours)}</td>
                            <td>
                              <Badge
                                bg={
                                  assign.isPaused
                                    ? "warning"
                                    : assign.isActive
                                      ? "success"
                                      : "secondary"
                                }
                              >
                                {assign.isPaused
                                  ? "Paused"
                                  : assign.isActive
                                    ? "Active"
                                    : "Not Started"}
                              </Badge>
                            </td>
                            {/* Current Assignment Checkbox Column */}
                            <td className="text-center">
                              <Form.Check
                                type="checkbox"
                                checked={assign.isCurrentAssignment === true}
                                disabled={!hasEditPermission()} // Only admins/managers can change
                                onChange={async (e) => {
                                  if (!hasEditPermission()) {
                                    toast.error(
                                      "You don't have permission to change current assignment",
                                    );
                                    return;
                                  }
                                  try {
                                    await toggleCurrentAssignment(
                                      assign.assignmentId,
                                    );
                                    toast.success(
                                      assign.isCurrentAssignment
                                        ? "Removed from current assignment"
                                        : "Set as current assignment",
                                    );
                                    await refreshTaskAssignments(
                                      taskForDialog.taskId,
                                    );
                                  } catch (error) {
                                    console.error(
                                      "Error toggling current assignment:",
                                      error,
                                    );
                                    toast.error(
                                      error.message ||
                                        "Failed to update current assignment",
                                    );
                                  }
                                }}
                                title={
                                  hasEditPermission()
                                    ? assign.isCurrentAssignment
                                      ? "Click to remove from current assignment"
                                      : "Click to set as current assignment"
                                    : "Only Admins/Managers can change current assignment"
                                }
                              />
                            </td>
                            <td>
                              {/* Start Button - Only show for current user or admin/manager */}
                              {isNotStarted(assign) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="success"
                                    onClick={async () => {
                                      await startTaskWork(
                                        taskForDialog.taskId,
                                        assign.assignedUserId,
                                        orgId,
                                      );
                                      toast.success("Work started");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Start
                                  </Button>
                                )}

                              {/* Pause Button - Only show for current user or admin/manager */}
                              {isActive(assign) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="warning"
                                    onClick={async () => {
                                      await pauseTaskWork(assign.assignmentId);
                                      toast.info("Work paused");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Pause
                                  </Button>
                                )}

                              {/* Resume Button - Only show for current user or admin/manager */}
                              {isPaused(assign) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="success"
                                    onClick={async () => {
                                      await startTaskWork(
                                        taskForDialog.taskId,
                                        assign.assignedUserId,
                                        orgId,
                                      );
                                      toast.success("Work resumed");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Resume
                                  </Button>
                                )}

                              {/* Stop Button - Only show for current user or admin/manager */}
                              {(isActive(assign) || isPaused(assign)) &&
                                (hasEditPermission() || isCurrentUser) && (
                                  <Button
                                    size="sm"
                                    variant="danger"
                                    className="ms-2"
                                    onClick={async () => {
                                      await stopTaskWork(assign.assignmentId);
                                      toast.success("Work stopped");
                                      await refreshTaskAssignments(
                                        taskForDialog.taskId,
                                      );
                                    }}
                                  >
                                    Stop
                                  </Button>
                                )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">
                  No assignment history found for this task.
                </p>
              )}

              <hr />

              {/* Add Manual Work Log Section */}
              <h6>Add Manual Work Log</h6>

              <Row className="align-items-end">
                <Col md={4}>
                  <Form.Group>
                    <Form.Label>User</Form.Label>
                    {loadingProjectAssignees || loadingContacts ? (
                      <Form.Control
                        type="text"
                        disabled
                        value="Loading users..."
                        className="bg-light"
                      />
                    ) : (
                      <Form.Select
                        value={workLogUserId}
                        onChange={(e) => setWorkLogUserId(e.target.value)}
                        disabled={projectAssigneeOptions.length === 0}
                      >
                        <option value="">
                          {projectAssigneeOptions.length === 0
                            ? "No users available"
                            : "Select user"}
                        </option>
                        {getAllAssigneeOptions().map((option) => {
                          // Check if user can add work log for this user
                          let canSelect = false;
                          const isCurrentUser =
                            String(option.value) === String(userId);

                          if (hasEditPermission()) {
                            // Admins/Managers can add work log for anyone
                            canSelect = true;
                          } else if (hasProjectCommercialRole()) {
                            // Commercial can only add work log for themselves
                            canSelect = isCurrentUser;
                          } else {
                            // Regular users can only add work log for themselves
                            canSelect = isCurrentUser;
                          }

                          // Also check if this is a client or partner contact - only admins/managers can add work logs for them
                          if (
                            (option.type === "client" ||
                              option.type === "partner") &&
                            !hasEditPermission()
                          ) {
                            canSelect = false;
                          }

                          return (
                            <option
                              key={option.value}
                              value={option.value}
                              disabled={!canSelect}
                            >
                              {option.label}{" "}
                              {!canSelect && "(Cannot add work log)"}
                            </option>
                          );
                        })}
                      </Form.Select>
                    )}
                    <Form.Text
                      className="text-muted"
                      style={{ fontSize: "11px" }}
                    >
                      {!loadingProjectAssignees &&
                      projectAssigneeOptions.length > 0
                        ? `Available: ${
                            projectAssigneeOptions.filter((o) => {
                              if (hasEditPermission()) return true;
                              if (hasProjectCommercialRole())
                                return String(o.value) === String(userId);
                              return String(o.value) === String(userId);
                            }).length
                          } users (team: ${projectAssigneeOptions.filter((o) => o.type === "team" && (hasEditPermission() || String(o.value) === String(userId))).length}, 
          client: ${projectAssigneeOptions.filter((o) => o.type === "client" && hasEditPermission()).length}, 
          partner: ${projectAssigneeOptions.filter((o) => o.type === "partner" && hasEditPermission()).length})`
                        : "No users available"}
                    </Form.Text>
                    {!hasEditPermission() && !hasProjectCommercialRole() && (
                      <Form.Text className="text-muted d-block">
                        You can only add work log for yourself
                      </Form.Text>
                    )}
                    {hasProjectCommercialRole() && !hasEditPermission() && (
                      <Form.Text className="text-muted d-block">
                        Commercial role: You can only add work log for yourself
                      </Form.Text>
                    )}
                    {hasEditPermission() && (
                      <Form.Text className="text-muted d-block">
                        Admin/Manager: You can add work log for any team member,
                        client contact, or partner contact
                      </Form.Text>
                    )}
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Work</Form.Label>
                    <Form.Control
                      type="number"
                      min="0"
                      step="0.25"
                      value={workValue}
                      onChange={(e) => setWorkValue(e.target.value)}
                      placeholder="e.g. 2.5"
                    />
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group>
                    <Form.Label>Unit</Form.Label>
                    <Form.Select
                      value={workUnit}
                      onChange={(e) => setWorkUnit(e.target.value)}
                    >
                      <option value="HOUR">Hour(s)</option>
                      <option value="DAY">Day(s)</option>
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col md={2}>
                  <Button
                    variant="primary"
                    size="sm"
                    disabled={savingWorkLog || !workLogUserId || !workValue}
                    onClick={handleSaveWorkLog}
                  >
                    {savingWorkLog ? "Saving..." : "Add"}
                  </Button>
                </Col>
              </Row>

              <hr />

              <h6>Task Log History</h6>

              {taskLogsLoading ? (
                <div className="text-center py-3">
                  <div className="spinner-border spinner-border-sm text-primary" />
                </div>
              ) : taskLogs.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-bordered table-sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Work</th>
                        <th>Type</th>
                        <th>Description</th>
                        <th>Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskLogs.map((log) => {
                        const userName = getUsernameFromId(
                          log.assignedUserId || log.createdBy,
                        );

                        return (
                          <tr key={log.taskLogId}>
                            <td>{userName}</td>
                            <td>
                              {log.workValue
                                ? `${log.workValue} ${log.workUnit}`
                                : "-"}
                            </td>
                            <td>
                              <Badge bg="info">{log.logType}</Badge>
                            </td>
                            <td>{log.logDescription || "-"}</td>
                            <td>
                              {moment(log.createdDate).format("MMM DD, YYYY")}{" "}
                              {moment(log.createdTime, "HH:mm:ss").format(
                                "hh:mm A",
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <p className="text-muted">No task logs found.</p>
              )}
            </>
          ) : (
            <div className="text-center text-muted">No task selected</div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeTaskDialog}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Excel Upload Modal */}
      <Modal
        show={showExcelUploadModal}
        onHide={handleCloseExcelUploadModal}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-file-excel me-2 text-success"></i>
            Upload Tasks from Excel
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="excel-upload-container">
            <div className="mb-4">
              <h5>Instructions:</h5>
              <ul className="small">
                <li>Download the template to see the required format</li>
                <li>Supported formats: .xlsx, .xls, .csv</li>
                <li>
                  Required columns: taskName, taskDescription, assignedTo,
                  taskStartDate, taskEndDate
                </li>
                <li>Optional columns: taskPriority, taskStatus, taskType</li>
                <li>Dates should be in YYYY-MM-DD format</li>
              </ul>
            </div>

            <div className="mb-4">
              <Button
                variant="outline-success"
                onClick={handleDownloadTemplate}
                className="mb-3"
              >
                <i className="fas fa-download me-2"></i>
                Download Excel Template
              </Button>
            </div>

            <Form.Group className="mb-4">
              <Form.Label>Select Excel File:</Form.Label>
              <Form.Control
                type="file"
                accept=".xlsx,.xls,.csv"
                onChange={handleExcelFileSelect}
              />
              <Form.Text className="text-muted">
                {excelFile ? `Selected: ${excelFile.name}` : "No file selected"}
              </Form.Text>
            </Form.Group>

            <div className="upload-info-card p-3 bg-light rounded">
              <h6 className="mb-2">Upload Information:</h6>
              <div className="row">
                <div className="col-md-6">
                  <small>
                    <strong>Organization ID:</strong> {orgId}
                  </small>
                </div>
                <div className="col-md-6">
                  <small>
                    <strong>Project ID:</strong> {project?.projectId}
                  </small>
                </div>
              </div>
              <div className="row mt-2">
                <div className="col-md-12">
                  <small>
                    <strong>Project:</strong> {project?.prTitle}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={handleCloseExcelUploadModal}
            disabled={uploadingExcel}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            onClick={handleExcelUpload}
            disabled={!excelFile || uploadingExcel}
          >
            {uploadingExcel ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                  aria-hidden="true"
                ></span>
                Uploading...
              </>
            ) : (
              <>
                <i className="fas fa-upload me-2"></i>
                Upload & Create Tasks
              </>
            )}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= Building block create ======================= */}

      {/* ======================= Building block create ======================= */}
      {(hasProjectAdminRole() || hasProjectManagerRole()) && (
        <Modal
          show={showBlockModal}
          onHide={() => {
            setShowBlockModal(false);
            resetBlockForm();
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {isEditingBlock ? "Edit Building Block" : "Create Building Block"}
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Building Block Name *</Form.Label>
                  <Form.Control
                    type="text"
                    value={blockForm.buildingBlockName}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockName", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Status</Form.Label>
                  <Form.Select
                    value={blockForm.buildingBlockStatus}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockStatus", e.target.value)
                    }
                  >
                    {BUILDING_BLOCK_STATUS_OPTIONS.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>Description</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    value={blockForm.buildingBlockDescription}
                    onChange={(e) =>
                      handleBlockChange(
                        "buildingBlockDescription",
                        e.target.value,
                      )
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Process POC</Form.Label>
                  <Form.Select
                    value={blockForm.buildingBlockProcessPoc || ""}
                    onChange={(e) =>
                      handleBlockChange(
                        "buildingBlockProcessPoc",
                        e.target.value,
                      )
                    }
                  >
                    <option value="">Select Process POC</option>
                    {teamMemberDetails.map((member) => (
                      <option key={member.userId} value={member.userId}>
                        {member.username}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Tech POC</Form.Label>
                  <Form.Select
                    value={blockForm.buildingBlockTechPoc || ""}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockTechPoc", e.target.value)
                    }
                  >
                    <option value="">Select Tech POC</option>
                    {teamMemberDetails.map((member) => (
                      <option key={member.userId} value={member.userId}>
                        {member.username}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>
              </Col>

              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Type</Form.Label>
                  <Form.Control
                    type="text"
                    value={blockForm.buildingBlockTypes}
                    onChange={(e) =>
                      handleBlockChange("buildingBlockTypes", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={blockForm.actualStartDate}
                    onChange={(e) =>
                      handleBlockChange("actualStartDate", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>

              <Col md={3}>
                <Form.Group className="mb-3">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={blockForm.actualEndDate}
                    onChange={(e) =>
                      handleBlockChange("actualEndDate", e.target.value)
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                setShowBlockModal(false);
                resetBlockForm();
              }}
            >
              Cancel
            </Button>

            <Button onClick={handleSaveBlock}>
              {isEditingBlock ? "Update" : "Create"}
            </Button>
          </Modal.Footer>
        </Modal>
      )}

      {/* ======================= TASK Map Modal ======================= */}
      <Modal
        show={showTaskMapModal}
        onHide={() => setShowTaskMapModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Add {blockViewType === "TASK" ? "Tasks" : "Tickets"} to{" "}
            {selectedBlock?.buildingBlockName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {projectTasksForMapping.length === 0 ? (
            <p>No tasks available for this project.</p>
          ) : (
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Select</th>
                    <th>Task ID</th>
                    <th>Name</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {projectTasksForMapping.map((item) => (
                    <tr
                      key={
                        blockViewType === "TASK" ? item.taskId : item.ticketId
                      }
                    >
                      <td>
                        <Form.Check
                          type="checkbox"
                          checked={selectedTaskIds.includes(
                            blockViewType === "TASK"
                              ? item.taskId
                              : item.ticketId,
                          )}
                          onChange={() =>
                            handleTaskSelection(
                              blockViewType === "TASK"
                                ? item.taskId
                                : item.ticketId,
                            )
                          }
                        />
                      </td>

                      <td>
                        {blockViewType === "TASK" ? item.taskId : item.ticketId}
                      </td>

                      <td>
                        {blockViewType === "TASK"
                          ? item.taskName
                          : item.ticketName}
                      </td>

                      <td>
                        {blockViewType === "TASK"
                          ? item.taskStatus
                          : item.status}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowTaskMapModal(false)}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={handleMapTasks}
            disabled={mappingLoading}
          >
            {mappingLoading ? "Saving..." : "Save"}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* ======================= block block modal ======================= */}
      <Modal
        show={showBlockTasksModal}
        onHide={() => setShowBlockTasksModal(false)}
        size="lg"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {blockViewType === "TASK" ? "Tasks" : "Tickets"} -{" "}
            {selectedBlock?.buildingBlockName}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {blockTasks.length === 0 ? (
            <p>No {blockViewType === "TASK" ? "tasks" : "tickets"} mapped.</p>
          ) : (
            <div className="table-responsive">
              <table className="table table-bordered table-hover align-middle">
                <thead className="table-dark">
                  <tr>
                    <th>#</th>

                    {/* 🔥 THIS IS WHERE YOUR LINE GOES */}
                    <th>
                      {blockViewType === "TASK" ? "Task ID" : "Ticket ID"}
                    </th>

                    <th>Name</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {blockTasks.map((item, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>

                      {blockViewType === "TASK" ? (
                        <>
                          <td>{item.taskId}</td>
                          <td>{item.taskName}</td>
                          <td>{item.taskStatus}</td>
                        </>
                      ) : (
                        <>
                          <td>{item.ticketId}</td>
                          <td>{item.ticketName}</td>
                          <td>{item.ticketStatus}</td>
                        </>
                      )}

                      <td>
                        <Button
                          size="sm"
                          variant="danger"
                          onClick={() =>
                            handleRemoveItemFromBlock(
                              blockViewType === "TASK"
                                ? item.taskId
                                : item.ticketId,
                            )
                          }
                        >
                          Remove
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setShowBlockTasksModal(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ProjectView;
